import { AVAILABLE_FONTS, getFontFamilyCss } from '../../utils/fontHelper';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useWebStore } from '../../context/WebStoreContext';
import UnifiedBannersAdminSection from '../common/UnifiedBannersAdminSection';
import { DEFAULT_UNIFIED_BANNERS, DEFAULT_SECONDARY_BANNERS } from '../common/UnifiedHeroBanner';
import { DEFAULT_SECONDARY_NAVBAR } from '../common/UnifiedHeader';
import { DEFAULT_FAQ_SECTION } from './FaqPage';
import { SecondaryNavBarAdminPanel, BestSellersAdminCard, FaqAdminPanel } from './ModularMenusAndFaqAdmin';
import { BenefitsAdminPanel, DEFAULT_BENEFITS_PRIMARY, DEFAULT_BENEFITS_SECONDARY, DEFAULT_BENEFITS_SETTINGS, normalizeBenefitsList } from './BenefitsAdminPanel';
import EcommerceProductDetail from '../ecommerce/EcommerceProductDetail';
import { getCandidateUrlsForImage, getArticleImageSlides, getImageCandidateUrls } from '../../utils/imageHelper';
import { resetSystemTheme } from '../../utils/ecommerceHelper';

const COLOR_PRESETS = [
  {
    name: 'Azul Hiperpel (Original)',
    primaryColor: '#0d6efd',
    secondaryColor: '#0a58ca',
    accentColor: '#ff6b35',
    buttonColor: '#ffc107',
    buttonPrimaryText: '#111827',
    buttonSecondaryBg: '#f8fafc',
    buttonSecondaryText: '#1e293b',
    textColor: '#1e293b',
    pageBg: '#f8fafc',
    cardBg: '#ffffff',
    borderColor: '#e2e8f0',
    borderRadius: '12px',
    topBarBg: '#0f172a',
    topBarText: '#ffffff',
    navbarBg: '#ffffff',
    headerText: '#1e293b',
    headerBorder: '#e2e8f0',
    footerBg: '#1e293b',
    footerTextColor: '#94a3b8',
    footerTitleColor: '#ffffff',
    footerBorderColor: '#334155'
  },
  {
    name: 'Verde Ecológico / Sustentable',
    primaryColor: '#059669',
    secondaryColor: '#047857',
    accentColor: '#f59e0b',
    buttonColor: '#10b981',
    buttonPrimaryText: '#ffffff',
    buttonSecondaryBg: '#f0fdf4',
    buttonSecondaryText: '#065f46',
    textColor: '#1e293b',
    pageBg: '#f0fdf4',
    cardBg: '#ffffff',
    borderColor: '#bbf7d0',
    borderRadius: '12px',
    topBarBg: '#064e3b',
    topBarText: '#ecfdf5',
    navbarBg: '#ffffff',
    headerText: '#064e3b',
    headerBorder: '#bbf7d0',
    footerBg: '#064e3b',
    footerTextColor: '#a7f3d0',
    footerTitleColor: '#ffffff',
    footerBorderColor: '#047857'
  },
  {
    name: 'Kraft & Packaging Cálido',
    primaryColor: '#b45309',
    secondaryColor: '#92400e',
    accentColor: '#d97706',
    buttonColor: '#f59e0b',
    buttonPrimaryText: '#ffffff',
    buttonSecondaryBg: '#fffbeb',
    buttonSecondaryText: '#78350f',
    textColor: '#292524',
    pageBg: '#fafaf9',
    cardBg: '#ffffff',
    borderColor: '#e7e5e4',
    borderRadius: '14px',
    topBarBg: '#292524',
    topBarText: '#f5f5f4',
    navbarBg: '#ffffff',
    headerText: '#292524',
    headerBorder: '#e7e5e4',
    footerBg: '#292524',
    footerTextColor: '#a8a29e',
    footerTitleColor: '#fafaf9',
    footerBorderColor: '#44403c'
  },
  {
    name: 'Dark Elegance Moderna',
    primaryColor: '#38bdf8',
    secondaryColor: '#0284c7',
    accentColor: '#f43f5e',
    buttonColor: '#38bdf8',
    buttonPrimaryText: '#0f172a',
    buttonSecondaryBg: '#1e293b',
    buttonSecondaryText: '#f8fafc',
    textColor: '#f1f5f9',
    pageBg: '#0f172a',
    cardBg: '#1e293b',
    borderColor: '#334155',
    borderRadius: '16px',
    topBarBg: '#020617',
    topBarText: '#94a3b8',
    navbarBg: '#0f172a',
    headerText: '#f8fafc',
    headerBorder: '#334155',
    footerBg: '#020617',
    footerTextColor: '#94a3b8',
    footerTitleColor: '#f8fafc',
    footerBorderColor: '#1e293b'
  },
  {
    name: 'Rojo Corporativo / Retail',
    primaryColor: '#dc2626',
    secondaryColor: '#b91c1c',
    accentColor: '#f97316',
    buttonColor: '#ef4444',
    buttonPrimaryText: '#ffffff',
    buttonSecondaryBg: '#fef2f2',
    buttonSecondaryText: '#991b1b',
    textColor: '#1f2937',
    pageBg: '#fef2f2',
    cardBg: '#ffffff',
    borderColor: '#fecaca',
    borderRadius: '12px',
    topBarBg: '#18181b',
    topBarText: '#ffffff',
    navbarBg: '#ffffff',
    headerText: '#18181b',
    headerBorder: '#fecaca',
    footerBg: '#18181b',
    footerTextColor: '#a1a1aa',
    footerTitleColor: '#ffffff',
    footerBorderColor: '#27272a'
  },
  {
    name: 'Violeta Tecnológico / Moderno',
    primaryColor: '#7c3aed',
    secondaryColor: '#6d28d9',
    accentColor: '#06b6d4',
    buttonColor: '#8b5cf6',
    buttonPrimaryText: '#ffffff',
    buttonSecondaryBg: '#f5f3ff',
    buttonSecondaryText: '#5b21b6',
    textColor: '#1e1b4b',
    pageBg: '#faf5ff',
    cardBg: '#ffffff',
    borderColor: '#ddd6fe',
    borderRadius: '14px',
    topBarBg: '#2e1065',
    topBarText: '#f5f3ff',
    navbarBg: '#ffffff',
    headerText: '#1e1b4b',
    headerBorder: '#ddd6fe',
    footerBg: '#2e1065',
    footerTextColor: '#c4b5fd',
    footerTitleColor: '#ffffff',
    footerBorderColor: '#4c1d95'
  }
];

export const ADMIN_MODULE_TABS = [
  // --- GRUPO 1: INICIO & TIENDA ---
  {
    id: 'sections',
    num: 1,
    group: 'home',
    label: '1. Orden del Inicio (Secciones)',
    shortLabel: '1. Orden Inicio',
    icon: 'bi-diagram-3-fill',
    badge: 'Inicio'
  },
  {
    id: 'hero',
    num: 2,
    group: 'home',
    label: '2. Identidad, Logo, Menús & Banners (Web & Tienda)',
    shortLabel: '2. Menús & Banners',
    icon: 'bi-images',
    badge: 'Inicio'
  },
  {
    id: 'benefits',
    num: 3,
    group: 'home',
    label: '3. Barra de Pilares & Beneficios',
    shortLabel: '3. Pilares',
    icon: 'bi-shield-check',
    badge: 'Inicio'
  },
  {
    id: 'shortcuts',
    num: 4,
    group: 'home',
    label: '4. Cards de Rubros',
    shortLabel: '4. Rubros',
    icon: 'bi-grid-fill',
    badge: 'Inicio'
  },
  {
    id: 'featured',
    num: 5,
    group: 'home',
    label: '5. Más Vendidos, Destacados & Promos',
    shortLabel: '5. Más Vendidos & Destacados',
    icon: 'bi-star-fill',
    badge: 'Inicio'
  },
  {
    id: 'secondaryBanner',
    num: 6,
    group: 'home',
    label: '6. Banners Secundarios (Envíos & Servicios)',
    shortLabel: '6. Banners Secundarios',
    icon: 'bi-truck',
    badge: 'Inicio'
  },
  {
    id: 'about',
    num: 7,
    group: 'home',
    label: '7. Institucional / Empresa (Home y /empresa)',
    shortLabel: '7. Empresa',
    icon: 'bi-building',
    badge: 'Inicio'
  },
  // --- GRUPO 2: PÁGINAS Y CONTACTO ---
  {
    id: 'contact',
    num: 8,
    group: 'pages',
    label: '8. Contacto & TopBar',
    shortLabel: '8. Contacto',
    icon: 'bi-telephone-fill',
    badge: 'Web'
  },
  {
    id: 'novedades',
    num: 9,
    group: 'pages',
    label: '9. Novedades & Ofertas (/novedades)',
    shortLabel: '9. Novedades',
    icon: 'bi-megaphone-fill',
    badge: 'Página'
  },
  {
    id: 'location',
    num: 10,
    group: 'pages',
    label: '10. Dónde Estamos (/donde-estamos)',
    shortLabel: '10. Dónde Estamos',
    icon: 'bi-geo-alt-fill',
    badge: 'Página'
  },
  {
    id: 'downloads',
    num: 11,
    group: 'pages',
    label: '11. Descargas (/descargas)',
    shortLabel: '11. Descargas',
    icon: 'bi-cloud-arrow-down-fill',
    badge: 'Página'
  },
  {
    id: 'faq',
    num: 12,
    group: 'pages',
    label: '12. Preguntas Frecuentes (/preguntas-frecuentes)',
    shortLabel: '12. Preguntas Frecuentes',
    icon: 'bi-patch-question-fill',
    badge: 'Página'
  },
  // --- GRUPO 3: DISEÑO Y APARIENCIA ---
  {
    id: 'theme',
    num: 13,
    group: 'design',
    label: '13. Colores, Fondos y Estilos',
    shortLabel: '13. Colores & Estilos',
    icon: 'bi-palette-fill',
    badge: 'Diseño'
  }
];

export const DEFAULT_HOME_SECTIONS = [
  { id: 'hero', name: 'Banners Principales (Hero Slider)', icon: 'bi-images', tabKey: 'hero', description: 'Carrusel principal con imágenes de portada y promociones', enabled: true },
  { id: 'benefits', name: 'Barra de Beneficios (Pilares 1)', icon: 'bi-shield-check', tabKey: 'benefits', description: '4 pilares comerciales (Envíos, Fábrica directa, Mayorista/Minorista, WhatsApp)', enabled: true },
  { id: 'categoryShortcuts', name: 'Líneas de Productos Destacadas', icon: 'bi-grid-3x3-gap-fill', tabKey: 'shortcuts', description: 'Tarjetas fotográficas con accesos rápidos a rubros principales', enabled: true },
  { id: 'bestSellers', name: '¡Los Más Vendidos! (Grilla Especial)', icon: 'bi-fire', tabKey: 'featured', description: 'Sección destacada de productos más vendidos (manual, por rubros o destacados)', enabled: false },
  { id: 'featuredProducts', name: 'Artículos Destacados / Catálogo', icon: 'bi-star-fill', tabKey: 'featured', description: 'Grilla de productos más solicitados con compra directa', enabled: true },
  { id: 'benefitsSecondary', name: 'Segunda Barra de Pilares (Pilares 2)', icon: 'bi-shield-plus', tabKey: 'benefits', description: 'Segunda barra de pilares y diferenciales comerciales para ubicar más abajo', enabled: false },
  { id: 'secondaryBanner', name: 'Banners Secundarios (Envíos & Servicios)', icon: 'bi-truck', tabKey: 'secondaryBanner', description: 'Banner fotográfico intermedio para destacar envíos a todo el país, logística o servicios con fotos y texto', enabled: true },
  { id: 'promoBanners', name: 'Banners de Oportunidades', icon: 'bi-tag-fill', tabKey: 'featured', description: 'Banners dobles para promociones especiales y líneas de temporada', enabled: true },
  { id: 'institutional', name: 'Institucional / Sobre la Empresa', icon: 'bi-building-check', tabKey: 'about', description: 'Teaser institucional de planta industrial y trayectoria', enabled: true },
  { id: 'faq', name: 'Preguntas Frecuentes (Acordeón en Portada)', icon: 'bi-patch-question-fill', tabKey: 'faq', description: 'Bloque de consultas frecuentes desplegables y contacto directo por WhatsApp', enabled: false }
];

export const DEFAULT_NAVBAR_ITEMS = [
  { id: 'home', label: 'INICIO', path: '/', description: 'Página principal de la tienda', icon: 'bi-house-door', enabled: true },
  { id: 'tienda', label: 'TIENDA', path: '/tienda', description: 'Catálogo de productos y compra online', icon: 'bi-shop', enabled: true },
  { id: 'novedades', label: 'NOVEDADES', path: '/novedades', description: 'Lanzamientos y ofertas especiales', icon: 'bi-megaphone', enabled: true },
  { id: 'descargas', label: 'DESCARGAS', path: '/descargas', description: 'Catálogos y listas de precios en PDF', icon: 'bi-cloud-arrow-down', enabled: true },
  { id: 'empresa', label: 'EMPRESA', path: '/empresa', description: 'Historia y planta industrial', icon: 'bi-building', enabled: true },
  { id: 'donde-estamos', label: 'DONDE ESTAMOS', path: '/donde-estamos', description: 'Ubicación de fábrica y sucursales', icon: 'bi-geo-alt', enabled: true },
  { id: 'faq', label: 'PREGUNTAS FRECUENTES', path: '/preguntas-frecuentes', description: 'Centro de ayuda y dudas frecuentes', icon: 'bi-patch-question', enabled: false },
  { id: 'contacto', label: 'CONTACTO', path: '/contacto', description: 'Formulario de contacto y WhatsApp', icon: 'bi-telephone', enabled: true }
];

export const DEFAULT_LANDING_CONFIG = {
  company_id: 1,
  showLogoText: true,
  showLogoSubtitle: true,
  logoText: 'HIPERPEL S.A.',
  logoSubtitle: 'FÁBRICA & TIENDA OFICIAL',
  homeSections: DEFAULT_HOME_SECTIONS,
  navbarItems: DEFAULT_NAVBAR_ITEMS,
  carouselSettings: {
    sizePreset: 'standard',
    widthMode: 'container',
    fitMode: 'cover',
    borderRadius: '16px',
    autoPlayInterval: 5000,
    showControls: true,
    showIndicators: true
  },
  topBar: {
    enabled: true,
    announcementText: '🚀 ¡Venta Mayorista y Minorista con Envíos a Todo el País! | Consultas por WhatsApp',
    phone: '(011) 4247-6622',
    whatsapp: '5491142476622',
    email: 'ventas@hiperpel.com.ar'
  },
  heroBanners: DEFAULT_UNIFIED_BANNERS,
  benefits: DEFAULT_BENEFITS_PRIMARY,
  benefitsSettings: DEFAULT_BENEFITS_SETTINGS,
  benefitsSecondary: DEFAULT_BENEFITS_SECONDARY,
  benefitsSecondarySettings: DEFAULT_BENEFITS_SETTINGS,
  categoryShortcuts: {
    enabled: true,
    columnsPerRow: 5,
    cardStyle: 'strip',
    cardHeight: 'large',
    imageFit: 'cover',
    showCardCta: false,
    chevronColor: '#16a34a',
    imageAreaBg: '#ededed',
    sectionTitle: 'Líneas de Productos Destacadas',
    sectionSubtitle: 'Accedé de forma directa a nuestros rubros principales con stock disponible',
    sectionTitleColor: '#1e293b',
    sectionSubtitleColor: '#64748b',
    fontFamily: 'inherit',
    cardTitleLineHeight: '1.25',
    cardSubtitleLineHeight: '1.35',
    cards: [
      {
        id: 'card-1',
        title: 'Bolsas y Polietileno',
        subtitle: 'Arranque, camiseta, riñón y consorcio',
        image: '/images/banners/Frente-Web1.jpg',
        rubroTarget: '',
        link: '/tienda?rubro=Bolsas',
        order: 1,
        is_active: true
      },
      {
        id: 'card-2',
        title: 'Cajas y Embalaje',
        subtitle: 'Cajas de cartón, corrugado, cintas y film',
        image: '/images/banners/Caja.jpg',
        rubroTarget: '',
        link: '/tienda?rubro=Embalaje',
        order: 2,
        is_active: true
      },
      {
        id: 'card-3',
        title: 'Línea Gastronómica',
        subtitle: 'Bandejas, blondas, descartables y aluminio',
        image: '/images/banners/Frente-Web2.jpg',
        rubroTarget: '',
        link: '/tienda?rubro=Gastronomia',
        order: 3,
        is_active: true
      },
      {
        id: 'card-4',
        title: 'Papelería y Resmas',
        subtitle: 'Bobinas, papeles para envolver y librería',
        image: '/images/banners/Slide4.jpg',
        rubroTarget: '',
        link: '/tienda?rubro=Papeleria',
        order: 4,
        is_active: true
      }
    ]
  },
  secondaryBanners: DEFAULT_SECONDARY_BANNERS,
  secondaryCarouselSettings: {
    sizePreset: 'standard',
    widthMode: 'container',
    fitMode: 'cover',
    borderRadius: '16px',
    autoPlay: true,
    interval: 6000,
    fontFamily: 'inherit'
  },
  featuredProductsSection: {
    enabled: true,
    title: 'Artículos Destacados',
    subtitle: 'Los productos más solicitados de nuestro catálogo con entrega inmediata',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
    buttonText: 'Ver Catálogo Completo',
    showButton: true,
    selectionMode: 'auto', // 'auto' | 'rubro' | 'manual'
    filterRubro: '',
    selectedProducts: [],
    limit: 8
  },
  bestSellersSection: {
    enabled: true,
    showInHome: false,
    title: '¡Los Más Vendidos!',
    subtitle: 'Los artículos preferidos por nuestros clientes con entrega inmediata',
    badgeText: '🔥 Ranking de Ventas',
    selectionMode: 'featured', // 'manual' | 'rubros' | 'featured' | 'offers'
    selectedProducts: [],
    selectedRubros: [],
    limit: 8,
    backgroundColor: '#ffffff'
  },
  secondaryNavBar: DEFAULT_SECONDARY_NAVBAR,
  faqSection: DEFAULT_FAQ_SECTION,
  promoBannersSettings: {
    showSectionTitle: true,
    title: 'Oportunidades & Promociones Destacadas',
    subtitle: 'Aprovechá ofertas por cantidad, lanzamientos y productos en liquidación',
    badgeText: 'Promociones Especiales',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
    cardStyle: 'overlay', // 'overlay' | 'below'
    columnsPerRow: 2,
    bannerHeight: 'standard',
    showGradient: true,
    backgroundColor: '#f8fafc',
    fontFamily: 'inherit'
  },
  promoBanners: [
    {
      id: 'promo-1',
      title: 'Cajas de Pizza & Empanadas',
      subtitle: 'Microcorrugado de alta resistencia con o sin impresión.',
      buttonText: 'Ver Opciones',
      showButton: true,
      rubroTarget: '',
      link: '/tienda?rubro=Cajas',
      titleColor: '',
      subtitleColor: '',
      cardStyle: 'inherit',
      image: '/images/banners/Caja.jpg',
      is_active: true
    },
    {
      id: 'promo-2',
      title: 'Papeles & Rollos Térmicos',
      subtitle: 'Para puntos de venta, básculas e impresoras fiscales.',
      buttonText: 'Ver Línea',
      showButton: true,
      rubroTarget: '',
      link: '/tienda?rubro=Papeleria',
      titleColor: '',
      subtitleColor: '',
      cardStyle: 'inherit',
      image: '/images/banners/Slide4.jpg',
      is_active: true
    }
  ],
  novedadesPosts: [
    {
      id: 'nov-1',
      title: 'Línea de Moldes para Roscas y Repostería',
      badge: 'LANZAMIENTO DE TEMPORADA',
      badgeColor: 'warning',
      date: 'Temporada Actual',
      image: '/images/novedades/moldes_roscas.jpg',
      description: 'Moldes descartables especiales para roscas de pascua, pan dulce y repostería artesanal e industrial. Variedad de diámetros y gramajes con máxima resistencia al horneado.',
      bulletPoints: [
        'Fabricados con papel microcorrugado apto para cocción',
        'Precios especiales por bulto cerrado y pallets',
        'Stock permanente con entrega inmediata'
      ],
      rubroTarget: 'Gastronomia',
      whatsappMessage: '¡Hola! Me comunico para consultar por la oferta de Moldes para Roscas que vi en Novedades.'
    },
    {
      id: 'nov-2',
      title: 'Ofertas Especiales en Bandejas, Bolsas y Descartables',
      badge: 'PROMO DESTACADA',
      badgeColor: 'danger',
      date: 'Oferta Vigente',
      image: '/images/novedades/ofertas_temporada.jpg',
      description: 'Promociones directas de fábrica en bandejas de cartón, blondas, bolsas de polietileno de alta y baja densidad, rollos de arranque y films adherentes.',
      bulletPoints: [
        'Descuentos por escala para distribuidoras y comercios',
        'Envíos a todo el país y retiro inmediato en planta',
        'Asesoramiento comercial personalizado'
      ],
      rubroTarget: 'Bolsas',
      whatsappMessage: '¡Hola! Me comunico para consultar por las ofertas especiales de Bandejas y Bolsas que vi en Novedades.'
    },
    {
      id: 'nov-3',
      title: 'Vasos Térmicos, Pasta y Línea Descartable',
      badge: 'STOCK PERMANENTE',
      badgeColor: 'success',
      date: 'Disponibilidad Inmediata',
      image: '/images/novedades/vasos_pasta.jpg',
      description: 'Soluciones integrales para cafeterías, heladerías, eventos y gastronomía. Vasos térmicos, potes de pasta, cubiertos y complementos descartables de máxima calidad.',
      bulletPoints: [
        'Línea completa de potes y vasos térmicos',
        'Venta mayorista y minorista con precios de fábrica',
        'Consultá por listas diferenciales'
      ],
      rubroTarget: 'Gastronomia',
      whatsappMessage: '¡Hola! Me comunico para consultar por la línea de Vasos Térmicos y Descartables que vi en Novedades.'
    }
  ],
  aboutSection: {
    enabled: true,
    badgeText: 'Fábrica Directa',
    homeTitle: 'Más de 30 años liderando en cartón, envases y embalajes',
    title: 'Sobre Nuestra Empresa',
    tagline: 'Más de 30 años de experiencia e innovación en el rubro',
    paragraph1: 'Somos una empresa argentina dedicada a la fabricación y comercialización integral de soluciones de embalaje, papelería comercial y descartables para todo el país.',
    paragraph2: 'Brindamos atención personalizada tanto a comercios minoristas como a industrias y grandes distribuidores de todo el país, garantizando calidad superior, precios competitivos y entregas puntuales.',
    image: '/images/banners/Frente-Web1.jpg',
    button1Text: 'Conocer Nuestra Empresa',
    button1Link: '/empresa',
    button2Text: 'Solicitar Asesoramiento',
    button2Link: '/contacto',
    floatingBadgeShow: true,
    floatingBadgeTitle: 'Calidad & Stock Permanente',
    floatingBadgeSubtitle: 'Despachos rápidos a toda la Argentina',
    backgroundColor: '#ffffff',
    showGradient: false,
    stats: [
      { number: '30+', label: 'Años de Trayectoria' },
      { number: '1000+', label: 'Artículos en Catálogo' },
      { number: '24h', label: 'Despacho Rápido' },
      { number: '100%', label: 'Cobertura Nacional' }
    ]
  },
  locationSection: {
    enabled: true,
    facilityTitle: 'Planta de Fabricación y Retiro',
    facilityDescription: 'Contamos con amplias instalaciones para la elaboración, stock y despacho ágil de mercadería con estacionamiento y zona de carga para utilitarios y camiones.',
    carAccess: 'Fácil acceso conectando directamente con las principales avenidas y autopistas. Zona de carga para retiros.',
    trainAccess: 'A pocas cuadras de las principales estaciones de ferrocarril y centros de transbordo.',
    busAccess: 'Múltiples líneas de colectivo y transporte público con parada directa en las inmediaciones de la planta.',
    locations: [
      {
        id: 'loc-1',
        title: 'Planta de Fabricación y Retiro',
        badge: 'Casa Central & Depósito',
        address: 'Vicente Damonte 1237 / 1247, Lanús Este (B1824ALG), Buenos Aires',
        description: 'Contamos con amplias instalaciones para la elaboración, stock y despacho ágil de mercadería con estacionamiento y zona de carga para utilitarios y camiones.',
        phone: '(011) 4247-6622',
        whatsapp: '5491142476622',
        schedule: 'Lunes a Viernes de 08:00 a 18:00 hs | Sábados de 08:00 a 13:00 hs',
        is_active: true
      }
    ]
  },
  contactSection: {
    enabled: true,
    title: '¿Tenés dudas o necesitás una cotización a medida?',
    subtitle: 'Escribinos y un asesor se pondrá en contacto a la brevedad.',
    address: 'Vicente Damonte 1237 / 1247, Lanús Este (B1824ALG), Buenos Aires',
    phone: '(011) 4247-6622',
    whatsapp: '5491142476622',
    email: 'ventas@hiperpel.com.ar',
    schedule: 'Lunes a Viernes de 08:00 a 18:00 hs | Sábados de 08:00 a 13:00 hs',
    scheduleMonFri: '08:00 a 18:00 hs',
    scheduleSat: '08:00 a 13:00 hs',
    showShippingBadge: true,
    shippingBadgeText: 'Envíos a todo el país y retiro en planta'
  },
  whatsappFloating: {
    enabled: true,
    phone: '5491142476622',
    message: '¡Hola! Me comunico desde el sitio web para hacer una consulta.',
    pillText: '¿Dudas? ¡Escribinos!',
    showPill: true
  },
  downloadsSection: {
    enabled: true,
    showInNavbar: true,
    showInNavbarForGuests: true,
    visibility: 'public', // 'public' | 'authenticated'
    title: 'Centro de Descargas y Recursos',
    subtitle: 'Descargá nuestras listas de precios actualizadas, catálogos en PDF, planos y material comercial.',
    categories: ['Listas de Precios', 'Catálogos PDF', 'Planos y Fichas Técnicas', 'Flyers y Promos', 'Imágenes en Alta'],
    items: [
      {
        id: 'down-1',
        title: 'Lista de Precios Mayorista - Vigente',
        description: 'Precios actualizados de fábrica para compras por bulto cerrado y distribuidores mayoristas de todo el país.',
        category: 'Listas de Precios',
        fileUrl: '',
        fileFormat: 'PDF',
        fileSize: '1.2 MB',
        updatedAt: 'Marzo 2026',
        requiresAuth: false,
        is_active: true,
        order: 1
      },
      {
        id: 'down-2',
        title: 'Catálogo Institucional Completo y Gama de Productos',
        description: 'Folleto general con especificaciones, medidas, gramajes y fotografías de todos los artículos.',
        category: 'Catálogos PDF',
        fileUrl: '',
        fileFormat: 'PDF',
        fileSize: '4.8 MB',
        updatedAt: '2026',
        requiresAuth: false,
        is_active: true,
        order: 2
      },
      {
        id: 'down-3',
        title: 'Ficha Técnica y Medidas de Cajas de Cartón',
        description: 'Planos de armado, resistencia al aplastamiento y tolerancias estándar para embalaje y logística.',
        category: 'Planos y Fichas Técnicas',
        fileUrl: '',
        fileFormat: 'PDF',
        fileSize: '850 KB',
        updatedAt: '2026',
        requiresAuth: false,
        is_active: true,
        order: 3
      },
      {
        id: 'down-4',
        title: 'Planilla de Pedidos Rápida (Formato Excel)',
        description: 'Plantilla estructurada para confeccionar pedidos masivos por código de artículo y enviarla por WhatsApp o correo.',
        category: 'Listas de Precios',
        fileUrl: '',
        fileFormat: 'XLSX',
        fileSize: '320 KB',
        updatedAt: '2026',
        requiresAuth: false,
        is_active: true,
        order: 4
      }
    ]
  },
  footer: {
    logoUrl: '',
    companyName: 'HIPERPEL S.A.',
    tagline: 'Fabricantes de productos de cartón, envases, embalajes, descartables, gastronomía y librería. Venta mayorista y minorista con envíos a todo el país.',
    websiteUrl: '',
    copyrightText: '',
    showSocials: true,
    socialLinks: {
      instagram: { enabled: true, url: 'https://instagram.com/hiperpel' },
      facebook: { enabled: true, url: 'https://facebook.com/hiperpel' },
      x: { enabled: true, url: 'https://x.com/hiperpel' },
      linkedin: { enabled: true, url: 'https://linkedin.com/company/hiperpel' },
      tiktok: { enabled: true, url: 'https://tiktok.com/@hiperpel' }
    }
  }
};

const ProductThumbnail = ({ product, size = 38 }) => {
  const candidateUrls = useMemo(() => {
    if (!product) return [];
    const slides = getArticleImageSlides(product);
    if (slides.length > 0 && slides[0].candidates && slides[0].candidates.length > 0) {
      return slides[0].candidates;
    }
    const raw = product?.d_pathimg || product?.imagen || product?.foto || product?.d_imagen;
    if (raw && typeof raw === 'string') {
      return getCandidateUrlsForImage(raw, product?.d_pathimg || '');
    }
    return [];
  }, [product]);

  const [candidateIdx, setCandidateIdx] = useState(0);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setCandidateIdx(0);
    setHasError(false);
  }, [product?.c_artic, product?.d_imagen, product?.imagen, product?.d_pathimg, product?.id]);

  const currentUrl = !hasError && candidateUrls.length > 0 ? candidateUrls[candidateIdx] : null;

  const handleError = () => {
    if (candidateIdx < candidateUrls.length - 1) {
      setCandidateIdx(prev => prev + 1);
    } else {
      setHasError(true);
    }
  };

  return (
    <div
      className="rounded-3 border bg-light d-flex align-items-center justify-content-center overflow-hidden flex-shrink-0"
      style={{ width: `${size}px`, height: `${size}px`, minWidth: `${size}px` }}
    >
      {currentUrl ? (
        <img
          src={currentUrl}
          alt=""
          className="w-100 h-100 object-fit-cover"
          onError={handleError}
        />
      ) : (
        <i className="bi bi-box-seam text-secondary" style={{ fontSize: `${Math.round(size * 0.45)}px` }}></i>
      )}
    </div>
  );
};

const LogoPreviewImage = ({ url, alt }) => {
  const candidateUrls = useMemo(() => getImageCandidateUrls(url), [url]);
  const [candidateIdx, setCandidateIdx] = useState(0);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setCandidateIdx(0);
    setHasError(false);
  }, [url]);

  const handleError = () => {
    if (candidateIdx + 1 < candidateUrls.length) {
      setCandidateIdx(prev => prev + 1);
    } else {
      setHasError(true);
    }
  };

  const currentUrl = !hasError && candidateUrls.length > 0 ? candidateUrls[candidateIdx] : null;

  if (!url || !currentUrl) {
    return (
      <div className="text-center text-muted">
        <i className="bi bi-image fs-1 text-secondary opacity-50"></i>
        <div className="small mt-1 text-xs">{url ? 'No se pudo cargar la imagen' : 'Sin imagen cargada'}</div>
      </div>
    );
  }

  return (
    <img 
      src={currentUrl} 
      alt={alt || 'Logo'} 
      className="img-fluid"
      style={{ maxHeight: '65px', maxWidth: '100%', objectFit: 'contain' }}
      onError={handleError}
    />
  );
};

const CardPreviewImage = ({ url, alt }) => {
  const candidateUrls = useMemo(() => (url ? getImageCandidateUrls(url) : []), [url]);
  const [candidateIdx, setCandidateIdx] = useState(0);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setCandidateIdx(0);
    setHasError(false);
  }, [url]);

  const handleError = () => {
    if (candidateIdx + 1 < candidateUrls.length) {
      setCandidateIdx(prev => prev + 1);
    } else {
      setHasError(true);
    }
  };

  const currentUrl = !hasError && candidateUrls.length > 0 ? candidateUrls[candidateIdx] : null;

  if (!url || !currentUrl) {
    return (
      <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-light text-muted p-2">
        <i className="bi bi-image fs-3 text-secondary opacity-50"></i>
        <span className="small text-secondary mt-1" style={{ fontSize: '0.72rem' }}>Sin imagen</span>
      </div>
    );
  }

  return (
    <img
      src={currentUrl}
      alt={alt || 'Vista previa'}
      className="object-fit-cover w-100 h-100"
      onError={handleError}
    />
  );
};

const LandingAdminSettings = ({ user }) => {
  const { updateLandingConfig } = useWebStore();
  const [config, setConfig] = useState(DEFAULT_LANDING_CONFIG);
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(() => {
    try {
      const cachedLanding = localStorage.getItem('sigecom_cached_landing_config');
      if (cachedLanding) {
        const parsed = JSON.parse(cachedLanding);
        if (parsed?.company_id) return Number(parsed.company_id);
      }
      const cachedStore = localStorage.getItem('sigecom_cached_store_config');
      if (cachedStore) {
        const parsed = JSON.parse(cachedStore);
        if (parsed?.company_id) return Number(parsed.company_id);
      }
    } catch (e) {}
    return user?.empresa_activa?.c_nuges || user?.empresa_activa?.id || 1;
  });
  const [rubros, setRubros] = useState([]);
  const [priceLists, setPriceLists] = useState([]);
  const [activeTab, setActiveTab] = useState('sections'); // 'hero' | 'shortcuts' | 'featured' | 'novedades' | 'about' | 'location' | 'contact' | 'downloads'
  const [selectedBenefitsBar, setSelectedBenefitsBar] = useState('primary');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [searchArticuloQuery, setSearchArticuloQuery] = useState('');
  const [searchingArticulos, setSearchingArticulos] = useState(false);
  const [searchedArticulos, setSearchedArticulos] = useState([]);
  const [previewProduct, setPreviewProduct] = useState(null);
  const [draggedSectionIndex, setDraggedSectionIndex] = useState(null);
  const [dragOverSectionIndex, setDragOverSectionIndex] = useState(null);
  const [draggedNavIndex, setDraggedNavIndex] = useState(null);
  const [dragOverNavIndex, setDragOverNavIndex] = useState(null);
  const [expandedStyleSectionId, setExpandedStyleSectionId] = useState(null);
  const [moduleFilterGroup, setModuleFilterGroup] = useState('all'); // 'all' | 'home' | 'pages' | 'design'
  const featuredSelectionModeRef = useRef(null);

  // Sincronizar automáticamente con la empresa activa del operador
  useEffect(() => {
    const activeId = user?.empresa_activa?.c_nuges || user?.empresa_activa?.id;
    if (activeId && Number(activeId) !== Number(selectedCompanyId)) {
      setSelectedCompanyId(Number(activeId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.empresa_activa]);

  const activeCompany = useMemo(() => {
    const currentId = selectedCompanyId;
    const found = companies.find(c => String(c.c_nuges || c.id) === String(currentId));
    const base = found || user?.empresa_activa || { c_nuges: currentId, nombre: `Empresa #${currentId}` };
    const rawDomain = (base?.d_sitien || '').replace(/www\.hiperpel\.com\.ar/gi, 'hiperpel.ar').replace(/hiperpel\.com\.ar/gi, 'hiperpel.ar');
    return { ...base, d_sitien: rawDomain };
  }, [companies, selectedCompanyId, user?.empresa_activa]);

  // 1. Cargar Empresas, Rubros y Listas de Precios
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [resEmp, resRub, resLis] = await Promise.all([
          axios.get('/api/empresas/'),
          axios.get('/api/rubros/', { params: { company: selectedCompanyId }, headers: { 'X-Company-ID': String(selectedCompanyId) } }),
          axios.get('/api/listas/', { params: { company: selectedCompanyId }, headers: { 'X-Company-ID': String(selectedCompanyId) } })
        ]);
        if (Array.isArray(resEmp.data) && resEmp.data.length > 0) {
          setCompanies(resEmp.data);
        } else if (Array.isArray(user?.empresas) && user.empresas.length > 0) {
          setCompanies(user.empresas);
        }
        if (Array.isArray(resRub.data)) {
          const activeOnly = resRub.data.filter(r => {
            if (!r) return false;
            if (r.c_situa === 9 || Number(r.c_situa) === 9) return false;
            if (r.q_articulos !== undefined && Number(r.q_articulos) <= 0) return false;
            const name = String(r.d_rubro || '').trim().toLowerCase();
            if (name === 'productos viejos') return false;
            return true;
          });
          setRubros(activeOnly);
        }
        if (Array.isArray(resLis.data)) {
          setPriceLists(resLis.data);
        } else if (resLis.data?.results && Array.isArray(resLis.data.results)) {
          setPriceLists(resLis.data.results);
        }
      } catch (err) {
        console.warn('Error cargando empresas/rubros/listas:', err);
      }
    };
    fetchInitialData();
  }, [selectedCompanyId, user?.empresas]);

  // 2. Cargar Configuración de la Landing para la empresa seleccionada
  useEffect(() => {
    const fetchLandingConfig = async () => {
      setLoading(true);
      try {
        const res = await axios.get('/api/landing/config/', {
          params: { company: selectedCompanyId, _t: Date.now() },
          headers: { 'X-Company-ID': String(selectedCompanyId) }
        });
        if (res.data) {
          const compId = res.data.company_id ? Number(res.data.company_id) : selectedCompanyId;
          if (compId !== selectedCompanyId) {
            setSelectedCompanyId(compId);
          }
          setConfig({
            ...DEFAULT_LANDING_CONFIG,
            ...res.data,
            company_id: compId,
            logoUrl: res.data.logoUrl !== undefined ? res.data.logoUrl : DEFAULT_LANDING_CONFIG.logoUrl,
            logoText: res.data.logoText !== undefined && res.data.logoText !== null ? res.data.logoText : DEFAULT_LANDING_CONFIG.logoText,
            colors: { ...DEFAULT_LANDING_CONFIG.colors, ...(res.data.colors || res.data.styles || {}) },
            topBar: { ...DEFAULT_LANDING_CONFIG.topBar, ...(res.data.topBar || {}) },
            categoryShortcuts: { ...DEFAULT_LANDING_CONFIG.categoryShortcuts, ...(res.data.categoryShortcuts || {}) },
            featuredProductsSection: { ...DEFAULT_LANDING_CONFIG.featuredProductsSection, ...(res.data.featuredProductsSection || {}) },
            bestSellersSection: { ...DEFAULT_LANDING_CONFIG.bestSellersSection, ...(res.data.bestSellersSection || {}) },
            secondaryNavBar: {
              ...DEFAULT_SECONDARY_NAVBAR,
              ...(res.data.secondaryNavBar || {}),
              items: Array.isArray(res.data.secondaryNavBar?.items)
                ? res.data.secondaryNavBar.items
                : DEFAULT_SECONDARY_NAVBAR.items
            },
            faqSection: {
              ...DEFAULT_FAQ_SECTION,
              ...(res.data.faqSection || {}),
              items: Array.isArray(res.data.faqSection?.items)
                ? res.data.faqSection.items
                : DEFAULT_FAQ_SECTION.items
            },
            aboutSection: { ...DEFAULT_LANDING_CONFIG.aboutSection, ...(res.data.aboutSection || {}) },
            locationSection: {
              ...DEFAULT_LANDING_CONFIG.locationSection,
              ...(res.data.locationSection || {}),
              locations: (res.data.locationSection?.locations && res.data.locationSection.locations.length > 0)
                ? res.data.locationSection.locations
                : [
                    {
                      id: 'loc-1',
                      title: res.data.locationSection?.facilityTitle || 'Planta de Fabricación y Retiro',
                      badge: 'Casa Central & Depósito',
                      address: res.data.contactSection?.address || DEFAULT_LANDING_CONFIG.contactSection.address,
                      description: res.data.locationSection?.facilityDescription || DEFAULT_LANDING_CONFIG.locationSection.facilityDescription,
                      phone: res.data.contactSection?.phone || DEFAULT_LANDING_CONFIG.contactSection.phone,
                      whatsapp: res.data.contactSection?.whatsapp || DEFAULT_LANDING_CONFIG.contactSection.whatsapp,
                      schedule: res.data.contactSection?.schedule || DEFAULT_LANDING_CONFIG.contactSection.schedule,
                      is_active: true
                    }
                  ]
            },
            contactSection: { ...DEFAULT_LANDING_CONFIG.contactSection, ...(res.data.contactSection || {}) },
            whatsappFloating: { ...DEFAULT_LANDING_CONFIG.whatsappFloating, ...(res.data.whatsappFloating || {}) },
            downloadsSection: {
              ...DEFAULT_LANDING_CONFIG.downloadsSection,
              ...(res.data.downloadsSection || {}),
              items: (res.data.downloadsSection?.items && res.data.downloadsSection.items.length > 0)
                ? res.data.downloadsSection.items
                : DEFAULT_LANDING_CONFIG.downloadsSection.items
            },
            novedadesPosts: (res.data.novedadesPosts && res.data.novedadesPosts.length > 0) ? res.data.novedadesPosts : DEFAULT_LANDING_CONFIG.novedadesPosts,
            promoBannersSettings: { ...DEFAULT_LANDING_CONFIG.promoBannersSettings, ...(res.data.promoBannersSettings || {}) },
            promoBanners: (res.data.promoBanners && res.data.promoBanners.length > 0) ? res.data.promoBanners : DEFAULT_LANDING_CONFIG.promoBanners,
            benefits: normalizeBenefitsList(res.data.benefits, DEFAULT_BENEFITS_PRIMARY),
            benefitsSecondary: normalizeBenefitsList(res.data.benefitsSecondary, DEFAULT_BENEFITS_SECONDARY),
            benefitsSettings: { ...DEFAULT_BENEFITS_SETTINGS, ...(res.data.benefitsSettings || {}) },
            benefitsSecondarySettings: { ...DEFAULT_BENEFITS_SETTINGS, ...(res.data.benefitsSecondarySettings || {}) },
            homeSections: (Array.isArray(res.data.homeSections) && res.data.homeSections.length > 0) ? res.data.homeSections : DEFAULT_HOME_SECTIONS,
            navbarItems: (Array.isArray(res.data.navbarItems) && res.data.navbarItems.length > 0) ? res.data.navbarItems : DEFAULT_NAVBAR_ITEMS,
            sitePublished: res.data.sitePublished !== undefined ? Boolean(res.data.sitePublished) : !Boolean(res.data.is_in_setup),
            tagline: res.data.tagline !== undefined ? res.data.tagline : (res.data.footer?.tagline !== undefined ? res.data.footer.tagline : DEFAULT_LANDING_CONFIG.tagline),
            logoSubtitle: res.data.logoSubtitle !== undefined ? res.data.logoSubtitle : 'FÁBRICA & TIENDA OFICIAL',
            showLogoSubtitle: res.data.showLogoSubtitle !== false,
            showLogoText: res.data.showLogoText !== false,
            footer: {
              ...DEFAULT_LANDING_CONFIG.footer,
              ...(res.data.footer || {}),
              tagline: res.data.tagline !== undefined ? res.data.tagline : (res.data.footer?.tagline !== undefined ? res.data.footer.tagline : DEFAULT_LANDING_CONFIG.footer.tagline)
            }
          });
        }
      } catch (err) {
        console.warn('Error cargando config de landing:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchLandingConfig();
  }, [selectedCompanyId]);

  // Garantizar que la pantalla de administración mantenga siempre los colores limpios del sistema
  useEffect(() => {
    resetSystemTheme();
    return () => {
      resetSystemTheme();
    };
  }, []);

  // Handlers para Colores y Estilos
  const handleColorChange = (key, value) => {
    setConfig(prev => ({
      ...prev,
      colors: {
        ...(prev.colors || DEFAULT_LANDING_CONFIG.colors),
        [key]: value
      }
    }));
  };

  const handleApplyPreset = (preset) => {
    setConfig(prev => ({
      ...prev,
      colors: {
        ...(prev.colors || DEFAULT_LANDING_CONFIG.colors),
        primaryColor: preset.primaryColor,
        secondaryColor: preset.secondaryColor || '#0a58ca',
        accentColor: preset.accentColor,
        buttonColor: preset.buttonColor,
        buttonPrimaryText: preset.buttonPrimaryText || '#111827',
        buttonSecondaryBg: preset.buttonSecondaryBg || '#f8fafc',
        buttonSecondaryText: preset.buttonSecondaryText || '#1e293b',
        textColor: preset.textColor || '#1e293b',
        pageBg: preset.pageBg || '#f8fafc',
        cardBg: preset.cardBg || '#ffffff',
        borderColor: preset.borderColor || '#e2e8f0',
        borderRadius: preset.borderRadius || '12px',
        topBarBg: preset.topBarBg || '#0f172a',
        topBarText: preset.topBarText || '#ffffff',
        navbarBg: preset.navbarBg || '#ffffff',
        headerText: preset.headerText || '#1e293b',
        headerBorder: preset.headerBorder || '#e2e8f0',
        footerBg: preset.footerBg || '#1e293b',
        footerTextColor: preset.footerTextColor || '#94a3b8',
        footerTitleColor: preset.footerTitleColor || '#ffffff',
        footerBorderColor: preset.footerBorderColor || '#334155'
      }
    }));
  };

  // Guardar Cambios
  const handleSave = async () => {
    setSaving(true);
    try {
      const resolvedTagline = config.tagline !== undefined ? config.tagline : (config.footer?.tagline || '');
      const isPublished = config.sitePublished !== false;
      const payload = {
        ...config,
        sitePublished: isPublished,
        tagline: resolvedTagline,
        footer: {
          ...(config.footer || {}),
          tagline: resolvedTagline
        },
        banners: config.heroBanners,
        company_id: Number(selectedCompanyId)
      };
      delete payload.is_in_setup;
      delete payload.status;
      const res = await axios.post('/api/landing/config/', payload, {
        params: { company: selectedCompanyId, _t: Date.now() },
        headers: { 'X-Company-ID': String(selectedCompanyId) }
      });
      if (updateLandingConfig) {
        updateLandingConfig({
          ...payload,
          is_in_setup: !isPublished,
          status: isPublished ? 'activa' : 'en_habilitacion'
        });
      }
      Swal.fire({
        icon: 'success',
        title: '¡Página Web Actualizada!',
        text: res.data?.mensaje || 'Los cambios en la portada institucional y páginas del sitio se guardaron con éxito.',
        confirmButtonColor: '#0d6efd',
        timer: 2500
      });
    } catch (err) {
      console.error('Error guardando configuración de landing:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error al Guardar',
        text: err.response?.data?.error || 'No se pudo guardar la configuración.',
        confirmButtonColor: '#dc3545'
      });
    } finally {
      setSaving(false);
    }
  };

  // Subir imagen para cualquier sección
  const handleUploadImage = async (e, onUrlReady, targetType = 'landing') => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('target_type', targetType);
    formData.append('company_id', selectedCompanyId);

    setUploadingImage(true);
    try {
      const res = await axios.post('/api/landing/upload-image/', formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'X-Company-ID': String(selectedCompanyId) }
      });
      if (res.data?.url || res.data?.relative_url) {
        onUrlReady(res.data.relative_url || res.data.url);
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: '¡Imagen subida correctamente!',
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (err) {
      console.error('Error al subir imagen:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error de Carga',
        text: err.response?.data?.error || 'No se pudo subir la imagen.',
        confirmButtonColor: '#dc3545'
      });
    } finally {
      setUploadingImage(false);
    }
  };

  // Handlers para Accesos Directos (Cards)
  const handleCardChange = (index, field, value) => {
    const updatedCards = [...(config.categoryShortcuts?.cards || [])];
    updatedCards[index] = { ...updatedCards[index], [field]: value };

    if (field === 'rubroTarget' && value) {
      updatedCards[index].link = `/tienda?rubro=${encodeURIComponent(value)}`;
    }

    setConfig({
      ...config,
      categoryShortcuts: {
        ...(config.categoryShortcuts || DEFAULT_LANDING_CONFIG.categoryShortcuts),
        cards: updatedCards
      }
    });
  };

  const handleAddCard = () => {
    const currentCards = config.categoryShortcuts?.cards || [];
    const newCard = {
      id: `card-${Date.now()}`,
      title: 'Nueva Línea de Producto',
      subtitle: 'Descripción de la categoría o rubro',
      image: '',
      rubroTarget: '',
      link: '/tienda',
      order: currentCards.length + 1,
      is_active: true,
      showGradient: true,
      textColorTheme: 'inherit',
      titleFontSize: 'inherit',
      subtitleFontSize: 'inherit',
      textAlignment: 'inherit',
      verticalAlignment: 'inherit',
      textShadow: 'inherit'
    };
    setConfig({
      ...config,
      categoryShortcuts: {
        ...(config.categoryShortcuts || DEFAULT_LANDING_CONFIG.categoryShortcuts),
        cards: [...currentCards, newCard]
      }
    });
  };

  const handleDeleteCard = (index) => {
    const currentCards = config.categoryShortcuts?.cards || [];
    Swal.fire({
      title: '¿Eliminar esta tarjeta?',
      text: 'La tarjeta se quitará de la sección de accesos directos.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = currentCards.filter((_, i) => i !== index);
        updated.forEach((c, i) => { c.order = i + 1; });
        setConfig({
          ...config,
          categoryShortcuts: {
            ...(config.categoryShortcuts || DEFAULT_LANDING_CONFIG.categoryShortcuts),
            cards: updated
          }
        });
      }
    });
  };

  const handleMoveCard = (index, direction) => {
    const currentCards = [...(config.categoryShortcuts?.cards || [])];
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= currentCards.length) return;
    const [moved] = currentCards.splice(index, 1);
    currentCards.splice(newIndex, 0, moved);
    currentCards.forEach((c, i) => { c.order = i + 1; });
    setConfig({
      ...config,
      categoryShortcuts: {
        ...(config.categoryShortcuts || DEFAULT_LANDING_CONFIG.categoryShortcuts),
        cards: currentCards
      }
    });
  };

  // Handlers para Novedades Posts
  const handleNovedadChange = (index, field, value) => {
    const updated = [...(config.novedadesPosts || [])];
    updated[index] = { ...updated[index], [field]: value };
    setConfig({ ...config, novedadesPosts: updated });
  };

  const handleNovedadBulletChange = (postIndex, bulletIndex, value) => {
    const updated = [...(config.novedadesPosts || [])];
    const bullets = [...(updated[postIndex].bulletPoints || [])];
    bullets[bulletIndex] = value;
    updated[postIndex] = { ...updated[postIndex], bulletPoints: bullets };
    setConfig({ ...config, novedadesPosts: updated });
  };

  const handleAddNovedad = () => {
    const newPost = {
      id: `nov-${Date.now()}`,
      title: 'Nueva Novedad / Lanzamiento de Producto',
      badge: 'PROMO DESTACADA',
      badgeColor: 'warning',
      date: 'Temporada Actual',
      image: '/images/novedades/ofertas_temporada.jpg',
      description: 'Detalle de la promoción, beneficios, materiales y condiciones comerciales de entrega.',
      bulletPoints: [
        'Stock disponible con entrega inmediata',
        'Precios especiales por escala y bulto cerrado',
        'Asesoramiento directo y envíos a todo el país'
      ],
      rubroTarget: '',
      whatsappMessage: '¡Hola! Me comunico para consultar por la novedad que vi en la web.'
    };
    setConfig({ ...config, novedadesPosts: [newPost, ...(config.novedadesPosts || [])] });
  };

  const handleDeleteNovedad = (index) => {
    const updated = (config.novedadesPosts || []).filter((_, i) => i !== index);
    setConfig({ ...config, novedadesPosts: updated });
  };

  // Handlers para Selección de Artículos Destacados
  const handleSearchArticulos = async (query) => {
    setSearchArticuloQuery(query);
    if (!query || query.trim().length < 2) {
      setSearchedArticulos([]);
      return;
    }
    setSearchingArticulos(true);
    try {
      const res = await axios.get('/api/articulos/', {
        params: { search: query.trim(), page: 1, page_size: 10, company: selectedCompanyId },
        headers: { 'X-Company-ID': String(selectedCompanyId) }
      });
      const items = Array.isArray(res.data) ? res.data : (res.data?.results || []);
      setSearchedArticulos(items);
    } catch (err) {
      console.warn('Error buscando artículos:', err);
    } finally {
      setSearchingArticulos(false);
    }
  };

  const handleSelectFeaturedProduct = (art) => {
    const currentSelected = config.featuredProductsSection?.selectedProducts || [];
    if (currentSelected.some(p => String(p.c_artic || p.id) === String(art.c_artic || art.id))) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: 'El artículo ya está en la lista de destacados',
        showConfirmButton: false,
        timer: 1800
      });
      return;
    }
    const productData = {
      c_artic: art.c_artic,
      id: art.id || art.c_artic,
      d_artic: art.d_artic,
      d_pathimg: art.d_pathimg || art.imagen || '',
      c_rubro: art.c_rubro || '',
      c_marca: art.c_marca || '',
      price: art.precio || art.i_preant || ''
    };
    setConfig({
      ...config,
      featuredProductsSection: {
        ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection),
        selectedProducts: [...currentSelected, productData],
        selectionMode: 'manual'
      }
    });
    setSearchArticuloQuery('');
    setSearchedArticulos([]);
  };

  const handleRemoveFeaturedProduct = (index) => {
    const currentSelected = [...(config.featuredProductsSection?.selectedProducts || [])];
    currentSelected.splice(index, 1);
    setConfig({
      ...config,
      featuredProductsSection: {
        ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection),
        selectedProducts: currentSelected
      }
    });
  };

  // Handler para cambio de modo de selección de productos destacados con centrado de scroll
  const handleFeaturedSelectionModeChange = (mode) => {
    setConfig(prev => ({
      ...prev,
      featuredProductsSection: {
        ...(prev.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection),
        selectionMode: mode
      }
    }));

    setTimeout(() => {
      if (featuredSelectionModeRef.current) {
        featuredSelectionModeRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, 60);
  };

  // Handlers para Promo Banners de Portada
  const handlePromoBannerChange = (index, field, value) => {
    const updated = [...(config.promoBanners || [])];
    updated[index] = { ...updated[index], [field]: value };
    setConfig({ ...config, promoBanners: updated });
  };

  const handleAddPromoBanner = () => {
    const newBanner = {
      id: `promo-${Date.now()}`,
      title: 'Nueva Oportunidad / Promoción',
      subtitle: 'Descripción breve de la oferta o categoría destacada.',
      buttonText: 'Ver Opciones',
      showButton: true,
      rubroTarget: '',
      link: '/tienda',
      titleColor: '',
      subtitleColor: '',
      cardStyle: 'inherit',
      image: '',
      is_active: true
    };
    setConfig(prev => ({
      ...prev,
      promoBanners: [...(prev.promoBanners || []), newBanner]
    }));
  };

  const handleDeletePromoBanner = (index) => {
    const current = config.promoBanners || [];
    Swal.fire({
      title: '¿Eliminar este banner promocional?',
      text: 'Se quitará este banner de la portada.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = current.filter((_, i) => i !== index);
        setConfig(prev => ({ ...prev, promoBanners: updated }));
      }
    });
  };

  const handleMovePromoBanner = (index, direction) => {
    const current = [...(config.promoBanners || [])];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= current.length) return;
    const [moved] = current.splice(index, 1);
    current.splice(targetIndex, 0, moved);
    setConfig(prev => ({ ...prev, promoBanners: current }));
  };

  const handlePromoBannersSettingsChange = (field, value) => {
    setConfig(prev => ({
      ...prev,
      promoBannersSettings: {
        ...(prev.promoBannersSettings || DEFAULT_LANDING_CONFIG.promoBannersSettings),
        [field]: value
      }
    }));
  };

  // Handlers para Stats de Sobre Nosotros
  const handleStatChange = (index, field, value) => {
    const currentStats = [...(config.aboutSection?.stats || DEFAULT_LANDING_CONFIG.aboutSection.stats || [])];
    currentStats[index] = { ...currentStats[index], [field]: value };
    setConfig({
      ...config,
      aboutSection: {
        ...(config.aboutSection || DEFAULT_LANDING_CONFIG.aboutSection),
        stats: currentStats
      }
    });
  };

  const handleAddStat = () => {
    const currentStats = [...(config.aboutSection?.stats || DEFAULT_LANDING_CONFIG.aboutSection.stats || [])];
    const newStat = { number: '100+', label: 'Nuevo Indicador' };
    setConfig({
      ...config,
      aboutSection: {
        ...(config.aboutSection || DEFAULT_LANDING_CONFIG.aboutSection),
        stats: [...currentStats, newStat]
      }
    });
  };

  const handleDeleteStat = (index) => {
    const currentStats = [...(config.aboutSection?.stats || DEFAULT_LANDING_CONFIG.aboutSection.stats || [])];
    const updatedStats = currentStats.filter((_, i) => i !== index);
    setConfig({
      ...config,
      aboutSection: {
        ...(config.aboutSection || DEFAULT_LANDING_CONFIG.aboutSection),
        stats: updatedStats
      }
    });
  };

  const handleMoveStat = (index, direction) => {
    const currentStats = [...(config.aboutSection?.stats || DEFAULT_LANDING_CONFIG.aboutSection.stats || [])];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= currentStats.length) return;
    const temp = currentStats[index];
    currentStats[index] = currentStats[targetIndex];
    currentStats[targetIndex] = temp;
    setConfig({
      ...config,
      aboutSection: {
        ...(config.aboutSection || DEFAULT_LANDING_CONFIG.aboutSection),
        stats: currentStats
      }
    });
  };

  // Handlers para Sedes / Direcciones de Dónde Estamos
  const handleLocationItemChange = (index, field, value) => {
    const currentLocs = [...(config.locationSection?.locations || DEFAULT_LANDING_CONFIG.locationSection.locations || [])];
    currentLocs[index] = { ...currentLocs[index], [field]: value };
    setConfig({
      ...config,
      locationSection: {
        ...(config.locationSection || DEFAULT_LANDING_CONFIG.locationSection),
        locations: currentLocs
      }
    });
  };

  const handleAddLocation = () => {
    const currentLocs = [...(config.locationSection?.locations || DEFAULT_LANDING_CONFIG.locationSection.locations || [])];
    const newLoc = {
      id: `loc-${Date.now()}`,
      title: 'Nueva Sede / Sucursal',
      badge: 'Showroom Comercial',
      address: '',
      description: 'Atención al público, showroom y retiro de pedidos.',
      phone: config.topBar?.phone || '',
      whatsapp: config.topBar?.whatsapp || '',
      schedule: 'Lunes a Viernes de 09:00 a 18:00 hs',
      is_active: true
    };
    setConfig({
      ...config,
      locationSection: {
        ...(config.locationSection || DEFAULT_LANDING_CONFIG.locationSection),
        locations: [...currentLocs, newLoc]
      }
    });
  };

  const handleDeleteLocation = (index) => {
    const currentLocs = [...(config.locationSection?.locations || DEFAULT_LANDING_CONFIG.locationSection.locations || [])];
    const updatedLocs = currentLocs.filter((_, i) => i !== index);
    setConfig({
      ...config,
      locationSection: {
        ...(config.locationSection || DEFAULT_LANDING_CONFIG.locationSection),
        locations: updatedLocs
      }
    });
  };

  const handleMoveLocation = (index, direction) => {
    const currentLocs = [...(config.locationSection?.locations || DEFAULT_LANDING_CONFIG.locationSection.locations || [])];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= currentLocs.length) return;
    const temp = currentLocs[index];
    currentLocs[index] = currentLocs[targetIndex];
    currentLocs[targetIndex] = temp;
    setConfig({
      ...config,
      locationSection: {
        ...(config.locationSection || DEFAULT_LANDING_CONFIG.locationSection),
        locations: currentLocs
      }
    });
  };

  // Handlers para Módulo de Descargas
  const handleDownloadSectionChange = (field, value) => {
    setConfig(prev => ({
      ...prev,
      downloadsSection: {
        ...(prev.downloadsSection || DEFAULT_LANDING_CONFIG.downloadsSection),
        [field]: value
      }
    }));
  };

  const handleDownloadItemChange = (index, field, value) => {
    const currentItems = [...(config.downloadsSection?.items || DEFAULT_LANDING_CONFIG.downloadsSection.items)];
    currentItems[index] = { ...currentItems[index], [field]: value };
    setConfig(prev => ({
      ...prev,
      downloadsSection: {
        ...(prev.downloadsSection || DEFAULT_LANDING_CONFIG.downloadsSection),
        items: currentItems
      }
    }));
  };

  const handleAddDownloadItem = () => {
    const currentItems = config.downloadsSection?.items || DEFAULT_LANDING_CONFIG.downloadsSection.items;
    const newItem = {
      id: `down-${Date.now()}`,
      title: 'Nuevo Documento / Lista de Precios',
      description: 'Descripción del documento, contenido o especificaciones.',
      category: 'Listas de Precios',
      fileUrl: '',
      fileFormat: 'PDF',
      fileSize: '',
      updatedAt: '2026',
      requiresAuth: false,
      is_active: true,
      order: currentItems.length + 1
    };
    setConfig(prev => ({
      ...prev,
      downloadsSection: {
        ...(prev.downloadsSection || DEFAULT_LANDING_CONFIG.downloadsSection),
        items: [newItem, ...currentItems]
      }
    }));
  };

  const handleDeleteDownloadItem = (index) => {
    const currentItems = config.downloadsSection?.items || DEFAULT_LANDING_CONFIG.downloadsSection.items;
    const updated = currentItems.filter((_, i) => i !== index);
    setConfig(prev => ({
      ...prev,
      downloadsSection: {
        ...(prev.downloadsSection || DEFAULT_LANDING_CONFIG.downloadsSection),
        items: updated
      }
    }));
  };

  const handleUploadDownloadFile = async (e, index) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('image', file);
    formData.append('target_type', 'downloads');
    formData.append('company_id', selectedCompanyId);

    setUploadingImage(true);
    try {
      const res = await axios.post('/api/landing/upload-file/', formData, {
        headers: { 'Content-Type': 'multipart/form-data', 'X-Company-ID': String(selectedCompanyId) }
      });
      const fileUrl = res.data?.relative_url || res.data?.url || '';
      const fileFormat = res.data?.format || (file.name.split('.').pop() || '').toUpperCase();
      const fileSize = res.data?.file_size || `${(file.size / (1024 * 1024)).toFixed(1)} MB`;

      const currentItems = [...(config.downloadsSection?.items || DEFAULT_LANDING_CONFIG.downloadsSection.items)];
      currentItems[index] = {
        ...currentItems[index],
        fileUrl,
        fileFormat,
        fileSize
      };

      setConfig(prev => ({
        ...prev,
        downloadsSection: {
          ...(prev.downloadsSection || DEFAULT_LANDING_CONFIG.downloadsSection),
          items: currentItems
        }
      }));

      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: `¡Archivo subido (${fileFormat})!`,
        showConfirmButton: false,
        timer: 2000
      });
    } catch (err) {
      console.error('Error al subir archivo de descarga:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error de Carga',
        text: err.response?.data?.error || 'No se pudo subir el archivo.',
        confirmButtonColor: '#dc3545'
      });
    } finally {
      setUploadingImage(false);
    }
  };

  // Handlers para Orden y Visibilidad de Secciones del Inicio
  const currentHomeSections = useMemo(() => {
    const list = config.homeSections;
    if (!Array.isArray(list) || list.length === 0) {
      return DEFAULT_HOME_SECTIONS;
    }
    const result = [];
    list.forEach(sec => {
      const match = DEFAULT_HOME_SECTIONS.find(d => d.id === sec.id);
      if (match) {
        result.push({
          ...match,
          ...sec,
          name: match.name,
          icon: match.icon,
          tabKey: match.tabKey,
          description: match.description,
          enabled: sec.enabled !== undefined ? sec.enabled : true
        });
      }
    });
    DEFAULT_HOME_SECTIONS.forEach(defSec => {
      if (!result.some(r => r.id === defSec.id)) {
        result.push(defSec);
      }
    });
    return result;
  }, [config.homeSections]);

  const handleToggleHomeSection = (sectionId, enabled) => {
    const updated = currentHomeSections.map(s => s.id === sectionId ? { ...s, enabled } : s);
    setConfig(prev => ({
      ...prev,
      homeSections: updated
    }));
  };

  const handleSectionBgChange = (sectionId, backgroundColor) => {
    const updated = currentHomeSections.map(s => s.id === sectionId ? { ...s, backgroundColor } : s);
    setConfig(prev => {
      const next = {
        ...prev,
        homeSections: updated
      };
      if (sectionId === 'benefits') {
        next.benefitsSettings = { ...DEFAULT_BENEFITS_SETTINGS, ...(prev.benefitsSettings || {}), backgroundColor };
      } else if (sectionId === 'benefitsSecondary') {
        next.benefitsSecondarySettings = { ...DEFAULT_BENEFITS_SETTINGS, ...(prev.benefitsSecondarySettings || {}), backgroundColor };
      }
      return next;
    });
  };

  const handleSectionFontChange = (sectionId, fontFamily) => {
    const updated = currentHomeSections.map(s => s.id === sectionId ? { ...s, fontFamily } : s);
    setConfig(prev => ({
      ...prev,
      homeSections: updated
    }));
  };

  const handleSectionPaddingChange = (sectionId, paddingY) => {
    const updated = currentHomeSections.map(s => s.id === sectionId ? { ...s, paddingY } : s);
    setConfig(prev => ({
      ...prev,
      homeSections: updated
    }));
  };

  const handleSectionTitleSizeChange = (sectionId, titleFontSize) => {
    const updated = currentHomeSections.map(s => s.id === sectionId ? { ...s, titleFontSize } : s);
    setConfig(prev => ({
      ...prev,
      homeSections: updated
    }));
  };

  const handleSectionSubtitleSizeChange = (sectionId, subtitleFontSize) => {
    const updated = currentHomeSections.map(s => s.id === sectionId ? { ...s, subtitleFontSize } : s);
    setConfig(prev => ({
      ...prev,
      homeSections: updated
    }));
  };

  const handleMoveHomeSection = (index, direction) => {
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    if (targetIndex < 0 || targetIndex >= currentHomeSections.length) return;

    const updated = [...currentHomeSections];
    const [moved] = updated.splice(index, 1);
    updated.splice(targetIndex, 0, moved);

    setConfig(prev => ({
      ...prev,
      homeSections: updated
    }));
  };

  // Drag and drop handlers para secciones
  const handleSectionDragStart = (e, index) => {
    setDraggedSectionIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    try {
      e.dataTransfer.setData('text/plain', String(index));
    } catch (err) {}
  };

  const handleSectionDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    if (dragOverSectionIndex !== index) {
      setDragOverSectionIndex(index);
    }
  };

  const handleSectionDragLeave = (e) => {
    e.preventDefault();
  };

  const handleSectionDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedSectionIndex === null || draggedSectionIndex === dropIndex) {
      setDraggedSectionIndex(null);
      setDragOverSectionIndex(null);
      return;
    }

    const updated = [...currentHomeSections];
    const [moved] = updated.splice(draggedSectionIndex, 1);
    updated.splice(dropIndex, 0, moved);

    setConfig(prev => ({
      ...prev,
      homeSections: updated
    }));

    setDraggedSectionIndex(null);
    setDragOverSectionIndex(null);
  };

  const handleSectionDragEnd = () => {
    setDraggedSectionIndex(null);
    setDragOverSectionIndex(null);
  };

  const handleResetHomeSections = () => {
    setConfig(prev => ({
      ...prev,
      homeSections: DEFAULT_HOME_SECTIONS
    }));
    Swal.fire({
      toast: true,
      position: 'top',
      icon: 'success',
      title: 'Estructura restablecida al orden predeterminado',
      showConfirmButton: false,
      timer: 1800
    });
  };

  // Handlers para Menú Superior de Navegación (Navbar)
  const currentNavbarItems = useMemo(() => {
    const list = config.navbarItems;
    if (!Array.isArray(list) || list.length === 0) {
      return DEFAULT_NAVBAR_ITEMS;
    }
    const result = [];
    list.forEach(item => {
      const match = DEFAULT_NAVBAR_ITEMS.find(d => d.id === item.id);
      if (match) {
        result.push({
          ...match,
          ...item,
          icon: item.icon || match.icon,
          path: item.path || match.path,
          description: item.description || match.description,
          label: item.label || match.label,
          enabled: item.enabled !== undefined ? item.enabled : true
        });
      } else if (item && item.id) {
        result.push({
          ...item,
          icon: item.icon || 'bi-link-45deg',
          path: item.path || '/',
          description: item.description || 'Acceso personalizado de la barra superior',
          label: item.label || 'NUEVO ACCESO',
          enabled: item.enabled !== undefined ? item.enabled : true,
          isCustom: true
        });
      }
    });
    DEFAULT_NAVBAR_ITEMS.forEach(defItem => {
      if (!result.some(r => r.id === defItem.id)) {
        result.push(defItem);
      }
    });
    return result;
  }, [config.navbarItems]);

  const handleToggleNavbarItem = (itemId, enabled) => {
    const updated = currentNavbarItems.map(item => item.id === itemId ? { ...item, enabled } : item);
    setConfig(prev => ({
      ...prev,
      navbarItems: updated
    }));
  };

  const handleNavbarItemLabelChange = (itemId, label) => {
    const updated = currentNavbarItems.map(item => item.id === itemId ? { ...item, label } : item);
    setConfig(prev => ({
      ...prev,
      navbarItems: updated
    }));
  };

  const handleNavbarItemPathChange = (itemId, path) => {
    const updated = currentNavbarItems.map(item => item.id === itemId ? { ...item, path } : item);
    setConfig(prev => ({
      ...prev,
      navbarItems: updated
    }));
  };

  const handleMoveNavbarItem = (index, direction) => {
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= currentNavbarItems.length) return;
    const updated = [...currentNavbarItems];
    const [moved] = updated.splice(index, 1);
    updated.splice(targetIndex, 0, moved);
    setConfig(prev => ({
      ...prev,
      navbarItems: updated
    }));
  };

  const handleMoveVisibleNavbarItem = (visibleIdx, direction) => {
    const visibleItems = currentNavbarItems
      .map((item, originalIdx) => ({ ...item, originalIdx }))
      .filter(i => i.enabled);
    const targetVisibleIdx = visibleIdx + direction;
    if (targetVisibleIdx < 0 || targetVisibleIdx >= visibleItems.length) return;
    const fromOriginalIdx = visibleItems[visibleIdx].originalIdx;
    const toOriginalIdx = visibleItems[targetVisibleIdx].originalIdx;
    const updated = [...currentNavbarItems];
    const [moved] = updated.splice(fromOriginalIdx, 1);
    updated.splice(toOriginalIdx, 0, moved);
    setConfig(prev => ({
      ...prev,
      navbarItems: updated
    }));
  };

  const handleNavDragStart = (e, index) => {
    setDraggedNavIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    try {
      e.dataTransfer.setData('text/plain', String(index));
    } catch (err) {}
  };

  const handleNavDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    if (dragOverNavIndex !== index) {
      setDragOverNavIndex(index);
    }
  };

  const handleNavDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedNavIndex === null || draggedNavIndex === dropIndex) {
      setDraggedNavIndex(null);
      setDragOverNavIndex(null);
      return;
    }
    const updated = [...currentNavbarItems];
    const [moved] = updated.splice(draggedNavIndex, 1);
    updated.splice(dropIndex, 0, moved);
    setConfig(prev => ({
      ...prev,
      navbarItems: updated
    }));
    setDraggedNavIndex(null);
    setDragOverNavIndex(null);
  };

  const handleNavDragEnd = () => {
    setDraggedNavIndex(null);
    setDragOverNavIndex(null);
  };

  const handleAddCustomNavbarItem = () => {
    const newItem = {
      id: `nav-custom-${Date.now()}`,
      label: 'NUEVO ENLACE',
      path: '/tienda',
      description: 'Enlace personalizado en la barra superior',
      icon: 'bi-link-45deg',
      enabled: true,
      isCustom: true
    };
    setConfig(prev => ({
      ...prev,
      navbarItems: [...currentNavbarItems, newItem]
    }));
  };

  const handleDeleteCustomNavbarItem = (itemId) => {
    setConfig(prev => ({
      ...prev,
      navbarItems: currentNavbarItems.filter(item => item.id !== itemId)
    }));
  };

  const handleResetNavbarItems = () => {
    setConfig(prev => ({
      ...prev,
      navbarItems: DEFAULT_NAVBAR_ITEMS
    }));
    Swal.fire({
      toast: true,
      position: 'top',
      icon: 'success',
      title: 'Menú superior restablecido al predeterminado',
      showConfirmButton: false,
      timer: 1800
    });
  };

  // Cambio de pestaña con auto-scroll / auto-enfoque centrado
  const handleTabSelect = (tabKey, e) => {
    setActiveTab(tabKey);
    const tabObj = ADMIN_MODULE_TABS.find(t => t.id === tabKey);
    if (tabObj && moduleFilterGroup !== 'all' && tabObj.group !== moduleFilterGroup) {
      setModuleFilterGroup('all');
    }
    if (e && e.currentTarget) {
      e.currentTarget.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  };

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
        <p className="mt-3 text-muted">Cargando panel de configuración de la página web...</p>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4 px-lg-5 bg-light min-vh-100 position-relative pb-5">
      
      {/* Encabezado del Panel */}
      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-4 gap-3 bg-white p-4 rounded-4 border shadow-sm">
        <div>
          <div className="d-flex align-items-center gap-2 mb-1">
            <span className="badge bg-primary-subtle text-primary fw-bold text-uppercase px-3 py-1 rounded-pill">
              Gestor Integral de Contenidos Web
            </span>
            <span className="badge bg-light text-dark border font-monospace">Portada + Subpáginas</span>
          </div>
          <h2 className="fw-black text-dark mb-0 tracking-tight" style={{ fontWeight: 800 }}>
            Configuración de la Página Web Institucional
          </h2>
          <p className="text-muted mb-0 small">
            Gestioná los banners principales, accesos por rubro, catálogo destacado, publicaciones de novedades, información de la empresa, ubicación, descargas y contacto.
          </p>
        </div>

        <div className="d-flex align-items-center gap-3 w-100 w-md-auto flex-wrap">
          {/* Info de Empresa y Estado Web en SGES000 */}
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <span className="badge bg-light text-dark border px-3 py-2 rounded-pill fw-bold d-inline-flex align-items-center gap-1 shadow-xs">
              <i className="bi bi-building text-primary"></i>
              <span>{activeCompany?.nombre || `Empresa #${selectedCompanyId}`}</span>
            </span>

            {activeCompany?.l_sitien ? (
              <>
                <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill fw-semibold d-inline-flex align-items-center gap-1 shadow-xs">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>Web Habilitada</span>
                  {activeCompany?.d_sitien && (
                    <a 
                      href={activeCompany.d_sitien.startsWith('http') ? activeCompany.d_sitien : `https://${activeCompany.d_sitien}`}
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-success text-decoration-underline ms-1 fw-bold"
                    >
                      ({activeCompany.d_sitien}) <i className="bi bi-box-arrow-up-right"></i>
                    </a>
                  )}
                </span>

                <div
                  className={`form-check form-switch d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill border mb-0 shadow-xs ${
                    config.sitePublished !== false
                      ? 'bg-primary-subtle border-primary-subtle text-primary-emphasis'
                      : 'bg-warning-subtle border-warning-subtle text-warning-emphasis'
                  }`}
                  title="Definí si el sitio público muestra la web activa o el cartel de 'En Proceso de Habilitación'"
                >
                  <input
                    className="form-check-input ms-0 cursor-pointer"
                    type="checkbox"
                    role="switch"
                    id="sitePublishedSwitch"
                    checked={config.sitePublished !== false}
                    onChange={(e) => setConfig(prev => ({ ...prev, sitePublished: e.target.checked }))}
                  />
                  <label className="form-check-label small fw-bold cursor-pointer mb-0" htmlFor="sitePublishedSwitch">
                    {config.sitePublished !== false ? 'Sitio Publicado (Online)' : 'Modo En Habilitación'}
                  </label>
                </div>
              </>
            ) : (
              <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-2 rounded-pill fw-semibold d-inline-flex align-items-center gap-1 shadow-xs" title="Esta empresa no tiene el sitio web habilitado en la tabla SGES000 (l_sitien = No)">
                <i className="bi bi-exclamation-triangle-fill"></i>
                <span>Web Deshabilitada (l_sitien = No)</span>
              </span>
            )}
          </div>

          {/* Accesos de Previsualización */}
          <div className="btn-group shadow-xs">
            <a href={selectedCompanyId ? `/?company=${selectedCompanyId}` : '/'} target="_blank" rel="noreferrer" className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1" title="Abrir Portada en pestaña nueva">
              <i className="bi bi-box-arrow-up-right"></i> Ver Portada
            </a>
            <a href={selectedCompanyId ? `/descargas?company=${selectedCompanyId}` : '/descargas'} target="_blank" rel="noreferrer" className="btn btn-outline-secondary btn-sm d-none d-lg-flex align-items-center gap-1">
              Descargas
            </a>
            <a href={selectedCompanyId ? `/novedades?company=${selectedCompanyId}` : '/novedades'} target="_blank" rel="noreferrer" className="btn btn-outline-secondary btn-sm d-none d-lg-flex align-items-center gap-1">
              Novedades
            </a>
            <a href={selectedCompanyId ? `/empresa?company=${selectedCompanyId}` : '/empresa'} target="_blank" rel="noreferrer" className="btn btn-outline-secondary btn-sm d-none d-lg-flex align-items-center gap-1">
              Empresa
            </a>
          </div>

          <button
            type="button"
            className="btn btn-primary fw-bold px-4 py-2 rounded-pill shadow-sm d-flex align-items-center gap-2"
            onClick={handleSave}
            disabled={saving || uploadingImage}
          >
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span>Guardando...</span>
              </>
            ) : (
              <>
                <i className="bi bi-cloud-check-fill fs-5"></i>
                <span>Guardar Cambios</span>
              </>
            )}
          </button>
        </div>
      </div>

      {/* Aviso de Empresa sin Web Habilitada en SGES000 */}
      {activeCompany && activeCompany.l_sitien === false && (
        <div className="alert alert-warning border border-warning-subtle rounded-3 py-2 px-3 mb-4 d-flex align-items-center gap-2 shadow-xs" role="alert">
          <i className="bi bi-exclamation-triangle-fill text-warning fs-5"></i>
          <div className="small">
            <strong>Aviso:</strong> La empresa <strong>{activeCompany.nombre || `#${selectedCompanyId}`}</strong> figura con sitio web deshabilitado en la base de datos (campo <code>l_sitien = No</code> en <code>sges000</code>).
          </div>
        </div>
      )}

      {/* Selector de Grupo de Módulos para no perder el foco */}
      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 mb-3">
        <div className="d-flex flex-wrap align-items-center gap-2 p-1 bg-light rounded-4 border">
          <button
            type="button"
            className={`btn btn-sm rounded-pill px-3 py-1 fw-bold transition-all ${
              moduleFilterGroup === 'all' ? 'btn-white bg-white text-dark shadow-xs' : 'btn-link text-secondary text-decoration-none'
            }`}
            onClick={() => setModuleFilterGroup('all')}
          >
            Todos los Módulos (10)
          </button>
          <button
            type="button"
            className={`btn btn-sm rounded-pill px-3 py-1 fw-bold transition-all ${
              moduleFilterGroup === 'home' ? 'btn-white bg-white text-primary shadow-xs' : 'btn-link text-secondary text-decoration-none'
            }`}
            onClick={() => setModuleFilterGroup('home')}
          >
            <i className="bi bi-house-door me-1"></i> Inicio y Tienda (1 a 5)
          </button>
          <button
            type="button"
            className={`btn btn-sm rounded-pill px-3 py-1 fw-bold transition-all ${
              moduleFilterGroup === 'pages' ? 'btn-white bg-white text-dark shadow-xs' : 'btn-link text-secondary text-decoration-none'
            }`}
            onClick={() => setModuleFilterGroup('pages')}
          >
            <i className="bi bi-file-earmark-text me-1"></i> Páginas Web (6 a 9)
          </button>
          <button
            type="button"
            className={`btn btn-sm rounded-pill px-3 py-1 fw-bold transition-all ${
              moduleFilterGroup === 'design' ? 'btn-white bg-white text-dark shadow-xs' : 'btn-link text-secondary text-decoration-none'
            }`}
            onClick={() => setModuleFilterGroup('design')}
          >
            <i className="bi bi-palette me-1"></i> Diseño Global (10)
          </button>
        </div>

        <span className="text-muted small">
          Módulo activo: <strong className="text-dark">{ADMIN_MODULE_TABS.find(t => t.id === activeTab)?.label || activeTab}</strong>
        </span>
      </div>

      {/* Pestañas de Navegación del Panel (Numeradas del 1 al 10) */}
      <ul className="nav nav-pills gap-2 mb-4 bg-white p-2 rounded-4 border shadow-xs flex-nowrap" style={{ overflowX: 'auto', overflowY: 'hidden' }}>
        {ADMIN_MODULE_TABS
          .filter(tab => moduleFilterGroup === 'all' || tab.group === moduleFilterGroup)
          .map(tab => {
            const isActive = activeTab === tab.id;
            return (
              <li key={tab.id} className="nav-item">
                <button
                  type="button"
                  className={`nav-link text-nowrap rounded-pill fw-semibold px-3 py-2 d-inline-flex align-items-center ${
                    isActive ? 'active shadow-sm' : 'text-secondary'
                  }`}
                  onClick={(e) => handleTabSelect(tab.id, e)}
                >
                  <i className={`bi ${tab.icon} me-2 fs-6`}></i>
                  <span>{tab.label}</span>
                </button>
              </li>
            );
          })}
      </ul>

      {/* CONTENIDO DE PESTAÑAS */}

      {/* PESTAÑA 0: ORDEN & VISIBILIDAD DE SECCIONES DEL INICIO */}
      {activeTab === 'sections' && (
        <div className="row g-4">
          <div className="col-12 col-xl-8">
            <div className="card border-0 shadow-sm rounded-4 bg-white overflow-hidden mb-4">
              <div className="card-header bg-white py-3 px-4 border-0 d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2 border-bottom">
                <div className="d-flex align-items-center gap-2">
                  <div className="p-2 bg-primary-subtle text-primary rounded-3">
                    <i className="bi bi-layout-wtf fs-5"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold text-dark mb-0">Estructura y Orden de la Página de Inicio</h5>
                    <small className="text-muted">Activá, ocultá y ordená las secciones de la portada exactamente como quieras que aparezcan.</small>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary rounded-pill px-3 d-flex align-items-center gap-2 fw-semibold"
                  onClick={handleResetHomeSections}
                  title="Restablecer el orden predeterminado"
                >
                  <i className="bi bi-arrow-counterclockwise"></i> Restablecer Orden
                </button>
              </div>

              <div className="card-body p-4">
                <div className="alert alert-primary bg-primary-subtle border-0 text-primary-emphasis rounded-3 p-3 mb-4 d-flex align-items-center gap-3">
                  <i className="bi bi-info-circle-fill fs-4 flex-shrink-0 text-primary"></i>
                  <div className="small">
                    <strong>Personalización en Tiempo Real:</strong> Podés <strong>arrastrar y soltar (Drag & Drop)</strong> las tarjetas o usar las flechas <strong>Subir (▲)</strong> y <strong>Bajar (▼)</strong> para definir el orden exacto en la portada. Si desactivás el switch de una sección, quedará oculta para los visitantes sin perder su configuración.
                  </div>
                </div>

                <div className="d-flex flex-column gap-3">
                  {currentHomeSections.map((sec, idx) => {
                    const isFirst = idx === 0;
                    const isLast = idx === currentHomeSections.length - 1;
                    const isBeingDragged = draggedSectionIndex === idx;
                    const isDragOver = dragOverSectionIndex === idx && draggedSectionIndex !== idx;

                    return (
                      <div
                        key={sec.id}
                        draggable
                        onDragStart={(e) => handleSectionDragStart(e, idx)}
                        onDragOver={(e) => handleSectionDragOver(e, idx)}
                        onDragLeave={handleSectionDragLeave}
                        onDrop={(e) => handleSectionDrop(e, idx)}
                        onDragEnd={handleSectionDragEnd}
                        className={`p-3 p-md-3.5 rounded-4 border transition-all ${
                          isDragOver
                            ? 'bg-primary-subtle border-primary shadow-md'
                            : sec.enabled
                            ? 'bg-white shadow-xs border-primary-subtle'
                            : 'bg-light bg-opacity-75 opacity-75 border-secondary-subtle'
                        }`}
                        style={{
                          borderLeftWidth: sec.enabled ? '5px' : '1px',
                          borderLeftColor: isDragOver ? '#0d6efd' : (sec.enabled ? 'var(--bs-primary, #0d6efd)' : '#cbd5e1'),
                          opacity: isBeingDragged ? 0.35 : 1,
                          borderStyle: isBeingDragged ? 'dashed' : 'solid',
                          transform: isDragOver ? 'translateY(-2px)' : 'none',
                          cursor: 'grab'
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap flex-lg-nowrap">
                          
                          {/* Lado Izquierdo: Grip para Arrastrar, Número de Posición, Icono y Textos */}
                          <div className="d-flex align-items-center gap-3 flex-grow-1 min-w-0">
                            {/* Manija de Arrastre (Grip Handle) */}
                            <div 
                              className="d-flex align-items-center justify-content-center text-muted px-1 flex-shrink-0"
                              title="Hacé clic y arrastrá para mover de lugar"
                              style={{ cursor: 'grab' }}
                            >
                              <i className="bi bi-grip-vertical fs-4 text-secondary opacity-75"></i>
                            </div>

                            {/* Badge Número de Posición */}
                            <span className={`badge font-monospace px-3 py-2 rounded-3 fw-bold flex-shrink-0 ${
                              sec.enabled ? 'bg-primary-subtle text-primary border border-primary-subtle' : 'bg-light text-muted border'
                            }`} style={{ fontSize: '0.85rem' }}>
                              #{idx + 1}
                            </span>

                            {/* Contenedor de Icono */}
                            <div className={`p-3 rounded-3 d-flex align-items-center justify-content-center flex-shrink-0 ${
                              sec.enabled ? 'bg-primary text-white shadow-xs' : 'bg-light text-muted border'
                            }`} style={{ width: '42px', height: '42px', minWidth: '42px', fontSize: '1.25rem' }}>
                              <i className={`bi ${sec.icon || 'bi-layers'}`}></i>
                            </div>

                            {/* Textos de la Sección */}
                            <div className="flex-grow-1 min-w-0 ps-1">
                              <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                <h6 className={`fw-bold mb-0 ${sec.enabled ? 'text-dark' : 'text-muted'}`}>
                                  {sec.name}
                                </h6>
                                {sec.enabled ? (
                                  <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill small flex-shrink-0" style={{ fontSize: '0.72rem', padding: '0.2rem 0.6rem' }}>
                                    <i className="bi bi-eye-fill me-1"></i>Visible
                                  </span>
                                ) : (
                                  <span className="badge bg-secondary-subtle text-secondary border border-secondary-subtle rounded-pill small flex-shrink-0" style={{ fontSize: '0.72rem', padding: '0.2rem 0.6rem' }}>
                                    <i className="bi bi-eye-slash-fill me-1"></i>Oculta
                                  </span>
                                )}
                              </div>
                              <p className="text-muted small mb-0">
                                {sec.description}
                              </p>
                            </div>
                          </div>

                          {/* Lado Derecho: Acciones Principales y Botón para Estilo */}
                          <div className="d-flex align-items-center gap-2 ms-auto flex-shrink-0 flex-nowrap pt-2 pt-lg-0">
                            {/* Botón Personalizar Estilo del Bloque */}
                            <button
                              type="button"
                              className={`btn btn-sm rounded-pill px-3 py-1 fw-semibold d-flex align-items-center gap-2 transition-all ${
                                expandedStyleSectionId === sec.id 
                                  ? 'btn-dark text-white shadow-xs' 
                                  : 'btn-outline-secondary'
                              }`}
                              onClick={() => setExpandedStyleSectionId(expandedStyleSectionId === sec.id ? null : sec.id)}
                              title="Personalizar color de fondo, tipografía y márgenes de este módulo"
                              style={{ fontSize: '0.78rem' }}
                            >
                              <i className="bi bi-palette2"></i>
                              <span className="d-none d-sm-inline">Estilo & Fondo</span>
                              <i className={`bi bi-chevron-${expandedStyleSectionId === sec.id ? 'up' : 'down'} small`}></i>
                            </button>

                            {/* Botón rápido para ir a la pestaña que edita esta sección */}
                            {sec.tabKey && (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary rounded-pill px-3 py-1 fw-semibold text-nowrap d-flex align-items-center gap-2"
                                onClick={(e) => {
                                  if (sec.id === 'benefitsSecondary') {
                                    setSelectedBenefitsBar('secondary');
                                  } else if (sec.id === 'benefits') {
                                    setSelectedBenefitsBar('primary');
                                  }
                                  handleTabSelect(sec.tabKey, e);
                                }}
                                title={`Editar contenido de ${sec.name}`}
                                style={{ fontSize: '0.78rem' }}
                              >
                                <span>Contenido</span> <i className="bi bi-arrow-right small"></i>
                              </button>
                            )}

                            {/* Switch de Visibilidad */}
                            <div className="form-check form-switch m-0 d-flex align-items-center px-1" title={sec.enabled ? 'Ocultar sección' : 'Mostrar sección'}>
                              <input
                                className="form-check-input cursor-pointer m-0"
                                type="checkbox"
                                role="switch"
                                id={`switch-sec-${sec.id}`}
                                checked={sec.enabled}
                                onChange={(e) => handleToggleHomeSection(sec.id, e.target.checked)}
                                style={{ transform: 'scale(1.2)' }}
                              />
                            </div>

                            {/* Botones de Orden Alternativos (Flechas) */}
                            <div className="btn-group btn-group-sm shadow-2xs flex-nowrap" style={{ whiteSpace: 'nowrap' }}>
                              <button
                                type="button"
                                className="btn btn-light border"
                                onClick={() => handleMoveHomeSection(idx, 'up')}
                                disabled={isFirst}
                                title="Mover sección hacia arriba"
                              >
                                <i className="bi bi-chevron-up"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-light border"
                                onClick={() => handleMoveHomeSection(idx, 'down')}
                                disabled={isLast}
                                title="Mover sección hacia abajo"
                              >
                                <i className="bi bi-chevron-down"></i>
                              </button>
                            </div>
                          </div>

                        </div>

                        {/* Panel Plegable de Estilos Específicos del Módulo */}
                        {expandedStyleSectionId === sec.id && (
                          <div className="mt-3 pt-3 border-top bg-light bg-opacity-75 p-3 rounded-3">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <span className="small fw-bold text-dark d-flex align-items-center gap-2">
                                <i className="bi bi-sliders text-primary"></i>
                                Personalización de Diseño para: <strong>{sec.name}</strong>
                              </span>
                              <button 
                                type="button" 
                                className="btn-close btn-close-sm" 
                                onClick={() => setExpandedStyleSectionId(null)}
                                title="Cerrar ajustes de estilo"
                              ></button>
                            </div>
                            <div className="row g-3">
                              {/* Color de Fondo */}
                              <div className="col-12 col-md-4">
                                <label className="form-label small fw-bold text-dark mb-1">
                                  <i className="bi bi-paint-bucket me-1 text-primary"></i> Color de Fondo
                                </label>
                                <div className="d-flex align-items-center gap-2">
                                  <input
                                    type="color"
                                    className="form-control form-control-color border rounded-3 p-1 cursor-pointer flex-shrink-0"
                                    style={{ width: '42px', height: '36px' }}
                                    value={sec.backgroundColor || (sec.id === 'benefits' || sec.id === 'featuredProducts' || sec.id === 'institutional' ? '#ffffff' : '#f8fafc')}
                                    onChange={(e) => handleSectionBgChange(sec.id, e.target.value)}
                                  />
                                  <input
                                    type="text"
                                    className="form-control form-control-sm font-monospace fw-semibold"
                                    value={sec.backgroundColor || (sec.id === 'benefits' || sec.id === 'featuredProducts' || sec.id === 'institutional' ? '#ffffff' : '#f8fafc')}
                                    onChange={(e) => handleSectionBgChange(sec.id, e.target.value)}
                                    placeholder="#f8fafc"
                                  />
                                </div>
                                <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                                  Fondo de esta sección en la portada.
                                </small>
                              </div>

                              {/* Tipografía */}
                              <div className="col-12 col-md-4">
                                <label className="form-label small fw-bold text-dark mb-1">
                                  <i className="bi bi-fonts me-1 text-primary"></i> Tipografía Específica
                                </label>
                                <select
                                  className="form-select form-select-sm fw-semibold rounded-3"
                                  value={sec.fontFamily || 'inherit'}
                                  onChange={(e) => handleSectionFontChange(sec.id, e.target.value)}
                                >
                                  <option value="inherit">Heredar del sitio (Principal)</option>
                                  {AVAILABLE_FONTS.map(f => (
                                    <option key={f.id} value={f.id}>{f.name}</option>
                                  ))}
                                </select>
                                <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                                  Aplica a títulos y textos de este bloque.
                                </small>
                              </div>

                              {/* Espaciado / Padding */}
                              <div className="col-12 col-md-4">
                                <label className="form-label small fw-bold text-dark mb-1">
                                  <i className="bi bi-arrows-collapse me-1 text-primary"></i> Espaciado Vertical
                                </label>
                                <select
                                  className="form-select form-select-sm fw-semibold rounded-3"
                                  value={sec.paddingY || 'standard'}
                                  onChange={(e) => handleSectionPaddingChange(sec.id, e.target.value)}
                                >
                                  <option value="compact">Compacto (Menos margen)</option>
                                  <option value="standard">Estándar (Equilibrado)</option>
                                  <option value="spacious">Amplio (Mayor respiro)</option>
                                  <option value="none">Sin margen vertical</option>
                                </select>
                                <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                                  Separación superior e inferior del módulo.
                                </small>
                              </div>

                              {/* Tamaños de Letra del Módulo */}
                              {(sec.id === 'benefits' || sec.id === 'benefitsSecondary') ? (() => {
                                const isSecBar = sec.id === 'benefitsSecondary';
                                const sKey = isSecBar ? 'benefitsSecondarySettings' : 'benefitsSettings';
                                const bSet = { ...DEFAULT_BENEFITS_SETTINGS, ...(config[sKey] || {}) };
                                const updateBSet = (field, val) => {
                                  setConfig(prev => ({
                                    ...prev,
                                    [sKey]: {
                                      ...DEFAULT_BENEFITS_SETTINGS,
                                      ...(prev[sKey] || {}),
                                      [field]: val
                                    }
                                  }));
                                };
                                return (
                                  <div className="col-12 pt-2 border-top">
                                    <div className="row g-2">
                                      <div className="col-12 col-md-4">
                                        <div className="p-2.5 rounded-3 border bg-white h-100">
                                          <span className="badge bg-primary text-white rounded-pill mb-2" style={{ fontSize: '0.68rem' }}>
                                            Línea 1: Título Principal
                                          </span>
                                          <div className="mb-1.5">
                                            <label className="form-label text-muted fw-semibold mb-0.5" style={{ fontSize: '0.7rem' }}>Fuente:</label>
                                            <select
                                              className="form-select form-select-sm fw-semibold rounded-2"
                                              value={bSet.line1FontFamily || 'inherit'}
                                              onChange={(e) => updateBSet('line1FontFamily', e.target.value)}
                                            >
                                              <option value="inherit">Heredar de la barra</option>
                                              {AVAILABLE_FONTS.map(f => (
                                                <option key={f.id} value={f.id}>{f.name}</option>
                                              ))}
                                            </select>
                                          </div>
                                          <div>
                                            <label className="form-label text-muted fw-semibold mb-0.5" style={{ fontSize: '0.7rem' }}>Tamaño:</label>
                                            <select
                                              className="form-select form-select-sm fw-semibold rounded-2"
                                              value={bSet.line1FontSize || 'md'}
                                              onChange={(e) => updateBSet('line1FontSize', e.target.value)}
                                            >
                                              <option value="xs">Muy Chico (0.75rem)</option>
                                              <option value="sm">Chico (0.84rem)</option>
                                              <option value="md">Mediano (0.95rem)</option>
                                              <option value="lg">Grande (1.10rem)</option>
                                              <option value="xl">Extra Grande (1.25rem)</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-12 col-md-4">
                                        <div className="p-2.5 rounded-3 border bg-white h-100">
                                          <span className="badge bg-secondary text-white rounded-pill mb-2" style={{ fontSize: '0.68rem' }}>
                                            Línea 2: Bajada / Descripción
                                          </span>
                                          <div className="mb-1.5">
                                            <label className="form-label text-muted fw-semibold mb-0.5" style={{ fontSize: '0.7rem' }}>Fuente:</label>
                                            <select
                                              className="form-select form-select-sm fw-semibold rounded-2"
                                              value={bSet.line2FontFamily || 'inherit'}
                                              onChange={(e) => updateBSet('line2FontFamily', e.target.value)}
                                            >
                                              <option value="inherit">Heredar de la barra</option>
                                              {AVAILABLE_FONTS.map(f => (
                                                <option key={f.id} value={f.id}>{f.name}</option>
                                              ))}
                                            </select>
                                          </div>
                                          <div>
                                            <label className="form-label text-muted fw-semibold mb-0.5" style={{ fontSize: '0.7rem' }}>Tamaño:</label>
                                            <select
                                              className="form-select form-select-sm fw-semibold rounded-2"
                                              value={bSet.line2FontSize || 'sm'}
                                              onChange={(e) => updateBSet('line2FontSize', e.target.value)}
                                            >
                                              <option value="2xs">Extra Chico (0.68rem)</option>
                                              <option value="xs">Muy Chico (0.75rem)</option>
                                              <option value="sm">Chico (0.84rem)</option>
                                              <option value="md">Mediano (0.95rem)</option>
                                              <option value="lg">Grande (1.10rem)</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-12 col-md-4">
                                        <div className="p-2.5 rounded-3 border bg-white h-100">
                                          <span className="badge bg-success text-white rounded-pill mb-2" style={{ fontSize: '0.68rem' }}>
                                            Línea 3: Detalle Adicional
                                          </span>
                                          <div className="mb-1.5">
                                            <label className="form-label text-muted fw-semibold mb-0.5" style={{ fontSize: '0.7rem' }}>Fuente:</label>
                                            <select
                                              className="form-select form-select-sm fw-semibold rounded-2"
                                              value={bSet.line3FontFamily || 'inherit'}
                                              onChange={(e) => updateBSet('line3FontFamily', e.target.value)}
                                            >
                                              <option value="inherit">Heredar de la barra</option>
                                              {AVAILABLE_FONTS.map(f => (
                                                <option key={f.id} value={f.id}>{f.name}</option>
                                              ))}
                                            </select>
                                          </div>
                                          <div>
                                            <label className="form-label text-muted fw-semibold mb-0.5" style={{ fontSize: '0.7rem' }}>Tamaño:</label>
                                            <select
                                              className="form-select form-select-sm fw-semibold rounded-2"
                                              value={bSet.line3FontSize || 'xs'}
                                              onChange={(e) => updateBSet('line3FontSize', e.target.value)}
                                            >
                                              <option value="2xs">Extra Chico (0.68rem)</option>
                                              <option value="xs">Chico (0.75rem)</option>
                                              <option value="sm">Mediano (0.84rem)</option>
                                              <option value="md">Grande (0.95rem)</option>
                                              <option value="lg">Extra Grande (1.10rem)</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })() : (
                                <>
                                  <div className="col-12 col-md-6 pt-2 border-top">
                                    <label className="form-label small fw-bold text-dark mb-1">
                                      <i className="bi bi-type-h1 me-1 text-primary"></i> Tamaño de Título
                                    </label>
                                    <select
                                      className="form-select form-select-sm fw-semibold rounded-3"
                                      value={sec.titleFontSize || 'medium'}
                                      onChange={(e) => handleSectionTitleSizeChange(sec.id, e.target.value)}
                                    >
                                      <option value="small">Chico (Discreto)</option>
                                      <option value="medium">Mediano / Normal (Estándar)</option>
                                      <option value="large">Grande (Destacado)</option>
                                      <option value="xlarge">Extra Grande (Impactante)</option>
                                    </select>
                                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                                      Aplica al encabezado principal de esta sección.
                                    </small>
                                  </div>

                                  <div className="col-12 col-md-6 pt-2 border-top">
                                    <label className="form-label small fw-bold text-dark mb-1">
                                      <i className="bi bi-card-text me-1 text-primary"></i> Tamaño de Subtítulo / Descripción
                                    </label>
                                    <select
                                      className="form-select form-select-sm fw-semibold rounded-3"
                                      value={sec.subtitleFontSize || 'medium'}
                                      onChange={(e) => handleSectionSubtitleSizeChange(sec.id, e.target.value)}
                                    >
                                      <option value="small">Chico (Sutil)</option>
                                      <option value="medium">Mediano / Normal (Estándar)</option>
                                      <option value="large">Grande (Legible)</option>
                                    </select>
                                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                                      Aplica a bajadas y párrafos explicativos de este bloque.
                                    </small>
                                  </div>
                                </>
                              )}

                              {(sec.id === 'benefits' || sec.id === 'benefitsSecondary') && (
                                <div className="col-12 pt-3 border-top d-flex align-items-center justify-content-between flex-wrap gap-2">
                                  <span className="small text-muted">
                                    <i className="bi bi-info-circle me-1 text-primary"></i>
                                    Esta sección contiene <strong>{(sec.id === 'benefitsSecondary' ? (config.benefitsSecondary?.length || 4) : (config.benefits?.length || 4))} pilares</strong> configurados.
                                  </span>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm rounded-pill fw-bold px-3 py-1.5 shadow-xs d-inline-flex align-items-center gap-1.5"
                                    onClick={(e) => {
                                      setSelectedBenefitsBar(sec.id === 'benefitsSecondary' ? 'secondary' : 'primary');
                                      handleTabSelect('benefits', e);
                                    }}
                                  >
                                    <i className="bi bi-pencil-square"></i>
                                    <span>Editar Contenido y Cantidad de Pilares</span>
                                    <i className="bi bi-arrow-right small"></i>
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Columna Lateral Derecha: Resumen Visual y Mapa de Portada */}
          <div className="col-12 col-xl-4">
            <div className="card border-0 shadow-sm rounded-4 bg-white overflow-hidden sticky-top" style={{ top: '1.5rem', zIndex: 10 }}>
              <div className="card-header bg-white py-3 px-4 border-0 border-bottom d-flex align-items-center justify-content-between">
                <h6 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                  <i className="bi bi-phone text-primary"></i>
                  <span>Vista Previa del Esquema</span>
                </h6>
                <span className="badge bg-primary text-white rounded-pill font-monospace">
                  {currentHomeSections.filter(s => s.enabled).length} de {currentHomeSections.length} Activas
                </span>
              </div>

              <div className="card-body p-4">
                <p className="text-muted small mb-3">
                  Así se ordenará la página de inicio desde arriba hacia abajo para cualquier visitante:
                </p>

                <div className="position-relative ps-4 d-flex flex-column gap-3">
                  {/* Línea vertical de conexión */}
                  <div
                    className="position-absolute start-0 top-0 bottom-0 ms-2 bg-primary bg-opacity-25"
                    style={{ width: '2px' }}
                  />

                  {/* Header fijo */}
                  <div className="p-2 px-3 rounded-3 bg-dark text-white small fw-bold d-flex align-items-center justify-content-between shadow-2xs">
                    <span><i className="bi bi-window-dock me-2"></i> Cabecera & Menú Superior</span>
                    <span className="badge bg-light text-dark small" style={{ fontSize: '0.65rem' }}>Fijo</span>
                  </div>

                  {/* Secciones dinámicas ordenadas */}
                  {currentHomeSections.map((sec, idx) => (
                    <div
                      key={`preview-${sec.id}`}
                      className={`p-2 px-3 rounded-3 border d-flex align-items-center justify-content-between small transition-all ${
                        sec.enabled
                          ? 'bg-white text-dark shadow-2xs border-primary-subtle'
                          : 'bg-light text-muted opacity-50 text-decoration-line-through'
                      }`}
                    >
                      <div className="d-flex align-items-center gap-2 text-truncate">
                        <span className="badge bg-light text-muted border font-monospace" style={{ fontSize: '0.65rem' }}>
                          #{idx + 1}
                        </span>
                        <i className={`bi ${sec.icon} ${sec.enabled ? 'text-primary' : 'text-muted'}`}></i>
                        <span className="fw-semibold text-truncate">{sec.name}</span>
                      </div>
                      {sec.enabled ? (
                        <i className="bi bi-check-circle-fill text-success small ms-2 flex-shrink-0"></i>
                      ) : (
                        <i className="bi bi-x-circle text-muted small ms-2 flex-shrink-0"></i>
                      )}
                    </div>
                  ))}

                  {/* Footer fijo */}
                  <div className="p-2 px-3 rounded-3 bg-dark text-white small fw-bold d-flex align-items-center justify-content-between shadow-2xs">
                    <span><i className="bi bi-layout-sidebar-inset-reverse me-2"></i> Pie de Página (Footer)</span>
                    <span className="badge bg-light text-dark small" style={{ fontSize: '0.65rem' }}>Fijo</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PESTAÑA 1: LOGO, IDENTIDAD & HERO CAROUSEL UNIFICADO */}
      {activeTab === 'hero' && (
        <div className="d-flex flex-column gap-4">
          
          {/* TARJETA 1: LOGOTIPO E IDENTIDAD DE MARCA */}
          <div className="card border-0 shadow-sm rounded-4 bg-white overflow-hidden">
            <div className="card-header bg-white py-3 px-4 border-0 d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2">
              <div className="d-flex align-items-center gap-2">
                <div className="p-2 bg-primary-subtle text-primary rounded-3">
                  <i className="bi bi-shield-check fs-5"></i>
                </div>
                <div>
                  <h5 className="fw-bold text-dark mb-0">Identidad de Marca, Logotipo y Nombre Oficial</h5>
                  <small className="text-muted">Personalizá el logotipo de la empresa, nombre visible y lema institucional para la cabecera y pie de página.</small>
                </div>
              </div>
              <span className="badge bg-light text-dark border rounded-pill px-3 py-2 small font-monospace">
                Cabecera & Pie de Página
              </span>
            </div>

            <div className="card-body p-4 pt-2">
              <div className="row g-4 align-items-center">
                
                {/* Visualizador / Preview del Logo */}
                <div className="col-12 col-md-3 text-center">
                  <label className="form-label fw-bold text-dark small mb-2 d-block">Logotipo Actual</label>
                  <div 
                    className="p-3 bg-light rounded-4 border d-flex flex-column align-items-center justify-content-center mx-auto"
                    style={{ minHeight: '110px', maxWidth: '240px' }}
                  >
                    <LogoPreviewImage url={config.logoUrl} alt={config.logoText} />
                  </div>
                  {config.logoUrl && (
                    <button
                      type="button"
                      className="btn btn-link btn-sm text-danger text-decoration-none mt-1 p-0"
                      onClick={() => setConfig(prev => ({ ...prev, logoUrl: '' }))}
                    >
                      <i className="bi bi-trash3 me-1"></i> Quitar imagen
                    </button>
                  )}

                  {/* Vista Previa de Cabecera en miniatura */}
                  <div className="mt-2.5 p-2 bg-white rounded-3 border d-inline-flex align-items-center gap-2 shadow-2xs">
                    {config.logoUrl ? (
                      <img 
                        src={config.logoUrl} 
                        alt="Logo" 
                        style={{ height: '22px', width: 'auto', objectFit: 'contain' }} 
                        onError={(e) => { e.target.style.display = 'none'; }} 
                      />
                    ) : (
                      <div className="bg-primary text-white rounded-1 d-flex align-items-center justify-content-center fw-bold" style={{ width: '22px', height: '22px', fontSize: '0.75rem' }}>
                        {config.logoText ? config.logoText.charAt(0).toUpperCase() : <i className="bi bi-building"></i>}
                      </div>
                    )}
                    {(config.showLogoText !== false || (config.showLogoSubtitle !== false && config.logoSubtitle)) && (
                      <div className="d-flex flex-column lh-1 text-start">
                        {config.showLogoText !== false && (
                          <span className="fw-bold text-primary" style={{ fontSize: '0.78rem', letterSpacing: '-0.2px' }}>
                            {config.logoText || 'SISGECOM'}
                          </span>
                        )}
                        {config.showLogoSubtitle !== false && config.logoSubtitle && (
                          <span className="text-muted" style={{ fontSize: '0.6rem', letterSpacing: '0.5px' }}>
                            {config.logoSubtitle}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Campos de Configuración */}
                <div className="col-12 col-md-9">
                  <div className="row g-3">
                    
                    {/* Subir Archivo de Logo y URL */}
                    <div className="col-12 col-lg-7">
                      <label className="form-label fw-semibold small text-dark mb-1">
                        Subir Imagen de Logotipo (PNG, SVG, JPG, WEBP)
                      </label>
                      <div className="input-group">
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          accept="image/*"
                          onChange={(e) => handleUploadImage(e, (url) => {
                            setConfig(prev => ({ ...prev, logoUrl: url }));
                          }, 'logo')}
                          disabled={uploadingImage}
                        />
                        {uploadingImage && (
                          <span className="input-group-text bg-light">
                            <span className="spinner-border spinner-border-sm text-primary" role="status"></span>
                          </span>
                        )}
                      </div>
                      <div className="mt-1.5 d-flex align-items-center gap-2">
                        <input
                          type="text"
                          className="form-control form-control-sm font-monospace"
                          value={config.logoUrl || ''}
                          onChange={(e) => setConfig(prev => ({ ...prev, logoUrl: e.target.value }))}
                          placeholder="o pegá una URL directa (/images/logo.png o https://...)"
                          style={{ fontSize: '0.8rem' }}
                        />
                      </div>
                    </div>

                    {/* Nombre Oficial de la Empresa / Tienda */}
                    <div className="col-12 col-lg-5">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <label className="form-label fw-semibold small text-dark mb-0">
                          Nombre de la Tienda / Empresa
                        </label>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            role="switch"
                            id="showLogoTextSwitch"
                            checked={config.showLogoText !== false}
                            onChange={(e) => setConfig(prev => ({ ...prev, showLogoText: e.target.checked }))}
                          />
                          <label className="form-check-label small fw-semibold text-muted cursor-pointer" htmlFor="showLogoTextSwitch">
                            {config.showLogoText !== false ? 'Visible' : 'Oculto'}
                          </label>
                        </div>
                      </div>
                      <div className="input-group input-group-sm">
                        <span className="input-group-text bg-light border-end-0">
                          <i className="bi bi-building text-muted"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control fw-bold border-start-0"
                          value={config.logoText || ''}
                          onChange={(e) => setConfig(prev => ({ ...prev, logoText: e.target.value }))}
                          disabled={config.showLogoText === false}
                          placeholder="Ej: HIPERPEL S.A."
                        />
                      </div>
                      <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                        {config.showLogoText !== false 
                          ? 'Visible junto al logo en cabecera y en el pie.' 
                          : 'Oculto junto al logo (ideal si tu imagen de logo ya incluye el nombre de la empresa).'}
                      </small>
                    </div>

                    {/* Subtítulo bajo el Nombre / Logo (Ej: FÁBRICA & TIENDA OFICIAL) */}
                    <div className="col-12 col-lg-6">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <label className="form-label fw-semibold small text-dark mb-0">
                          Subtítulo bajo el Nombre (Cabecera y Pie)
                        </label>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            role="switch"
                            id="showLogoSubtitleSwitch"
                            checked={config.showLogoSubtitle !== false}
                            onChange={(e) => setConfig(prev => ({ ...prev, showLogoSubtitle: e.target.checked }))}
                          />
                          <label className="form-check-label small fw-semibold text-muted cursor-pointer" htmlFor="showLogoSubtitleSwitch">
                            {config.showLogoSubtitle !== false ? 'Visible' : 'Oculto'}
                          </label>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={config.logoSubtitle !== undefined ? config.logoSubtitle : 'FÁBRICA & TIENDA OFICIAL'}
                        onChange={(e) => setConfig(prev => ({ ...prev, logoSubtitle: e.target.value }))}
                        disabled={config.showLogoSubtitle === false}
                        placeholder="Ej: FÁBRICA & TIENDA OFICIAL (o dejá vacío para ocultar)"
                      />
                      <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                        Texto pequeño debajo del nombre de la empresa junto al logo. Podés modificarlo u ocultarlo.
                      </small>
                    </div>

                    {/* Slogan o Lema Comercial */}
                    <div className="col-12 col-lg-6">
                      <label className="form-label fw-semibold small text-dark mb-1">
                        Lema Comercial o Descripción Institucional
                      </label>
                      <textarea
                        className="form-control form-control-sm"
                        rows="2"
                        value={config.tagline !== undefined ? config.tagline : (config.footer?.tagline || '')}
                        onChange={(e) => {
                          const val = e.target.value;
                          setConfig(prev => ({
                            ...prev,
                            tagline: val,
                            footer: { ...(prev.footer || {}), tagline: val }
                          }));
                        }}
                        placeholder="Fabricantes de productos de cartón, envases, embalajes, descartables..."
                      ></textarea>
                      <small className="text-muted" style={{ fontSize: '0.72rem' }}>
                        Texto de presentación que acompaña al logotipo en el pie de página de todo el sitio web.
                      </small>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* TARJETA: MENÚ SUPERIOR DE NAVEGACIÓN (CABECERA / NAVBAR) */}
          <div className="card border-0 shadow-sm rounded-4 bg-white overflow-hidden">
            <div className="card-header bg-white py-3 px-4 border-0 d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2 border-bottom">
              <div className="d-flex align-items-center gap-2">
                <div className="p-2 bg-primary-subtle text-primary rounded-3">
                  <i className="bi bi-menu-button-wide-fill fs-5"></i>
                </div>
                <div>
                  <h5 className="fw-bold text-dark mb-0">Menú Superior de Navegación (Cabecera / Navbar)</h5>
                  <small className="text-muted">Activá, ocultá, cambiá el orden de aparición y personalizá los textos de los enlaces del menú superior.</small>
                </div>
              </div>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <button
                  type="button"
                  className="btn btn-sm btn-primary rounded-pill px-3 fw-bold d-flex align-items-center gap-1.5 shadow-2xs"
                  onClick={handleAddCustomNavbarItem}
                  title="Agregar un nuevo enlace personalizado a la barra superior"
                >
                  <i className="bi bi-plus-circle-fill"></i> Agregar Enlace
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary rounded-pill px-3 fw-semibold d-flex align-items-center gap-1"
                  onClick={handleResetNavbarItems}
                  title="Restablecer orden y enlaces predeterminados"
                >
                  <i className="bi bi-arrow-counterclockwise"></i> Restablecer Menú
                </button>
              </div>
            </div>

            <div className="card-body p-4">
              <div className="alert alert-primary bg-primary-subtle border-0 text-primary-emphasis rounded-3 p-3 mb-3 d-flex align-items-center gap-3">
                <i className="bi bi-arrows-move fs-4 flex-shrink-0 text-primary"></i>
                <div className="small">
                  <strong>Orden y Visibilidad del Menú Superior:</strong> Usá las flechas <span className="badge bg-white text-primary border px-1.5">&larr; &rarr;</span> o <strong>arrastrá y soltá</strong> cada tarjeta para definir el orden exacto de izquierda a derecha en la cabecera. Los accesos que no necesites podés ocultarlos con el interruptor.
                </div>
              </div>

              {/* Vista Previa en Vivo del Orden de la Barra Superior */}
              <div className="p-3 rounded-4 border bg-light mb-4">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2.5">
                  <span className="small fw-bold text-dark d-flex align-items-center gap-1.5">
                    <i className="bi bi-eye-fill text-primary"></i>
                    Vista Previa del Orden en la Barra Superior (arrastrá con el mouse o usá las flechas):
                  </span>
                  <span className="badge bg-primary-subtle text-primary rounded-pill px-2.5 py-1" style={{ fontSize: '0.74rem' }}>
                    {currentNavbarItems.filter(i => i.enabled).length} enlaces visibles
                  </span>
                </div>
                <div className="d-flex align-items-center gap-2.5 flex-wrap p-3 rounded-4 bg-white border shadow-2xs">
                  {currentNavbarItems.filter(i => i.enabled).length === 0 ? (
                    <span className="text-muted small fst-italic">No hay enlaces visibles activos en el menú superior.</span>
                  ) : (
                    (() => {
                      const visibleNavbarItems = currentNavbarItems
                        .map((item, originalIdx) => ({ ...item, originalIdx }))
                        .filter(i => i.enabled);
                      return visibleNavbarItems.map((item, visibleIdx) => {
                        const isDraggingThis = draggedNavIndex === item.originalIdx;
                        const isDragOverThis = dragOverNavIndex === item.originalIdx && draggedNavIndex !== item.originalIdx;
                        return (
                          <div
                            key={item.id}
                            draggable
                            onDragStart={(e) => handleNavDragStart(e, item.originalIdx)}
                            onDragOver={(e) => handleNavDragOver(e, item.originalIdx)}
                            onDrop={(e) => handleNavDrop(e, item.originalIdx)}
                            onDragEnd={handleNavDragEnd}
                            className={`d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill border fw-bold user-select-none transition-all ${
                              isDragOverThis
                                ? 'bg-primary-subtle border-primary border-2 shadow-sm'
                                : 'bg-light border-secondary-subtle text-dark shadow-2xs'
                            }`}
                            style={{
                              fontSize: '0.84rem',
                              cursor: 'grab',
                              opacity: isDraggingThis ? 0.5 : 1,
                              paddingLeft: '10px',
                              paddingRight: '10px'
                            }}
                            title="Arrastrá con el mouse para cambiar el orden"
                          >
                            <i className="bi bi-grip-vertical text-muted" style={{ fontSize: '0.95rem', marginLeft: '-2px', marginRight: '-2px' }}></i>
                            <span
                              className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-extrabold flex-shrink-0 shadow-2xs"
                              style={{
                                width: '24px',
                                height: '24px',
                                fontSize: '0.78rem',
                                lineHeight: 1
                              }}
                            >
                              {visibleIdx + 1}
                            </span>
                            <span className="px-1 text-nowrap" style={{ letterSpacing: '0.2px' }}>
                              {item.label}
                            </span>
                            <div className="d-inline-flex align-items-center gap-1 ms-1 ps-1.5 border-start">
                              <button
                                type="button"
                                className="btn btn-sm btn-white border rounded-circle d-inline-flex align-items-center justify-content-center p-0 text-secondary"
                                style={{ width: '22px', height: '22px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMoveVisibleNavbarItem(visibleIdx, -1);
                                }}
                                disabled={visibleIdx === 0}
                                title="Mover a la izquierda"
                              >
                                <i className="bi bi-chevron-left" style={{ fontSize: '0.7rem' }}></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-white border rounded-circle d-inline-flex align-items-center justify-content-center p-0 text-secondary"
                                style={{ width: '22px', height: '22px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMoveVisibleNavbarItem(visibleIdx, 1);
                                }}
                                disabled={visibleIdx === visibleNavbarItems.length - 1}
                                title="Mover a la derecha"
                              >
                                <i className="bi bi-chevron-right" style={{ fontSize: '0.7rem' }}></i>
                              </button>
                            </div>
                          </div>
                        );
                      });
                    })()
                  )}
                </div>
              </div>

              <div className="row g-3">
                {currentNavbarItems.map((item, idx) => {
                  const isCustomItem = Boolean(item.isCustom || !DEFAULT_NAVBAR_ITEMS.some(d => d.id === item.id));
                  return (
                    <div
                      key={item.id}
                      className="col-12 col-md-6 col-xl-4"
                      draggable
                      onDragStart={(e) => handleNavDragStart(e, idx)}
                      onDragOver={(e) => handleNavDragOver(e, idx)}
                      onDrop={(e) => handleNavDrop(e, idx)}
                      onDragEnd={handleNavDragEnd}
                    >
                      <div 
                        className={`p-3 rounded-4 border h-100 transition-all ${
                          item.enabled 
                            ? 'bg-white shadow-2xs border-primary-subtle' 
                            : 'bg-light bg-opacity-75 opacity-75 border-secondary-subtle'
                        } ${dragOverNavIndex === idx ? 'border-primary border-2 shadow' : ''}`}
                        style={{
                          borderLeftWidth: item.enabled ? '4px' : '1px',
                          borderLeftColor: item.enabled ? 'var(--bs-primary, #0d6efd)' : '#cbd5e1',
                          cursor: 'grab',
                          opacity: draggedNavIndex === idx ? 0.55 : 1
                        }}
                      >
                        {/* Cabecera de la tarjeta: Orden + Controles de Posición + Switch Visibilidad */}
                        <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom gap-2">
                          <div className="d-flex align-items-center gap-2">
                            <span className="text-muted cursor-grab" title="Arrastrar con el mouse para cambiar el orden">
                              <i className="bi bi-grip-vertical fs-5"></i>
                            </span>
                            <span
                              className={`d-inline-flex align-items-center justify-content-center rounded-pill font-monospace fw-bold px-2.5 py-1 shadow-2xs ${
                                item.enabled ? 'bg-primary text-white' : 'bg-secondary text-white'
                              }`}
                              style={{ fontSize: '0.78rem', minWidth: '34px', lineHeight: 1.1 }}
                              title={`Posición #${idx + 1} en la barra superior`}
                            >
                              #{idx + 1}
                            </span>
                            <div className="btn-group btn-group-sm ms-1">
                              <button
                                type="button"
                                className="btn btn-outline-secondary py-0 px-2"
                                onClick={() => handleMoveNavbarItem(idx, -1)}
                                disabled={idx === 0}
                                title="Mover antes (Hacia la izquierda en la barra)"
                                style={{ fontSize: '0.75rem' }}
                              >
                                <i className="bi bi-arrow-left"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-secondary py-0 px-2"
                                onClick={() => handleMoveNavbarItem(idx, 1)}
                                disabled={idx === currentNavbarItems.length - 1}
                                title="Mover después (Hacia la derecha en la barra)"
                                style={{ fontSize: '0.75rem' }}
                              >
                                <i className="bi bi-arrow-right"></i>
                              </button>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <span className={`badge rounded-pill ${item.enabled ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'}`} style={{ fontSize: '0.68rem' }}>
                              {item.enabled ? 'Visible' : 'Oculto'}
                            </span>
                            <div className="form-check form-switch mb-0">
                              <input
                                className="form-check-input cursor-pointer"
                                type="checkbox"
                                role="switch"
                                id={`navItemActive_${item.id}`}
                                checked={item.enabled}
                                onChange={(e) => handleToggleNavbarItem(item.id, e.target.checked)}
                                title={item.enabled ? 'Ocultar esta opción del menú' : 'Mostrar esta opción en el menú'}
                              />
                            </div>
                            {isCustomItem && (
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0"
                                style={{ width: '24px', height: '24px' }}
                                onClick={() => handleDeleteCustomNavbarItem(item.id)}
                                title="Eliminar enlace personalizado"
                              >
                                <i className="bi bi-trash3" style={{ fontSize: '0.7rem' }}></i>
                              </button>
                            )}
                          </div>
                        </div>

                        {/* Información del enlace */}
                        <div className="d-flex align-items-center gap-2 mb-2.5">
                          <div className={`p-2 rounded-2 d-flex align-items-center justify-content-center flex-shrink-0 ${
                            item.enabled ? 'bg-primary-subtle text-primary' : 'bg-light text-muted border'
                          }`} style={{ width: '32px', height: '32px', fontSize: '1rem' }}>
                            <i className={`bi ${item.icon || 'bi-link-45deg'}`}></i>
                          </div>
                          <div className="text-truncate">
                            <span className="fw-bold text-dark small d-block text-truncate">{item.label}</span>
                            <code className="text-muted" style={{ fontSize: '0.7rem' }}>{item.path}</code>
                          </div>
                        </div>

                        <div>
                          <label className="form-label text-muted small fw-semibold mb-1" style={{ fontSize: '0.74rem' }}>
                            Texto visible del botón:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm rounded-3 fw-bold"
                            value={item.label || ''}
                            onChange={(e) => handleNavbarItemLabelChange(item.id, e.target.value)}
                            placeholder={`Ej: ${item.label}`}
                            disabled={!item.enabled}
                          />
                          {isCustomItem ? (
                            <div className="mt-2">
                              <label className="form-label text-muted small fw-semibold mb-1" style={{ fontSize: '0.72rem' }}>
                                Ruta o URL de destino:
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm rounded-3 font-monospace"
                                value={item.path || ''}
                                onChange={(e) => handleNavbarItemPathChange(item.id, e.target.value)}
                                placeholder="Ej: /empresa, /tienda?rubro=1 o https://..."
                                disabled={!item.enabled}
                                style={{ fontSize: '0.74rem' }}
                              />
                            </div>
                          ) : (
                            <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                              {item.description}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* BARRA SECUNDARIA / MEGA-MENÚ COMERCIAL */}
          <SecondaryNavBarAdminPanel
            config={config}
            setConfig={setConfig}
            rubros={rubros}
            selectedCompanyId={selectedCompanyId}
          />

          {/* BANNERS Y CARRUSEL UNIFICADO */}
          <UnifiedBannersAdminSection
            banners={config.heroBanners || config.banners || []}
            carouselSettings={config.carouselSettings || {}}
            onBannersChange={(newBanners) => {
              setConfig(prev => ({
                ...prev,
                heroBanners: newBanners,
                banners: newBanners
              }));
            }}
            onCarouselSettingsChange={(field, value) => {
              setConfig(prev => ({
                ...prev,
                carouselSettings: {
                  ...(prev.carouselSettings || DEFAULT_LANDING_CONFIG.carouselSettings),
                  [field]: value
                }
              }));
            }}
            companyId={selectedCompanyId}
            showLivePreview={true}
          />
        </div>
      )}

      {/* PESTAÑA: BARRA DE BENEFICIOS (PILARES COMERCIALES 1 Y 2) */}
      {activeTab === 'benefits' && (
        <BenefitsAdminPanel
          config={config}
          setConfig={setConfig}
          onToggleHomeSection={handleToggleHomeSection}
          currentHomeSections={currentHomeSections}
          initialBar={selectedBenefitsBar}
        />
      )}

      {/* PESTAÑA 2: ACCESOS DIRECTOS POR RUBRO (CARDS DINÁMICAS) */}
      {activeTab === 'shortcuts' && (
        <div className="bg-white p-4 rounded-4 border shadow-sm">
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-4 pb-3 border-bottom gap-3">
            <div>
              <div className="d-flex align-items-center gap-2 mb-1">
                <span className="badge bg-primary-subtle text-primary fw-bold text-uppercase px-3 py-1 rounded-pill">
                  Líneas de Productos
                </span>
                <span className="badge bg-light text-muted border font-monospace">
                  {config.categoryShortcuts?.cards?.length || 0} {(config.categoryShortcuts?.cards?.length === 1) ? 'Tarjeta' : 'Tarjetas'}
                </span>
              </div>
              <h5 className="fw-bold text-dark mb-1">Accesos Directos por Categoría y Rubro</h5>
              <p className="text-muted small mb-0">
                Configurá las tarjetas destacadas que dirigen a los clientes directamente a los rubros principales. Podés agregar, quitar u ordenar tantas como necesites.
              </p>
            </div>

            <div className="d-flex align-items-center gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-success btn-sm rounded-pill fw-bold px-3 py-2 shadow-xs d-flex align-items-center gap-2"
                onClick={handleAddCard}
              >
                <i className="bi bi-plus-circle-fill me-1"></i>
                <span>Agregar Tarjeta</span>
              </button>

              <div className="form-check form-switch d-flex align-items-center gap-2 bg-light px-3 py-2 rounded-pill border mb-0">
                <input
                  className="form-check-input ms-0 cursor-pointer"
                  type="checkbox"
                  role="switch"
                  id="shortcutsSectionEnabled"
                  checked={config.categoryShortcuts?.enabled !== false}
                  onChange={(e) => setConfig({
                    ...config,
                    categoryShortcuts: { ...(config.categoryShortcuts || {}), enabled: e.target.checked }
                  })}
                />
                <label className="form-check-label small fw-bold text-dark cursor-pointer mb-0" htmlFor="shortcutsSectionEnabled">
                  {config.categoryShortcuts?.enabled !== false ? 'Sección Habilitada' : 'Sección Oculta'}
                </label>
              </div>
            </div>
          </div>

          {/* Encabezados globales de la sección */}
          <div className="row g-3 mb-4 p-3 bg-light rounded-4 border">
            <div className="col-12 col-md-6">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-fonts me-1 text-primary"></i> Título de la Sección en Portada
              </label>
              <input
                type="text"
                className="form-control form-control-sm fw-bold rounded-3"
                value={config.categoryShortcuts?.sectionTitle || ''}
                onChange={(e) => setConfig({
                  ...config,
                  categoryShortcuts: { ...(config.categoryShortcuts || {}), sectionTitle: e.target.value }
                })}
                placeholder="Ej. Líneas de Productos Destacadas"
              />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-card-text me-1 text-primary"></i> Subtítulo / Bajada
              </label>
              <input
                type="text"
                className="form-control form-control-sm rounded-3"
                value={config.categoryShortcuts?.sectionSubtitle || ''}
                onChange={(e) => setConfig({
                  ...config,
                  categoryShortcuts: { ...(config.categoryShortcuts || {}), sectionSubtitle: e.target.value }
                })}
                placeholder="Ej. Accedé de forma directa a nuestros rubros principales con stock disponible"
              />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-palette me-1 text-primary"></i> Color de Fondo de la Sección
              </label>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="color"
                  className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                  style={{ width: '40px', height: '32px' }}
                  value={config.categoryShortcuts?.backgroundColor || '#f8fafc'}
                  onChange={(e) => setConfig({
                    ...config,
                    categoryShortcuts: { ...(config.categoryShortcuts || {}), backgroundColor: e.target.value }
                  })}
                />
                <input
                  type="text"
                  className="form-control form-control-sm font-monospace"
                  style={{ maxWidth: '120px' }}
                  value={config.categoryShortcuts?.backgroundColor || '#f8fafc'}
                  onChange={(e) => setConfig({
                    ...config,
                    categoryShortcuts: { ...(config.categoryShortcuts || {}), backgroundColor: e.target.value }
                  })}
                />
              </div>
            </div>
            <div className="col-12 col-md-3">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-fonts me-1 text-primary"></i> Color del Título
              </label>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="color"
                  className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                  style={{ width: '38px', height: '32px' }}
                  value={config.categoryShortcuts?.sectionTitleColor || '#1e293b'}
                  onChange={(e) => setConfig({
                    ...config,
                    categoryShortcuts: { ...(config.categoryShortcuts || {}), sectionTitleColor: e.target.value }
                  })}
                />
                <input
                  type="text"
                  className="form-control form-control-sm font-monospace"
                  value={config.categoryShortcuts?.sectionTitleColor || '#1e293b'}
                  onChange={(e) => setConfig({
                    ...config,
                    categoryShortcuts: { ...(config.categoryShortcuts || {}), sectionTitleColor: e.target.value }
                  })}
                />
              </div>
            </div>
            <div className="col-12 col-md-3">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-card-text me-1 text-primary"></i> Color del Subtítulo
              </label>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="color"
                  className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                  style={{ width: '38px', height: '32px' }}
                  value={config.categoryShortcuts?.sectionSubtitleColor || '#64748b'}
                  onChange={(e) => setConfig({
                    ...config,
                    categoryShortcuts: { ...(config.categoryShortcuts || {}), sectionSubtitleColor: e.target.value }
                  })}
                />
                <input
                  type="text"
                  className="form-control form-control-sm font-monospace"
                  value={config.categoryShortcuts?.sectionSubtitleColor || '#64748b'}
                  onChange={(e) => setConfig({
                    ...config,
                    categoryShortcuts: { ...(config.categoryShortcuts || {}), sectionSubtitleColor: e.target.value }
                  })}
                />
              </div>
            </div>
            {/* SELECTOR PROMINENTE DE ESTILO DE TARJETAS */}
            <div className="col-12 mt-2 mb-2">
              <label className="form-label small fw-bold text-dark mb-2 d-flex align-items-center gap-2">
                <i className="bi bi-layout-text-window-reverse text-primary fs-6"></i>
                <span>Estilo de Diseño de las Tarjetas de Rubros (Elegí cómo querés que se vean)</span>
              </label>
              <div className="row g-3">
                {/* Opción 1: Ficha Catálogo con Franja Inferior */}
                <div className="col-12 col-md-6">
                  <div 
                    className={`p-3 rounded-4 border cursor-pointer h-100 transition-all ${
                      (config.categoryShortcuts?.cardStyle || 'strip') === 'strip' 
                        ? 'border-primary bg-primary bg-opacity-10 shadow-sm' 
                        : 'border-light-subtle bg-white hover-shadow-sm'
                    }`}
                    onClick={() => setConfig({
                      ...config,
                      categoryShortcuts: { ...(config.categoryShortcuts || {}), cardStyle: 'strip', showCardCta: false }
                    })}
                  >
                    <div className="d-flex align-items-start gap-2.5">
                      <div className="form-check mt-0.5">
                        <input 
                          className="form-check-input cursor-pointer" 
                          type="radio" 
                          name="cardStyleRadio"
                          id="cardStyleStrip"
                          checked={(config.categoryShortcuts?.cardStyle || 'strip') === 'strip'}
                          onChange={() => {}}
                        />
                      </div>
                      <div>
                        <label className="fw-bold mb-1 text-dark d-flex align-items-center gap-2 cursor-pointer" htmlFor="cardStyleStrip">
                          <span>Ficha Catálogo con Franja Inferior</span>
                          <span className="badge bg-success text-white" style={{ fontSize: '0.68rem' }}>Recomendado</span>
                        </label>
                        <p className="small text-muted mb-0" style={{ fontSize: '0.8rem', lineHeight: 1.35 }}>
                          Foto en recuadro neutro superior + franja blanca inferior con flecha <b>»</b> y descripción. Diseño uniforme de catálogo, sin botón redundante (toda la tarjeta redirige).
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Opción 2: Foto Completa con Texto Superpuesto */}
                <div className="col-12 col-md-6">
                  <div 
                    className={`p-3 rounded-4 border cursor-pointer h-100 transition-all ${
                      config.categoryShortcuts?.cardStyle === 'overlay' 
                        ? 'border-primary bg-primary bg-opacity-10 shadow-sm' 
                        : 'border-light-subtle bg-white hover-shadow-sm'
                    }`}
                    onClick={() => setConfig({
                      ...config,
                      categoryShortcuts: { ...(config.categoryShortcuts || {}), cardStyle: 'overlay' }
                    })}
                  >
                    <div className="d-flex align-items-start gap-2.5">
                      <div className="form-check mt-0.5">
                        <input 
                          className="form-check-input cursor-pointer" 
                          type="radio" 
                          name="cardStyleRadio"
                          id="cardStyleOverlay"
                          checked={config.categoryShortcuts?.cardStyle === 'overlay'}
                          onChange={() => {}}
                        />
                      </div>
                      <div>
                        <label className="fw-bold mb-1 text-dark cursor-pointer" htmlFor="cardStyleOverlay">
                          Foto Completa Superpuesta (Clásico)
                        </label>
                        <p className="small text-muted mb-0" style={{ fontSize: '0.8rem', lineHeight: 1.35 }}>
                          La imagen ocupa toda la tarjeta con degradé oscuro y los textos flotan adentro. Permite configurar sombras, degradés individuales y botón "Ver Artículos".
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Opciones Comunes: Columnas, Tipografía e Interlineado */}
            <div className="col-12 col-md-3">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-grid-fill me-1 text-primary"></i> Tarjetas por Fila
              </label>
              <div className="d-flex align-items-center p-1 bg-light rounded-pill border w-100">
                {[3, 4, 5, 6].map(num => {
                  const isSelected = (Number(config.categoryShortcuts?.columnsPerRow) || 4) === num;
                  return (
                    <button
                      key={num}
                      type="button"
                      className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                        isSelected 
                          ? 'btn-primary text-white shadow-xs' 
                          : 'btn-link text-secondary text-decoration-none'
                      }`}
                      style={{ padding: '0.35rem 0.25rem', fontSize: '0.78rem' }}
                      onClick={() => setConfig({
                        ...config,
                        categoryShortcuts: { ...(config.categoryShortcuts || {}), columnsPerRow: num }
                      })}
                    >
                      {num}
                    </button>
                  );
                })}
              </div>
              <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                Columnas en escritorio (3, 4, 5 o 6).
              </small>
            </div>

            <div className="col-12 col-md-3">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-fonts me-1 text-primary"></i> Tipografía de Rubros
              </label>
              <select
                className="form-select form-select-sm fw-semibold rounded-3"
                value={config.categoryShortcuts?.fontFamily || 'inherit'}
                onChange={(e) => setConfig({
                  ...config,
                  categoryShortcuts: { ...(config.categoryShortcuts || {}), fontFamily: e.target.value }
                })}
              >
                <option value="inherit">Heredar del sitio (Principal)</option>
                {AVAILABLE_FONTS.map(f => (
                  <option key={f.id} value={f.id}>{f.name}</option>
                ))}
              </select>
            </div>

            <div className="col-6 col-md-3">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-text-paragraph me-1 text-primary"></i> Interlineado Título
              </label>
              <select
                className="form-select form-select-sm fw-semibold rounded-3"
                value={config.categoryShortcuts?.cardTitleLineHeight || '1.25'}
                onChange={(e) => setConfig({
                  ...config,
                  categoryShortcuts: { ...(config.categoryShortcuts || {}), cardTitleLineHeight: e.target.value }
                })}
              >
                <option value="1.10">Muy compacto (1.10)</option>
                <option value="1.20">Compacto (1.20)</option>
                <option value="1.25">Normal (1.25 - Recomendado)</option>
                <option value="1.40">Holgado (1.40)</option>
                <option value="1.60">Amplio (1.60)</option>
              </select>
            </div>

            <div className="col-6 col-md-3">
              <label className="form-label small fw-bold text-dark mb-1">
                <i className="bi bi-text-paragraph me-1 text-primary"></i> Interlineado Subtítulo
              </label>
              <select
                className="form-select form-select-sm fw-semibold rounded-3"
                value={config.categoryShortcuts?.cardSubtitleLineHeight || '1.35'}
                onChange={(e) => setConfig({
                  ...config,
                  categoryShortcuts: { ...(config.categoryShortcuts || {}), cardSubtitleLineHeight: e.target.value }
                })}
              >
                <option value="1.15">Muy compacto (1.15)</option>
                <option value="1.25">Compacto (1.25)</option>
                <option value="1.35">Normal (1.35 - Recomendado)</option>
                <option value="1.50">Holgado (1.50)</option>
                <option value="1.70">Amplio (1.70)</option>
              </select>
            </div>

            {/* Opciones Específicas según el estilo seleccionado */}
            {(config.categoryShortcuts?.cardStyle || 'strip') === 'strip' ? (
              <>
                <div className="col-12 col-md-4">
                  <label className="form-label small fw-bold text-dark mb-1">
                    <i className="bi bi-aspect-ratio me-1 text-primary"></i> Tamaño del Recuadro de Foto
                  </label>
                  <select
                    className="form-select form-select-sm fw-semibold rounded-3"
                    value={config.categoryShortcuts?.cardHeight || 'large'}
                    onChange={(e) => setConfig({
                      ...config,
                      categoryShortcuts: { ...(config.categoryShortcuts || {}), cardHeight: e.target.value }
                    })}
                  >
                    <option value="large">Grande (165px foto - Destacado)</option>
                    <option value="normal">Estándar (145px foto)</option>
                  </select>
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label small fw-bold text-dark mb-1">
                    <i className="bi bi-arrows-fullscreen me-1 text-primary"></i> Ajuste de la Foto
                  </label>
                  <select
                    className="form-select form-select-sm fw-semibold rounded-3"
                    value={config.categoryShortcuts?.imageFit || 'cover'}
                    onChange={(e) => setConfig({
                      ...config,
                      categoryShortcuts: { ...(config.categoryShortcuts || {}), imageFit: e.target.value }
                    })}
                  >
                    <option value="cover">Llenar todo el recuadro (Cover - Sin bordes)</option>
                    <option value="contain">Centrado con margen (Contain)</option>
                  </select>
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label small fw-bold text-dark mb-1">
                    Color del símbolo »
                  </label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="color"
                      className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                      style={{ width: '38px', height: '31px' }}
                      value={config.categoryShortcuts?.chevronColor || '#16a34a'}
                      onChange={(e) => setConfig({
                        ...config,
                        categoryShortcuts: { ...(config.categoryShortcuts || {}), chevronColor: e.target.value }
                      })}
                    />
                    <input
                      type="text"
                      className="form-control form-control-sm font-monospace"
                      value={config.categoryShortcuts?.chevronColor || '#16a34a'}
                      onChange={(e) => setConfig({
                        ...config,
                        categoryShortcuts: { ...(config.categoryShortcuts || {}), chevronColor: e.target.value }
                      })}
                    />
                  </div>
                </div>
              </>
            ) : (
              /* Opciones exclusivas de Modo Clásico (Overlay) */
              <>
                <div className="col-12 col-md-6 d-flex align-items-center">
                  <div className="form-check form-switch pt-3">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id="catShortcutsGradientSwitch"
                      checked={config.categoryShortcuts?.showGradient !== false}
                      onChange={(e) => setConfig({
                        ...config,
                        categoryShortcuts: { ...(config.categoryShortcuts || {}), showGradient: e.target.checked }
                      })}
                    />
                    <label className="form-check-label small fw-bold text-dark cursor-pointer ms-1" htmlFor="catShortcutsGradientSwitch">
                      {config.categoryShortcuts?.showGradient !== false ? 'Degradé oscuro activo sobre fotos' : 'Sin degradé (fotos 100% nítidas)'}
                    </label>
                  </div>
                </div>

                {/* Opciones de Estilo de Textos en las Tarjetas de Rubros */}
                <div className="col-12 mt-3 pt-3 border-top">
                  <h6 className="fw-bold text-dark small mb-3 d-flex align-items-center gap-2">
                    <i className="bi bi-sliders text-primary"></i>
                    <span>Estilo General de Textos dentro de las Tarjetas de Rubros</span>
                    <span className="badge bg-white text-muted border fw-normal">Aplica a modo foto completa</span>
                  </h6>
                  <div className="row g-3">
                    <div className="col-12 col-md-3">
                      <label className="form-label small fw-bold text-dark mb-1">Color de Textos</label>
                      <select
                        className="form-select form-select-sm fw-semibold rounded-3"
                        value={config.categoryShortcuts?.cardTextColorTheme || 'light'}
                        onChange={(e) => setConfig({
                          ...config,
                          categoryShortcuts: { ...(config.categoryShortcuts || {}), cardTextColorTheme: e.target.value }
                        })}
                      >
                        <option value="light">Claro (Blanco + Amarillo)</option>
                        <option value="dark">Oscuro (Negro/Gris + Azul)</option>
                        <option value="custom">Colores Personalizados</option>
                      </select>
                    </div>

                    <div className="col-6 col-md-2">
                      <label className="form-label small fw-bold text-dark mb-1">Tamaño Título</label>
                      <select
                        className="form-select form-select-sm fw-semibold rounded-3"
                        value={config.categoryShortcuts?.cardTitleFontSize || 'md'}
                        onChange={(e) => setConfig({
                          ...config,
                          categoryShortcuts: { ...(config.categoryShortcuts || {}), cardTitleFontSize: e.target.value }
                        })}
                      >
                        <option value="sm">Pequeño</option>
                        <option value="md">Mediano (Normal)</option>
                        <option value="lg">Grande</option>
                        <option value="xl">Extra Grande</option>
                      </select>
                    </div>

                    <div className="col-6 col-md-2">
                      <label className="form-label small fw-bold text-dark mb-1">Tamaño Subtítulo</label>
                      <select
                        className="form-select form-select-sm fw-semibold rounded-3"
                        value={config.categoryShortcuts?.cardSubtitleFontSize || 'md'}
                        onChange={(e) => setConfig({
                          ...config,
                          categoryShortcuts: { ...(config.categoryShortcuts || {}), cardSubtitleFontSize: e.target.value }
                        })}
                      >
                        <option value="sm">Pequeño</option>
                        <option value="md">Mediano (Normal)</option>
                        <option value="lg">Grande</option>
                      </select>
                    </div>

                    <div className="col-6 col-md-2">
                      <label className="form-label small fw-bold text-dark mb-1">Alineación Horiz.</label>
                      <select
                        className="form-select form-select-sm fw-semibold rounded-3"
                        value={config.categoryShortcuts?.cardTextAlignment || 'left'}
                        onChange={(e) => setConfig({
                          ...config,
                          categoryShortcuts: { ...(config.categoryShortcuts || {}), cardTextAlignment: e.target.value }
                        })}
                      >
                        <option value="left">Izquierda</option>
                        <option value="center">Centro</option>
                        <option value="right">Derecha</option>
                      </select>
                    </div>

                    <div className="col-6 col-md-3">
                      <label className="form-label small fw-bold text-dark mb-1">Posición Vertical</label>
                      <select
                        className="form-select form-select-sm fw-semibold rounded-3"
                        value={config.categoryShortcuts?.cardVerticalAlignment || 'bottom'}
                        onChange={(e) => setConfig({
                          ...config,
                          categoryShortcuts: { ...(config.categoryShortcuts || {}), cardVerticalAlignment: e.target.value }
                        })}
                      >
                        <option value="bottom">Abajo (Pie de tarjeta)</option>
                        <option value="center">Centro</option>
                        <option value="top">Arriba</option>
                      </select>
                    </div>

                    <div className="col-6 col-md-3">
                      <label className="form-label small fw-bold text-dark mb-1">Grosor / Negrita Título</label>
                      <select
                        className="form-select form-select-sm fw-semibold rounded-3"
                        value={config.categoryShortcuts?.cardTitleFontWeight || 'bold'}
                        onChange={(e) => setConfig({
                          ...config,
                          categoryShortcuts: { ...(config.categoryShortcuts || {}), cardTitleFontWeight: e.target.value }
                        })}
                      >
                        <option value="normal">Normal (400)</option>
                        <option value="semibold">Semi-Negrita (600)</option>
                        <option value="bold">Negrita (700)</option>
                        <option value="extrabold">Extra-Negrita (800)</option>
                        <option value="black">Ultra-Negrita / Black (900)</option>
                      </select>
                    </div>

                    <div className="col-6 col-md-3">
                      <label className="form-label small fw-bold text-dark mb-1">Grosor / Negrita Subtítulo</label>
                      <select
                        className="form-select form-select-sm fw-semibold rounded-3"
                        value={config.categoryShortcuts?.cardSubtitleFontWeight || 'normal'}
                        onChange={(e) => setConfig({
                          ...config,
                          categoryShortcuts: { ...(config.categoryShortcuts || {}), cardSubtitleFontWeight: e.target.value }
                        })}
                      >
                        <option value="normal">Normal (400)</option>
                        <option value="medium">Medio (500)</option>
                        <option value="semibold">Semi-Negrita (600)</option>
                        <option value="bold">Negrita (700)</option>
                        <option value="extrabold">Extra-Negrita (800)</option>
                      </select>
                    </div>

                    {config.categoryShortcuts?.cardTextColorTheme === 'custom' && (
                      <>
                        <div className="col-12 col-sm-6">
                          <label className="form-label small fw-bold text-dark mb-1">Color del Título</label>
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="color"
                              className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                              style={{ width: '38px', height: '31px' }}
                              value={config.categoryShortcuts?.cardTitleColor || '#ffffff'}
                              onChange={(e) => setConfig({
                                ...config,
                                categoryShortcuts: { ...(config.categoryShortcuts || {}), cardTitleColor: e.target.value }
                              })}
                            />
                            <input
                              type="text"
                              className="form-control form-control-sm font-monospace"
                              value={config.categoryShortcuts?.cardTitleColor || '#ffffff'}
                              onChange={(e) => setConfig({
                                ...config,
                                categoryShortcuts: { ...(config.categoryShortcuts || {}), cardTitleColor: e.target.value }
                              })}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-6">
                          <label className="form-label small fw-bold text-dark mb-1">Color del Subtítulo</label>
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="color"
                              className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                              style={{ width: '38px', height: '31px' }}
                              value={config.categoryShortcuts?.cardSubtitleColor || '#f1f5f9'}
                              onChange={(e) => setConfig({
                                ...config,
                                categoryShortcuts: { ...(config.categoryShortcuts || {}), cardSubtitleColor: e.target.value }
                              })}
                            />
                            <input
                              type="text"
                              className="form-control form-control-sm font-monospace"
                              value={config.categoryShortcuts?.cardSubtitleColor || '#f1f5f9'}
                              onChange={(e) => setConfig({
                                ...config,
                                categoryShortcuts: { ...(config.categoryShortcuts || {}), cardSubtitleColor: e.target.value }
                              })}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    <div className="col-12 col-md-6">
                      <label className="form-label small fw-bold text-dark mb-1">Sombra de Textos (Legibilidad)</label>
                      <select
                        className="form-select form-select-sm fw-semibold rounded-3"
                        value={config.categoryShortcuts?.cardTextShadow || 'subtle'}
                        onChange={(e) => setConfig({
                          ...config,
                          categoryShortcuts: { ...(config.categoryShortcuts || {}), cardTextShadow: e.target.value }
                        })}
                      >
                        <option value="none">Sin sombra</option>
                        <option value="subtle">Sombra suave (Recomendado)</option>
                        <option value="strong">Sombra fuerte (Alto contraste)</option>
                      </select>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Listado de Tarjetas */}
          {(!config.categoryShortcuts?.cards || config.categoryShortcuts.cards.length === 0) ? (
            <div className="text-center py-5 border rounded-4 bg-light">
              <i className="bi bi-grid-3x3-gap text-muted fs-1 d-block mb-2"></i>
              <h6 className="fw-bold text-dark mb-1">No hay tarjetas de accesos directos configuradas</h6>
              <p className="text-muted small mb-3">Hacé click en el botón para añadir una nueva tarjeta para tu catálogo.</p>
              <button
                type="button"
                className="btn btn-primary btn-sm rounded-pill fw-bold px-4 py-2"
                onClick={handleAddCard}
              >
                <i className="bi bi-plus-circle-fill me-1"></i> Agregar Primera Tarjeta
              </button>
            </div>
          ) : (
            <div className="row g-4">
              {config.categoryShortcuts.cards.map((card, idx) => (
                <div key={card.id || idx} className="col-12 col-xl-6">
                  <div className="card border shadow-xs rounded-4 h-100 overflow-hidden bg-white">
                    {/* Card Header Bar con Controles */}
                    <div className="card-header bg-light bg-opacity-75 py-2 px-3 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
                      <div className="d-flex align-items-center gap-2">
                        {/* Botones de Reordenamiento */}
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                            onClick={() => handleMoveCard(idx, -1)}
                            disabled={idx === 0}
                            title="Mover antes"
                          >
                            <i className="bi bi-chevron-up"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                            onClick={() => handleMoveCard(idx, 1)}
                            disabled={idx === config.categoryShortcuts.cards.length - 1}
                            title="Mover después"
                          >
                            <i className="bi bi-chevron-down"></i>
                          </button>
                        </div>

                        <span className="badge bg-primary text-white fw-bold font-monospace px-3 py-1 rounded-pill">
                          Tarjeta #{idx + 1}
                        </span>
                        <span className="fw-bold text-dark small text-truncate" style={{ maxWidth: '160px' }}>
                          {card.title || 'Sin Título'}
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        {((config.categoryShortcuts?.cardStyle || 'strip') === 'overlay') && (
                          <div className="form-check form-switch mb-0" title="Activar o desactivar degradé sobre esta tarjeta">
                            <input
                              className="form-check-input cursor-pointer"
                              type="checkbox"
                              role="switch"
                              id={`cardGradient_${idx}`}
                              checked={card.showGradient !== false}
                              onChange={(e) => handleCardChange(idx, 'showGradient', e.target.checked)}
                            />
                            <label className="form-check-label small fw-semibold text-muted cursor-pointer" htmlFor={`cardGradient_${idx}`}>
                              {card.showGradient !== false ? 'Degradé' : 'Sin degradé'}
                            </label>
                          </div>
                        )}
                        <span className={`badge rounded-pill ${card.is_active !== false ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'}`} style={{ fontSize: '0.72rem' }}>
                          {card.is_active !== false ? 'Visible' : 'Oculto'}
                        </span>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            role="switch"
                            id={`cardActive_${idx}`}
                            checked={card.is_active !== false}
                            onChange={(e) => handleCardChange(idx, 'is_active', e.target.checked)}
                            title="Mostrar u ocultar esta tarjeta"
                          />
                        </div>

                        {/* Botón Eliminar */}
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: '28px', height: '28px', padding: 0 }}
                          onClick={() => handleDeleteCard(idx)}
                          title="Eliminar esta tarjeta"
                        >
                          <i className="bi bi-trash3" style={{ fontSize: '0.8rem' }}></i>
                        </button>
                      </div>
                    </div>

                    {/* Card Body */}
                    <div className="card-body p-3 p-md-4">
                      <div className="row g-3 align-items-start">
                        {/* Columna Izquierda: Imagen y Botón Subir */}
                        <div className="col-12 col-sm-4">
                          <div 
                            className="ratio ratio-4x3 rounded-3 overflow-hidden border mb-2 bg-light shadow-xs position-relative group"
                            style={{ minHeight: '110px' }}
                          >
                            <CardPreviewImage
                              url={card.image}
                              alt={card.title || `Tarjeta #${idx + 1}`}
                            />
                          </div>
                          <label 
                            className="btn btn-outline-primary btn-sm w-100 rounded-pill fw-semibold shadow-xs d-flex align-items-center justify-content-center gap-2 cursor-pointer mb-0" 
                            style={{ fontSize: '0.78rem' }}
                          >
                            <i className="bi bi-cloud-arrow-up-fill"></i>
                            <span>Cambiar Foto</span>
                            <input
                              type="file"
                              hidden
                              accept="image/*"
                              onChange={(e) => handleUploadImage(e, (url) => handleCardChange(idx, 'image', url), 'shortcuts')}
                            />
                          </label>
                          {card.image && (
                            <button
                              type="button"
                              className="btn btn-link btn-sm text-danger text-decoration-none w-100 mt-1.5 p-0 d-flex align-items-center justify-content-center gap-1"
                              style={{ fontSize: '0.76rem' }}
                              title="Quitar imagen de esta tarjeta"
                              onClick={() => handleCardChange(idx, 'image', '')}
                            >
                              <i className="bi bi-trash3"></i>
                              <span>Quitar imagen</span>
                            </button>
                          )}
                        </div>

                        {/* Columna Derecha: Campos de Texto y Rubro */}
                        <div className="col-12 col-sm-8">
                          <div className="mb-2">
                            <label className="form-label small fw-bold text-muted mb-1">Título de la Tarjeta</label>
                            <input
                              type="text"
                              className="form-control form-control-sm fw-bold rounded-3"
                              value={card.title || ''}
                              onChange={(e) => handleCardChange(idx, 'title', e.target.value)}
                              placeholder="Ej. Cajas y Embalaje"
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label small fw-bold text-muted mb-1">Subtítulo / Bajada</label>
                            <input
                              type="text"
                              className="form-control form-control-sm rounded-3"
                              value={card.subtitle || ''}
                              onChange={(e) => handleCardChange(idx, 'subtitle', e.target.value)}
                              placeholder="Ej. Cajas de cartón, corrugado, cintas..."
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label small fw-bold text-muted mb-1">Rubro Asociado de la Tienda</label>
                            <select
                              className="form-select form-select-sm fw-semibold rounded-3"
                              value={card.rubroTarget || ''}
                              onChange={(e) => handleCardChange(idx, 'rubroTarget', e.target.value)}
                            >
                              <option value="">-- Seleccionar Rubro del Catálogo --</option>
                              {rubros.map(r => (
                                <option key={r.c_rubro || r.id} value={r.d_rubro || r.nombre}>
                                  {r.d_rubro || r.nombre}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Personalización individual de estilo de esta tarjeta (Solo en modo Foto Completa Superpuesta) */}
                          {((config.categoryShortcuts?.cardStyle || 'strip') === 'overlay') && (
                            <div className="row g-2 mt-1 pt-2 border-top">
                              <div className="col-6 col-md-4">
                                <label className="form-label text-muted mb-0" style={{ fontSize: '0.72rem', fontWeight: 600 }}>Color Texto</label>
                                <select
                                  className="form-select form-select-sm rounded-2 py-1"
                                  style={{ fontSize: '0.75rem' }}
                                  value={card.textColorTheme || 'inherit'}
                                  onChange={(e) => handleCardChange(idx, 'textColorTheme', e.target.value)}
                                >
                                  <option value="inherit">Por defecto</option>
                                  <option value="light">Claro (Blanco)</option>
                                  <option value="dark">Oscuro (Negro)</option>
                                  <option value="custom">Personalizado</option>
                                </select>
                              </div>
                              <div className="col-6 col-md-4">
                                <label className="form-label text-muted mb-0" style={{ fontSize: '0.72rem', fontWeight: 600 }}>Tam. Título</label>
                                <select
                                  className="form-select form-select-sm rounded-2 py-1"
                                  style={{ fontSize: '0.75rem' }}
                                  value={card.titleFontSize || 'inherit'}
                                  onChange={(e) => handleCardChange(idx, 'titleFontSize', e.target.value)}
                                >
                                  <option value="inherit">Por defecto</option>
                                  <option value="sm">Pequeño</option>
                                  <option value="md">Mediano</option>
                                  <option value="lg">Grande</option>
                                  <option value="xl">Extra Grande</option>
                                </select>
                              </div>
                              <div className="col-6 col-md-4">
                                <label className="form-label text-muted mb-0" style={{ fontSize: '0.72rem', fontWeight: 600 }}>Alineación</label>
                                <select
                                  className="form-select form-select-sm rounded-2 py-1"
                                  style={{ fontSize: '0.75rem' }}
                                  value={card.textAlignment || 'inherit'}
                                  onChange={(e) => handleCardChange(idx, 'textAlignment', e.target.value)}
                                >
                                  <option value="inherit">Por defecto</option>
                                  <option value="left">Izquierda</option>
                                  <option value="center">Centro</option>
                                  <option value="right">Derecha</option>
                                </select>
                              </div>
                              <div className="col-6 col-md-4">
                                <label className="form-label text-muted mb-0" style={{ fontSize: '0.72rem', fontWeight: 600 }}>Grosor Título</label>
                                <select
                                  className="form-select form-select-sm rounded-2 py-1"
                                  style={{ fontSize: '0.75rem' }}
                                  value={card.titleFontWeight || 'inherit'}
                                  onChange={(e) => handleCardChange(idx, 'titleFontWeight', e.target.value)}
                                >
                                  <option value="inherit">Por defecto</option>
                                  <option value="normal">Normal (400)</option>
                                  <option value="semibold">Semi-Negrita (600)</option>
                                  <option value="bold">Negrita (700)</option>
                                  <option value="extrabold">Extra-Negrita (800)</option>
                                  <option value="black">Ultra-Negrita (900)</option>
                                </select>
                              </div>
                              <div className="col-6 col-md-4">
                                <label className="form-label text-muted mb-0" style={{ fontSize: '0.72rem', fontWeight: 600 }}>Grosor Subtítulo</label>
                                <select
                                  className="form-select form-select-sm rounded-2 py-1"
                                  style={{ fontSize: '0.75rem' }}
                                  value={card.subtitleFontWeight || 'inherit'}
                                  onChange={(e) => handleCardChange(idx, 'subtitleFontWeight', e.target.value)}
                                >
                                  <option value="inherit">Por defecto</option>
                                  <option value="normal">Normal (400)</option>
                                  <option value="medium">Medio (500)</option>
                                  <option value="semibold">Semi-Negrita (600)</option>
                                  <option value="bold">Negrita (700)</option>
                                  <option value="extrabold">Extra-Negrita (800)</option>
                                </select>
                              </div>
                              <div className="col-6 col-md-4">
                                <label className="form-label text-muted mb-0" style={{ fontSize: '0.72rem', fontWeight: 600 }}>Posición Vertical</label>
                                <select
                                  className="form-select form-select-sm rounded-2 py-1"
                                  style={{ fontSize: '0.75rem' }}
                                  value={card.verticalAlignment || 'inherit'}
                                  onChange={(e) => handleCardChange(idx, 'verticalAlignment', e.target.value)}
                                >
                                  <option value="inherit">Por defecto</option>
                                  <option value="bottom">Abajo</option>
                                  <option value="center">Centro</option>
                                  <option value="top">Arriba</option>
                                </select>
                              </div>
                              <div className="col-12 col-md-12">
                                <label className="form-label text-muted mb-0" style={{ fontSize: '0.72rem', fontWeight: 600 }}>Sombra Texto</label>
                                <select
                                  className="form-select form-select-sm rounded-2 py-1"
                                  style={{ fontSize: '0.75rem' }}
                                  value={card.textShadow || 'inherit'}
                                  onChange={(e) => handleCardChange(idx, 'textShadow', e.target.value)}
                                >
                                  <option value="inherit">Por defecto</option>
                                  <option value="none">Sin sombra</option>
                                  <option value="subtle">Sombra suave</option>
                                  <option value="strong">Sombra fuerte</option>
                                </select>
                              </div>
                              {card.textColorTheme === 'custom' && (
                                <div className="col-12 d-flex align-items-center gap-3 pt-1">
                                  <div className="d-flex align-items-center gap-1">
                                    <input
                                      type="color"
                                      className="form-control form-control-color p-0 border rounded"
                                      style={{ width: '24px', height: '24px' }}
                                      value={card.titleColor || '#ffffff'}
                                      onChange={(e) => handleCardChange(idx, 'titleColor', e.target.value)}
                                    />
                                    <span style={{ fontSize: '0.72rem' }} className="text-muted">Título</span>
                                  </div>
                                  <div className="d-flex align-items-center gap-1">
                                    <input
                                      type="color"
                                      className="form-control form-control-color p-0 border rounded"
                                      style={{ width: '24px', height: '24px' }}
                                      value={card.subtitleColor || '#f1f5f9'}
                                      onChange={(e) => handleCardChange(idx, 'subtitleColor', e.target.value)}
                                    />
                                    <span style={{ fontSize: '0.72rem' }} className="text-muted">Subtítulo</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {/* Enlace Destino Automático */}
                          <div className="d-flex align-items-center gap-2 pt-2">
                            <span className="text-muted small" style={{ fontSize: '0.74rem' }}>Enlace directo:</span>
                            <code className="text-primary small bg-light px-2 py-1 rounded border" style={{ fontSize: '0.74rem' }}>
                              {card.link || (card.rubroTarget ? `/tienda?rubro=${encodeURIComponent(card.rubroTarget)}` : '/tienda')}
                            </code>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* PESTAÑA 3: ARTÍCULOS DESTACADOS, MÁS VENDIDOS & PROMO BANNERS */}
      {activeTab === 'featured' && (
        <div className="bg-white p-4 rounded-4 border shadow-sm">
          {/* Sección 0: ¡Los Más Vendidos! */}
          <BestSellersAdminCard
            config={config}
            setConfig={setConfig}
            rubros={rubros}
            selectedCompanyId={selectedCompanyId}
            onToggleHomeSection={handleToggleHomeSection}
            isHomeSectionEnabled={currentHomeSections.find(s => s.id === 'bestSellers')?.enabled}
          />

          {/* Sección 1: Artículos Destacados */}
          <div className="mb-5 pb-4 border-bottom">
            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-4 pb-3 border-bottom gap-3">
              <div>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span className="badge bg-danger-subtle text-danger fw-bold text-uppercase px-3 py-1 rounded-pill">
                    Catálogo Destacado
                  </span>
                  <span className="badge bg-light text-muted border font-monospace">Portada Principal</span>
                </div>
                <h5 className="fw-bold text-dark mb-1">Sección de Artículos Destacados</h5>
                <p className="text-muted small mb-0">Controlá qué productos específicos o rubros se exhiben en la grilla principal de la portada.</p>
              </div>

              <div className="form-check form-switch d-flex align-items-center gap-2 bg-light px-3 py-2 rounded-pill border mb-0">
                <input
                  className="form-check-input ms-0 cursor-pointer"
                  type="checkbox"
                  role="switch"
                  id="featuredEnabled"
                  checked={config.featuredProductsSection?.enabled !== false}
                  onChange={(e) => setConfig({
                    ...config,
                    featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), enabled: e.target.checked }
                  })}
                />
                <label className="form-check-label small fw-bold text-dark cursor-pointer mb-0" htmlFor="featuredEnabled">
                  {config.featuredProductsSection?.enabled !== false ? 'Sección Habilitada' : 'Sección Oculta'}
                </label>
              </div>
            </div>

            {/* Parámetros generales */}
            <div className="row g-3 mb-4 p-3 bg-light rounded-4 border">
              <div className="col-12 col-md-5">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-fonts me-1 text-primary"></i> Título de la Sección
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm fw-bold rounded-3"
                  value={config.featuredProductsSection?.title || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), title: e.target.value }
                  })}
                  placeholder="Ej. Artículos Destacados"
                />
              </div>
              <div className="col-12 col-md-5">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-card-text me-1 text-primary"></i> Subtítulo / Bajada
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm rounded-3"
                  value={config.featuredProductsSection?.subtitle || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), subtitle: e.target.value }
                  })}
                  placeholder="Ej. Los productos más solicitados de nuestro catálogo con entrega inmediata"
                />
              </div>
              <div className="col-12 col-md-4">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-palette me-1 text-primary"></i> Color de Fondo
                </label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                    style={{ width: '40px', height: '32px' }}
                    value={config.featuredProductsSection?.backgroundColor || '#ffffff'}
                    onChange={(e) => setConfig({
                      ...config,
                      featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), backgroundColor: e.target.value }
                    })}
                  />
                  <input
                    type="text"
                    className="form-control form-control-sm font-monospace"
                    style={{ maxWidth: '100px' }}
                    value={config.featuredProductsSection?.backgroundColor || '#ffffff'}
                    onChange={(e) => setConfig({
                      ...config,
                      featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), backgroundColor: e.target.value }
                    })}
                  />
                </div>
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-fonts me-1 text-primary"></i> Tipografía
                </label>
                <select
                  className="form-select form-select-sm fw-semibold"
                  value={config.featuredProductsSection?.fontFamily || 'inherit'}
                  onChange={(e) => setConfig({
                    ...config,
                    featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), fontFamily: e.target.value }
                  })}
                >
                  <option value="inherit">Heredar del sitio (Principal)</option>
                  {AVAILABLE_FONTS.map(f => (
                    <option key={f.id} value={f.id}>{f.name}</option>
                  ))}
                </select>
              </div>

              <div className="col-12 col-md-3">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-fonts me-1 text-primary"></i> Color del Título
                </label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                    style={{ width: '38px', height: '32px' }}
                    value={config.featuredProductsSection?.titleColor || '#1e293b'}
                    onChange={(e) => setConfig({
                      ...config,
                      featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), titleColor: e.target.value }
                    })}
                  />
                  <input
                    type="text"
                    className="form-control form-control-sm font-monospace"
                    style={{ maxWidth: '100px' }}
                    value={config.featuredProductsSection?.titleColor || '#1e293b'}
                    onChange={(e) => setConfig({
                      ...config,
                      featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), titleColor: e.target.value }
                    })}
                  />
                </div>
              </div>

              <div className="col-12 col-md-3">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-card-text me-1 text-primary"></i> Color del Subtítulo
                </label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                    style={{ width: '38px', height: '32px' }}
                    value={config.featuredProductsSection?.subtitleColor || '#64748b'}
                    onChange={(e) => setConfig({
                      ...config,
                      featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), subtitleColor: e.target.value }
                    })}
                  />
                  <input
                    type="text"
                    className="form-control form-control-sm font-monospace"
                    style={{ maxWidth: '100px' }}
                    value={config.featuredProductsSection?.subtitleColor || '#64748b'}
                    onChange={(e) => setConfig({
                      ...config,
                      featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), subtitleColor: e.target.value }
                    })}
                  />
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <label className="form-label small fw-bold text-dark mb-0">
                    <i className="bi bi-arrow-right-circle me-1 text-primary"></i> Texto del Botón de Catálogo
                  </label>
                  <div className="form-check form-switch mb-0">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id="featShowBtnSwitch"
                      checked={config.featuredProductsSection?.showButton !== false}
                      onChange={(e) => setConfig({
                        ...config,
                        featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), showButton: e.target.checked }
                      })}
                    />
                    <label className="form-check-label small text-muted cursor-pointer" htmlFor="featShowBtnSwitch">
                      {config.featuredProductsSection?.showButton !== false ? 'Mostrar Botón' : 'Ocultar'}
                    </label>
                  </div>
                </div>
                <input
                  type="text"
                  className="form-control form-control-sm rounded-3"
                  value={config.featuredProductsSection?.buttonText ?? 'Ver Catálogo Completo'}
                  onChange={(e) => setConfig({
                    ...config,
                    featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), buttonText: e.target.value }
                  })}
                  placeholder="Dejar vacío o desactivar switch para ocultar"
                />
              </div>

              <div className="col-12 col-md-2">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-123 me-1 text-primary"></i> Límite Visible
                </label>
                <select
                  className="form-select form-select-sm fw-semibold rounded-3"
                  value={config.featuredProductsSection?.limit || 8}
                  onChange={(e) => setConfig({
                    ...config,
                    featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), limit: Number(e.target.value) }
                  })}
                >
                  <option value={4}>4 productos</option>
                  <option value={8}>8 productos</option>
                  <option value={12}>12 productos</option>
                  <option value={16}>16 productos</option>
                </select>
              </div>

              {/* Personalización visual: Tamaños de letra */}
              <div className="col-12 col-md-6">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-fonts me-1 text-primary"></i> Tamaño del Título de Sección
                </label>
                <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '380px' }}>
                  {[
                    { id: 'small', label: 'Chico' },
                    { id: 'medium', label: 'Mediano' },
                    { id: 'large', label: 'Grande' },
                    { id: 'xlarge', label: 'Muy Grande' }
                  ].map(opt => {
                    const isSelected = (config.featuredProductsSection?.titleFontSize || 'medium') === opt.id;
                    return (
                      <button
                        key={opt.id}
                        type="button"
                        className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                          isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                        }`}
                        style={{ padding: '0.35rem 0.5rem', fontSize: '0.78rem' }}
                        onClick={() => setConfig({
                          ...config,
                          featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), titleFontSize: opt.id }
                        })}
                      >
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-card-text me-1 text-primary"></i> Tamaño de Subtítulo / Bajada
                </label>
                <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '300px' }}>
                  {[
                    { id: 'small', label: 'Chico' },
                    { id: 'medium', label: 'Mediano' },
                    { id: 'large', label: 'Grande' }
                  ].map(opt => {
                    const isSelected = (config.featuredProductsSection?.subtitleFontSize || 'medium') === opt.id;
                    return (
                      <button
                        key={opt.id}
                        type="button"
                        className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                          isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                        }`}
                        style={{ padding: '0.35rem 0.5rem', fontSize: '0.78rem' }}
                        onClick={() => setConfig({
                          ...config,
                          featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), subtitleFontSize: opt.id }
                        })}
                      >
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Columnas por fila y personalización de imágenes */}
              <div className="col-12 col-md-4">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-grid-fill me-1 text-primary"></i> Artículos por Fila (Escritorio)
                </label>
                <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '340px' }}>
                  {[3, 4, 5, 6].map(num => {
                    const isSelected = (Number(config.featuredProductsSection?.columnsPerRow) || 4) === num;
                    return (
                      <button
                        key={num}
                        type="button"
                        className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                          isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                        }`}
                        style={{ padding: '0.35rem 0.5rem', fontSize: '0.8rem' }}
                        onClick={() => setConfig({
                          ...config,
                          featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), columnsPerRow: num }
                        })}
                      >
                        {num} / fila
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-aspect-ratio me-1 text-primary"></i> Ajuste de Imagen
                </label>
                <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '280px' }}>
                  {[
                    { id: 'contain', label: 'Proporcional' },
                    { id: 'cover', label: 'Rellenar' }
                  ].map(opt => {
                    const isSelected = (config.featuredProductsSection?.imageFit || 'contain') === opt.id;
                    return (
                      <button
                        key={opt.id}
                        type="button"
                        className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                          isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                        }`}
                        style={{ padding: '0.35rem 0.5rem', fontSize: '0.78rem' }}
                        onClick={() => setConfig({
                          ...config,
                          featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), imageFit: opt.id }
                        })}
                      >
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label small fw-bold text-dark mb-1">
                  <i className="bi bi-arrows-expand me-1 text-primary"></i> Altura Imagen de Producto
                </label>
                <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '320px' }}>
                  {[
                    { id: 'compact', label: 'Compacta' },
                    { id: 'standard', label: 'Estándar' },
                    { id: 'large', label: 'Amplia' }
                  ].map(opt => {
                    const isSelected = (config.featuredProductsSection?.imageHeight || 'standard') === opt.id;
                    return (
                      <button
                        key={opt.id}
                        type="button"
                        className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                          isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                        }`}
                        style={{ padding: '0.35rem 0.5rem', fontSize: '0.78rem' }}
                        onClick={() => setConfig({
                          ...config,
                          featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), imageHeight: opt.id }
                        })}
                      >
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Selector de Modo de Destacados */}
            <div 
              ref={featuredSelectionModeRef}
              className="p-4 p-md-4 rounded-4 border bg-white shadow-xs mb-4"
            >
              <label className="form-label fw-bold text-dark mb-2 small text-uppercase tracking-wider">
                Modo de Selección de Artículos
              </label>
              
              <div className="row g-3 mb-3">
                <div className="col-12 col-sm-6 col-xl-3">
                  <div
                    className={`p-3 rounded-3 border cursor-pointer h-100 transition-all ${
                      (config.featuredProductsSection?.selectionMode || 'auto') === 'auto'
                        ? 'border-primary bg-primary-subtle shadow-xs'
                        : 'bg-light bg-opacity-50'
                    }`}
                    onClick={() => handleFeaturedSelectionModeChange('auto')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <i className="bi bi-magic text-primary fs-5"></i>
                      <strong className="small text-dark">Automático (Catálogo)</strong>
                    </div>
                    <p className="text-muted small mb-0" style={{ fontSize: '0.78rem' }}>
                      Muestra automáticamente los primeros artículos con stock del catálogo general.
                    </p>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-xl-3">
                  <div
                    className={`p-3 rounded-3 border cursor-pointer h-100 transition-all ${
                      config.featuredProductsSection?.selectionMode === 'ofertas'
                        ? 'border-danger bg-danger-subtle shadow-xs'
                        : 'bg-light bg-opacity-50'
                    }`}
                    onClick={() => handleFeaturedSelectionModeChange('ofertas')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <i className="bi bi-percent text-danger fs-5"></i>
                      <strong className="small text-dark">Artículos en Oferta</strong>
                    </div>
                    <p className="text-muted small mb-0" style={{ fontSize: '0.78rem' }}>
                      Muestra automáticamente los productos que poseen precio especial de oferta.
                    </p>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-xl-3">
                  <div
                    className={`p-3 rounded-3 border cursor-pointer h-100 transition-all ${
                      config.featuredProductsSection?.selectionMode === 'rubro'
                        ? 'border-primary bg-primary-subtle shadow-xs'
                        : 'bg-light bg-opacity-50'
                    }`}
                    onClick={() => handleFeaturedSelectionModeChange('rubro')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <i className="bi bi-tag-fill text-primary fs-5"></i>
                      <strong className="small text-dark">Filtrar por Rubro</strong>
                    </div>
                    <p className="text-muted small mb-0" style={{ fontSize: '0.78rem' }}>
                      Muestra solo los productos pertenecientes a un rubro que elijas.
                    </p>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-xl-3">
                  <div
                    className={`p-3 rounded-3 border cursor-pointer h-100 transition-all ${
                      config.featuredProductsSection?.selectionMode === 'manual'
                        ? 'border-primary bg-primary-subtle shadow-xs'
                        : 'bg-light bg-opacity-50'
                    }`}
                    onClick={() => handleFeaturedSelectionModeChange('manual')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <i className="bi bi-hand-index-thumb-fill text-primary fs-5"></i>
                      <strong className="small text-dark">Selección Manual</strong>
                    </div>
                    <p className="text-muted small mb-0" style={{ fontSize: '0.78rem' }}>
                      Elegí uno por uno los productos exactos que querés mostrar en la portada.
                    </p>
                  </div>
                </div>
              </div>

              {/* Sub-configuración si eligió "Artículos en Oferta" */}
              {config.featuredProductsSection?.selectionMode === 'ofertas' && (
                <div className="p-3 bg-danger bg-opacity-10 rounded-3 border border-danger-subtle mt-3 d-flex align-items-center gap-3">
                  <div className="rounded-circle bg-danger text-white d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '38px', height: '38px' }}>
                    <i className="bi bi-percent fs-5"></i>
                  </div>
                  <div className="small">
                    <div className="fw-bold text-danger">Modo Artículos en Oferta Activo</div>
                    <div className="text-muted" style={{ fontSize: '0.8rem' }}>
                      La portada mostrará automáticamente los productos con precio promocional / oferta vigente cargados en el sistema (<code>I_PREANT &gt; 0</code>).
                    </div>
                  </div>
                </div>
              )}

              {/* Sub-configuración si eligió "Por Rubro" */}
              {config.featuredProductsSection?.selectionMode === 'rubro' && (
                <div className="p-3 bg-light rounded-3 border mt-3">
                  <label className="form-label small fw-bold text-dark mb-1">
                    Seleccionar Rubro a Destacar:
                  </label>
                  <select
                    className="form-select form-select-sm fw-semibold rounded-3"
                    value={config.featuredProductsSection?.filterRubro || ''}
                    onChange={(e) => setConfig({
                      ...config,
                      featuredProductsSection: { ...(config.featuredProductsSection || DEFAULT_LANDING_CONFIG.featuredProductsSection), filterRubro: e.target.value }
                    })}
                  >
                    <option value="">-- Todos los Rubros --</option>
                    {rubros.map(r => (
                      <option key={r.c_rubro || r.id} value={r.c_rubro || r.nombre}>
                        {r.d_rubro || r.nombre} ({r.c_rubro})
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* Sub-configuración si eligió "Selección Manual de Artículos" */}
              {config.featuredProductsSection?.selectionMode === 'manual' && (
                <div className="p-3 bg-light rounded-3 border mt-3">
                  <h6 className="fw-bold text-dark mb-2 d-flex align-items-center gap-2">
                    <i className="bi bi-search text-primary"></i>
                    Buscador de Artículos para Destacar
                  </h6>

                  {/* Input buscador */}
                  <div className="input-group input-group-sm mb-3">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-search"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Escribí código o nombre del producto (ej: Caja, Bobina, 1001)..."
                      value={searchArticuloQuery}
                      onChange={(e) => handleSearchArticulos(e.target.value)}
                    />
                    {searchArticuloQuery && (
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => { setSearchArticuloQuery(''); setSearchedArticulos([]); }}
                      >
                        Limpiar
                      </button>
                    )}
                  </div>

                  {/* Spinner de búsqueda */}
                  {searchingArticulos && (
                    <div className="text-center py-2 text-muted small">
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Buscando en catálogo...
                    </div>
                  )}

                  {/* Resultados de búsqueda */}
                  {searchedArticulos.length > 0 && (
                    <div className="list-group mb-3 shadow-sm border rounded-3 overflow-hidden" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                      {searchedArticulos.map(art => (
                        <div key={art.c_artic || art.id} className="list-group-item list-group-item-action d-flex align-items-center justify-content-between p-2">
                          <div className="d-flex align-items-center gap-2">
                            <ProductThumbnail product={art} size={38} />
                            <div>
                              <div className="fw-bold small text-dark">{art.d_artic}</div>
                              <div className="text-muted" style={{ fontSize: '0.74rem' }}>
                                Código: <code className="text-primary">{art.c_artic}</code> | Rubro: {art.c_rubro || '-'}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: '32px', height: '32px' }}
                              title="Ver detalle del artículo"
                              onClick={() => setPreviewProduct(art)}
                            >
                              <i className="bi bi-eye"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm rounded-pill px-3 py-1 fw-semibold d-flex align-items-center gap-1"
                              onClick={() => handleSelectFeaturedProduct(art)}
                            >
                              <i className="bi bi-plus-circle me-1"></i> Destacar
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Lista de Artículos Seleccionados */}
                  <div className="mt-3">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <label className="small fw-bold text-dark mb-0">
                        Artículos Destacados Seleccionados ({(config.featuredProductsSection?.selectedProducts || []).length})
                      </label>
                      {(config.featuredProductsSection?.selectedProducts || []).length > 0 && (
                        <span className="text-muted small" style={{ fontSize: '0.74rem' }}>
                          Se mostrarán hasta {config.featuredProductsSection?.limit || 8} productos
                        </span>
                      )}
                    </div>

                    {(!config.featuredProductsSection?.selectedProducts || config.featuredProductsSection.selectedProducts.length === 0) ? (
                      <div className="text-center p-3 bg-white border border-dashed rounded-3 text-muted small">
                        <i className="bi bi-inbox fs-4 d-block mb-1 text-secondary"></i>
                        No has seleccionado artículos manualmente todavía. Utilizá el buscador superior para agregar productos a la portada.
                      </div>
                    ) : (
                      <div className="row g-2">
                        {config.featuredProductsSection.selectedProducts.map((p, idx) => (
                          <div key={p.c_artic || idx} className="col-12 col-md-6 col-lg-4">
                            <div className="card border bg-white shadow-xs rounded-3 p-2 d-flex flex-row align-items-center justify-content-between gap-2 h-100">
                              <div className="d-flex align-items-center gap-2 overflow-hidden">
                                <ProductThumbnail product={p} size={38} />
                                <div className="overflow-hidden">
                                  <div className="fw-bold small text-dark text-truncate" title={p.d_artic}>{p.d_artic}</div>
                                  <div className="text-muted" style={{ fontSize: '0.72rem' }}>
                                    Código: <code className="text-primary">{p.c_artic}</code>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex align-items-center gap-1 flex-shrink-0">
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                  style={{ width: '26px', height: '26px', padding: 0 }}
                                  title="Ver detalle del artículo"
                                  onClick={() => setPreviewProduct(p)}
                                >
                                  <i className="bi bi-eye" style={{ fontSize: '0.8rem' }}></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                  style={{ width: '26px', height: '26px', padding: 0 }}
                                  onClick={() => handleRemoveFeaturedProduct(idx)}
                                  title="Quitar de destacados"
                                >
                                  <i className="bi bi-x" style={{ fontSize: '1rem' }}></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Sección 2: Banners Promocionales de Portada */}
          <div>
            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-4 pb-3 border-bottom gap-3">
              <div>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span className="badge bg-warning-subtle text-dark fw-bold text-uppercase px-3 py-1 rounded-pill">
                    Promociones Especiales
                  </span>
                  <span className="badge bg-light text-muted border font-monospace">
                    {(config.promoBanners || []).length} {(config.promoBanners || []).length === 1 ? 'Banner' : 'Banners'} en Portada
                  </span>
                </div>
                <h5 className="fw-bold text-dark mb-1">Banners Promocionales de Portada</h5>
                <p className="text-muted small mb-0">Banners visuales ubicados en el cuerpo de la portada para destacar ofertas, combos y rubros especiales.</p>
              </div>

              <button
                type="button"
                className="btn btn-primary btn-sm rounded-pill px-3 py-2 fw-bold d-flex align-items-center gap-2 shadow-xs"
                onClick={handleAddPromoBanner}
              >
                <i className="bi bi-plus-circle-fill"></i>
                <span>Agregar Banner</span>
              </button>
            </div>

            {/* Configuración del Título y Encabezado de la Sección */}
            <div className="p-3 p-md-4 bg-light rounded-4 border mb-4 shadow-xs">
              <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-3 pb-3 border-bottom gap-2">
                <div>
                  <span className="fw-bold text-dark d-block">Encabezado y Título de la Sección</span>
                  <small className="text-muted">Personalizá cómo se presenta este bloque en la portada.</small>
                </div>

                <div className="form-check form-switch d-flex align-items-center gap-2 bg-white px-3 py-2 rounded-pill border mb-0">
                  <input
                    className="form-check-input ms-0 cursor-pointer"
                    type="checkbox"
                    role="switch"
                    id="promoSectionTitleEnabled"
                    checked={config.promoBannersSettings?.showSectionTitle !== false}
                    onChange={(e) => handlePromoBannersSettingsChange('showSectionTitle', e.target.checked)}
                  />
                  <label className="form-check-label small fw-bold text-dark cursor-pointer mb-0" htmlFor="promoSectionTitleEnabled">
                    {config.promoBannersSettings?.showSectionTitle !== false ? 'Título Visible' : 'Título Oculto'}
                  </label>
                </div>
              </div>

              {config.promoBannersSettings?.showSectionTitle !== false && (
                <div className="row g-3 pt-1">
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">Título de la Sección</label>
                    <input
                      type="text"
                      className="form-control fw-bold rounded-3"
                      value={config.promoBannersSettings?.title ?? 'Oportunidades & Promociones Destacadas'}
                      onChange={(e) => handlePromoBannersSettingsChange('title', e.target.value)}
                      placeholder="Ej. Oportunidades & Promociones Destacadas"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">Etiqueta Superior (Badge)</label>
                    <input
                      type="text"
                      className="form-control rounded-3"
                      value={config.promoBannersSettings?.badgeText ?? 'Promociones Especiales'}
                      onChange={(e) => handlePromoBannersSettingsChange('badgeText', e.target.value)}
                      placeholder="Ej. Promociones Especiales (opcional)"
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label small fw-bold text-muted mb-1">Subtítulo / Bajada de la Sección</label>
                    <input
                      type="text"
                      className="form-control rounded-3"
                      value={config.promoBannersSettings?.subtitle ?? 'Aprovechá ofertas por cantidad, lanzamientos y productos en liquidación'}
                      onChange={(e) => handlePromoBannersSettingsChange('subtitle', e.target.value)}
                      placeholder="Ej. Aprovechá ofertas por cantidad, lanzamientos y productos en liquidación"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">Color de Fondo de la Sección</label>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="color"
                        className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                        style={{ width: '40px', height: '32px' }}
                        value={config.promoBannersSettings?.backgroundColor || '#f8fafc'}
                        onChange={(e) => handlePromoBannersSettingsChange('backgroundColor', e.target.value)}
                      />
                      <input
                        type="text"
                        className="form-control form-control-sm font-monospace"
                        style={{ maxWidth: '120px' }}
                        value={config.promoBannersSettings?.backgroundColor || '#f8fafc'}
                        onChange={(e) => handlePromoBannersSettingsChange('backgroundColor', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-6 d-flex align-items-center">
                    <div className="form-check form-switch pt-3">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        role="switch"
                        id="promoGradientGlobalSwitch"
                        checked={config.promoBannersSettings?.showGradient !== false}
                        onChange={(e) => handlePromoBannersSettingsChange('showGradient', e.target.checked)}
                      />
                      <label className="form-check-label small fw-bold text-dark cursor-pointer ms-1" htmlFor="promoGradientGlobalSwitch">
                        {config.promoBannersSettings?.showGradient !== false ? 'Degradé oscuro activo sobre banners' : 'Sin degradé (banners 100% nítidos)'}
                      </label>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">Tipografía de esta Sección</label>
                    <select
                      className="form-select form-select-sm fw-semibold"
                      value={config.promoBannersSettings?.fontFamily || 'inherit'}
                      onChange={(e) => handlePromoBannersSettingsChange('fontFamily', e.target.value)}
                    >
                      <option value="inherit">Heredar del sitio (Principal)</option>
                      {AVAILABLE_FONTS.map(f => (
                        <option key={f.id} value={f.id}>{f.name}</option>
                      ))}
                    </select>
                  </div>

                  {/* Personalización de Tamaños de Título y Subtítulo de Sección de Promociones */}
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">
                      <i className="bi bi-fonts me-1 text-primary"></i> Tamaño del Título de Sección
                    </label>
                    <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '380px' }}>
                      {[
                        { id: 'small', label: 'Chico' },
                        { id: 'medium', label: 'Mediano' },
                        { id: 'large', label: 'Grande' },
                        { id: 'xlarge', label: 'Muy Grande' }
                      ].map(opt => {
                        const isSelected = (config.promoBannersSettings?.titleFontSize || 'large') === opt.id;
                        return (
                          <button
                            key={opt.id}
                            type="button"
                            className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                              isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                            }`}
                            style={{ padding: '0.35rem 0.5rem', fontSize: '0.78rem' }}
                            onClick={() => handlePromoBannersSettingsChange('titleFontSize', opt.id)}
                          >
                            {opt.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">
                      <i className="bi bi-card-text me-1 text-primary"></i> Tamaño del Subtítulo de Sección
                    </label>
                    <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '300px' }}>
                      {[
                        { id: 'small', label: 'Chico' },
                        { id: 'medium', label: 'Mediano' },
                        { id: 'large', label: 'Grande' }
                      ].map(opt => {
                        const isSelected = (config.promoBannersSettings?.subtitleFontSize || 'medium') === opt.id;
                        return (
                          <button
                            key={opt.id}
                            type="button"
                            className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                              isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                            }`}
                            style={{ padding: '0.35rem 0.5rem', fontSize: '0.78rem' }}
                            onClick={() => handlePromoBannersSettingsChange('subtitleFontSize', opt.id)}
                          >
                            {opt.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Columnas y Altura de los Banners Promocionales */}
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">
                      <i className="bi bi-grid-fill me-1 text-primary"></i> Distribución de Banners en Portada
                    </label>
                    <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '400px' }}>
                      {[
                        { id: 1, label: '1 Columna' },
                        { id: 2, label: '2 Columnas' },
                        { id: 3, label: '3 Columnas' }
                      ].map(opt => {
                        const isSelected = (Number(config.promoBannersSettings?.columnsPerRow) || 2) === opt.id;
                        return (
                          <button
                            key={opt.id}
                            type="button"
                            className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                              isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                            }`}
                            style={{ padding: '0.35rem 0.5rem', fontSize: '0.8rem' }}
                            onClick={() => handlePromoBannersSettingsChange('columnsPerRow', opt.id)}
                          >
                            {opt.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">
                      <i className="bi bi-arrows-expand me-1 text-primary"></i> Altura de los Banners
                    </label>
                    <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '340px' }}>
                      {[
                        { id: 'compact', label: 'Compacto' },
                        { id: 'standard', label: 'Estándar' },
                        { id: 'large', label: 'Grande' }
                      ].map(opt => {
                        const isSelected = (config.promoBannersSettings?.bannerHeight || 'standard') === opt.id;
                        return (
                          <button
                            key={opt.id}
                            type="button"
                            className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                              isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                            }`}
                            style={{ padding: '0.35rem 0.5rem', fontSize: '0.8rem' }}
                            onClick={() => handlePromoBannersSettingsChange('bannerHeight', opt.id)}
                          >
                            {opt.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Disposición de Títulos: Superpuesto sobre foto vs Debajo de la foto */}
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">
                      <i className="bi bi-layout-text-window-reverse me-1 text-primary"></i> Disposición de Títulos en los Banners
                    </label>
                    <div className="d-flex align-items-center p-1 bg-white rounded-pill border w-100" style={{ maxWidth: '420px' }}>
                      {[
                        { id: 'overlay', label: 'Superpuesto (Sobre foto)', icon: 'bi-card-image' },
                        { id: 'below', label: 'Debajo de la foto (Ficha)', icon: 'bi-layout-text-sidebar' }
                      ].map(opt => {
                        const isSelected = (config.promoBannersSettings?.cardStyle || 'overlay') === opt.id;
                        return (
                          <button
                            key={opt.id}
                            type="button"
                            className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 d-flex align-items-center justify-content-center gap-1 ${
                              isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                            }`}
                            style={{ padding: '0.35rem 0.5rem', fontSize: '0.78rem' }}
                            onClick={() => handlePromoBannersSettingsChange('cardStyle', opt.id)}
                          >
                            <i className={`bi ${opt.icon}`}></i>
                            <span>{opt.label}</span>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Colores de Título y Subtítulo de Sección */}
                  <div className="col-12 col-md-3">
                    <label className="form-label small fw-bold text-muted mb-1">Color Título Sección</label>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="color"
                        className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                        style={{ width: '40px', height: '32px' }}
                        value={config.promoBannersSettings?.titleColor || '#1e293b'}
                        onChange={(e) => handlePromoBannersSettingsChange('titleColor', e.target.value)}
                      />
                      <input
                        type="text"
                        className="form-control form-control-sm font-monospace"
                        style={{ maxWidth: '110px' }}
                        value={config.promoBannersSettings?.titleColor || '#1e293b'}
                        onChange={(e) => handlePromoBannersSettingsChange('titleColor', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-3">
                    <label className="form-label small fw-bold text-muted mb-1">Color Subtítulo Sección</label>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="color"
                        className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                        style={{ width: '40px', height: '32px' }}
                        value={config.promoBannersSettings?.subtitleColor || '#64748b'}
                        onChange={(e) => handlePromoBannersSettingsChange('subtitleColor', e.target.value)}
                      />
                      <input
                        type="text"
                        className="form-control form-control-sm font-monospace"
                        style={{ maxWidth: '110px' }}
                        value={config.promoBannersSettings?.subtitleColor || '#64748b'}
                        onChange={(e) => handlePromoBannersSettingsChange('subtitleColor', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Listado de Banners */}
            {(!config.promoBanners || config.promoBanners.length === 0) ? (
              <div className="text-center p-5 bg-light rounded-4 border border-dashed text-muted">
                <i className="bi bi-tag fs-1 d-block mb-2 text-secondary opacity-50"></i>
                <h6 className="fw-bold text-dark">No hay banners promocionales creados</h6>
                <p className="small mb-3">Hacé clic en el botón superior para agregar un banner promocional a la portada.</p>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm rounded-pill px-4 fw-semibold"
                  onClick={handleAddPromoBanner}
                >
                  <i className="bi bi-plus-lg me-1"></i> Crear Primer Banner
                </button>
              </div>
            ) : (
              <div className="row g-4">
                {config.promoBanners.map((promo, idx) => (
                  <div key={promo.id || idx} className="col-lg-6 col-12">
                    <div className="card border shadow-xs rounded-4 h-100 overflow-hidden bg-white">
                      {/* Header Banner Promocional */}
                      <div className="card-header bg-light bg-opacity-75 py-2 px-3 border-bottom d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div className="btn-group btn-group-sm">
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm px-2 py-1"
                              onClick={() => handleMovePromoBanner(idx, -1)}
                              disabled={idx === 0}
                              title="Mover antes"
                            >
                              <i className="bi bi-chevron-up"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm px-2 py-1"
                              onClick={() => handleMovePromoBanner(idx, 1)}
                              disabled={idx === (config.promoBanners || []).length - 1}
                              title="Mover después"
                            >
                              <i className="bi bi-chevron-down"></i>
                            </button>
                          </div>

                          <span className="badge bg-primary text-white fw-bold font-monospace px-3 py-1 rounded-pill">
                            Banner #{idx + 1}
                          </span>
                          <span className="fw-bold text-dark small text-truncate" style={{ maxWidth: '160px' }}>
                            {promo.title || 'Sin Título'}
                          </span>
                        </div>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div className="form-check form-switch mb-0" title="Activar o desactivar degradé oscuro sobre este banner">
                            <input
                              className="form-check-input cursor-pointer"
                              type="checkbox"
                              role="switch"
                              id={`promoGradient_${idx}`}
                              checked={promo.showGradient !== false}
                              onChange={(e) => handlePromoBannerChange(idx, 'showGradient', e.target.checked)}
                            />
                            <label className="form-check-label small fw-semibold text-muted cursor-pointer" htmlFor={`promoGradient_${idx}`}>
                              {promo.showGradient !== false ? 'Degradé' : 'Sin degradé'}
                            </label>
                          </div>
                          <span className={`badge rounded-pill ${promo.is_active !== false ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'}`} style={{ fontSize: '0.72rem' }}>
                            {promo.is_active !== false ? 'Visible' : 'Oculto'}
                          </span>
                          <div className="form-check form-switch mb-0">
                            <input
                              className="form-check-input cursor-pointer"
                              type="checkbox"
                              role="switch"
                              id={`promoActive_${idx}`}
                              checked={promo.is_active !== false}
                              onChange={(e) => handlePromoBannerChange(idx, 'is_active', e.target.checked)}
                              title="Mostrar u ocultar este banner"
                            />
                          </div>

                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: '28px', height: '28px', padding: 0 }}
                            onClick={() => handleDeletePromoBanner(idx)}
                            title="Eliminar este banner"
                          >
                            <i className="bi bi-trash3" style={{ fontSize: '0.8rem' }}></i>
                          </button>
                        </div>
                      </div>

                      <div className="card-body p-3 p-md-4">
                        <div className="row g-3">
                          <div className="col-12 col-sm-4">
                            <div className="ratio ratio-4x3 rounded-3 overflow-hidden border mb-2 bg-light shadow-xs">
                              <CardPreviewImage
                                url={promo.image}
                                alt={promo.title || `Banner #${idx + 1}`}
                              />
                            </div>
                            <label className="btn btn-outline-primary btn-sm w-100 rounded-pill fw-semibold shadow-xs d-flex align-items-center justify-content-center gap-2 cursor-pointer mb-0">
                              <i className="bi bi-cloud-arrow-up-fill me-1"></i>
                              <span>Cambiar Foto</span>
                              <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={(e) => handleUploadImage(e, (url) => handlePromoBannerChange(idx, 'image', url), 'promos')}
                              />
                            </label>
                            {promo.image && (
                              <button
                                type="button"
                                className="btn btn-link btn-sm text-danger text-decoration-none w-100 mt-1.5 p-0 d-flex align-items-center justify-content-center gap-1"
                                style={{ fontSize: '0.76rem' }}
                                onClick={() => handlePromoBannerChange(idx, 'image', '')}
                              >
                                <i className="bi bi-trash3"></i>
                                <span>Quitar imagen</span>
                              </button>
                            )}
                          </div>
                          <div className="col-12 col-sm-8">
                            <div className="mb-2">
                              <label className="form-label small fw-bold text-muted mb-1">Título del Banner</label>
                              <input
                                type="text"
                                className="form-control form-control-sm fw-bold rounded-3"
                                value={promo.title || ''}
                                onChange={(e) => handlePromoBannerChange(idx, 'title', e.target.value)}
                                placeholder="Ej. Cajas de Pizza & Empanadas"
                              />
                            </div>
                            <div className="mb-2">
                              <label className="form-label small fw-bold text-muted mb-1">Subtítulo / Bajada</label>
                              <input
                                type="text"
                                className="form-control form-control-sm rounded-3"
                                value={promo.subtitle || ''}
                                onChange={(e) => handlePromoBannerChange(idx, 'subtitle', e.target.value)}
                                placeholder="Ej. Microcorrugado de alta resistencia..."
                              />
                            </div>
                            {/* Rubro Asociado del Catálogo */}
                            <div className="mb-2">
                              <label className="form-label small fw-bold text-muted mb-1">
                                <i className="bi bi-tag-fill me-1 text-primary"></i> Vincular Directamente a un Rubro
                              </label>
                              <select
                                className="form-select form-select-sm fw-semibold rounded-3"
                                value={promo.rubroTarget || ''}
                                onChange={(e) => {
                                  const rubroVal = e.target.value;
                                  const updated = [...(config.promoBanners || [])];
                                  const targetLink = rubroVal ? `/tienda?rubro=${encodeURIComponent(rubroVal)}` : (updated[idx].link || '/tienda');
                                  updated[idx] = {
                                    ...updated[idx],
                                    rubroTarget: rubroVal,
                                    link: targetLink
                                  };
                                  setConfig({ ...config, promoBanners: updated });
                                }}
                              >
                                <option value="">-- Sin Rubro Asociado (o enlace manual personalizado) --</option>
                                {rubros.map(r => (
                                  <option key={r.c_rubro || r.id} value={r.d_rubro || r.nombre}>
                                    {r.d_rubro || r.nombre}
                                  </option>
                                ))}
                              </select>
                              {promo.rubroTarget && (
                                <small className="text-success d-block mt-1" style={{ fontSize: '0.74rem' }}>
                                  <i className="bi bi-check-circle-fill me-1"></i>
                                  Toda la tarjeta y la foto enlazarán al rubro: <strong>{promo.rubroTarget}</strong>
                                </small>
                              )}
                            </div>

                            <div className="row g-2">
                              <div className="col-12 col-md-6">
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                  <label className="form-label small fw-bold text-muted mb-0">Texto del Botón</label>
                                  <div className="form-check form-switch mb-0" title="Mostrar u ocultar botón">
                                    <input
                                      className="form-check-input cursor-pointer"
                                      type="checkbox"
                                      role="switch"
                                      id={`promoBtnShow_${idx}`}
                                      checked={promo.showButton !== false}
                                      onChange={(e) => handlePromoBannerChange(idx, 'showButton', e.target.checked)}
                                    />
                                    <label className="form-check-label small fw-semibold text-muted cursor-pointer" htmlFor={`promoBtnShow_${idx}`}>
                                      {promo.showButton !== false ? 'Visible' : 'Oculto'}
                                    </label>
                                  </div>
                                </div>
                                <input
                                  type="text"
                                  className="form-control form-control-sm rounded-3"
                                  value={promo.buttonText || ''}
                                  onChange={(e) => handlePromoBannerChange(idx, 'buttonText', e.target.value)}
                                  placeholder="Ej. Ver Ofertas (vacío = sin botón)"
                                />
                                <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                                  💡 Dejalo vacío para no mostrar el botón.
                                </small>
                              </div>

                              <div className="col-12 col-md-6">
                                <label className="form-label small fw-bold text-muted mb-1">Enlace Destino (URL / Ruta)</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm rounded-3"
                                  value={promo.link || ''}
                                  onChange={(e) => handlePromoBannerChange(idx, 'link', e.target.value)}
                                  placeholder="Ej. /tienda?rubro=Cajas o URL externa"
                                />
                                <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                                  Auto-completado al elegir un rubro arriba.
                                </small>
                              </div>
                            </div>

                            {/* Personalización visual avanzada del Banner */}
                            <div className="row g-2 mt-2 pt-2 border-top">
                              <div className="col-12 col-md-6">
                                <label className="form-label small fw-bold text-muted mb-1">
                                  <i className="bi bi-fonts me-1 text-primary"></i> Tamaño Título
                                </label>
                                <div className="d-flex align-items-center p-1 bg-light rounded-pill border w-100">
                                  {[
                                    { id: 'small', label: 'Chico' },
                                    { id: 'medium', label: 'Medio' },
                                    { id: 'large', label: 'Grande' },
                                    { id: 'xlarge', label: 'Muy Gr.' }
                                  ].map(opt => {
                                    const isSelected = (promo.titleFontSize || 'large') === opt.id;
                                    return (
                                      <button
                                        key={opt.id}
                                        type="button"
                                        className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                                          isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                                        }`}
                                        style={{ padding: '0.22rem 0.35rem', fontSize: '0.72rem' }}
                                        onClick={() => handlePromoBannerChange(idx, 'titleFontSize', opt.id)}
                                      >
                                        {opt.label}
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>

                              <div className="col-12 col-md-6">
                                <label className="form-label small fw-bold text-muted mb-1">
                                  <i className="bi bi-text-left me-1 text-primary"></i> Alineación de Contenido
                                </label>
                                <div className="d-flex align-items-center p-1 bg-light rounded-pill border w-100">
                                  {[
                                    { id: 'left', label: 'Izq', icon: 'bi-text-left' },
                                    { id: 'center', label: 'Centro', icon: 'bi-text-center' },
                                    { id: 'right', label: 'Der', icon: 'bi-text-right' }
                                  ].map(opt => {
                                    const isSelected = (promo.textAlignment || 'left') === opt.id;
                                    return (
                                      <button
                                        key={opt.id}
                                        type="button"
                                        className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 d-flex align-items-center justify-content-center gap-1 ${
                                          isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                                        }`}
                                        style={{ padding: '0.22rem 0.35rem', fontSize: '0.72rem' }}
                                        onClick={() => handlePromoBannerChange(idx, 'textAlignment', opt.id)}
                                      >
                                        <i className={`bi ${opt.icon}`}></i>
                                        <span>{opt.label}</span>
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>

                              <div className="col-12 col-md-6">
                                <label className="form-label small fw-bold text-muted mb-1">
                                  <i className="bi bi-card-text me-1 text-primary"></i> Tamaño Subtítulo
                                </label>
                                <div className="d-flex align-items-center p-1 bg-light rounded-pill border w-100">
                                  {[
                                    { id: 'small', label: 'Chico' },
                                    { id: 'medium', label: 'Mediano' },
                                    { id: 'large', label: 'Grande' }
                                  ].map(opt => {
                                    const isSelected = (promo.subtitleFontSize || 'medium') === opt.id;
                                    return (
                                      <button
                                        key={opt.id}
                                        type="button"
                                        className={`btn btn-sm rounded-pill fw-bold transition-all flex-grow-1 ${
                                          isSelected ? 'btn-primary text-white shadow-xs' : 'btn-link text-secondary text-decoration-none'
                                        }`}
                                        style={{ padding: '0.22rem 0.35rem', fontSize: '0.72rem' }}
                                        onClick={() => handlePromoBannerChange(idx, 'subtitleFontSize', opt.id)}
                                      >
                                        {opt.label}
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>

                              <div className="col-12 col-md-6">
                                <label className="form-label small fw-bold text-muted mb-1">
                                  <i className="bi bi-palette me-1 text-primary"></i> Estilo del Botón
                                </label>
                                <select
                                  className="form-select form-select-sm fw-semibold rounded-3"
                                  value={promo.buttonStyle || 'warning'}
                                  onChange={(e) => handlePromoBannerChange(idx, 'buttonStyle', e.target.value)}
                                >
                                  <option value="warning">Amarillo Destacado (Warning)</option>
                                  <option value="primary">Azul Corporativo (Primary)</option>
                                  <option value="light">Blanco Sólido (Light)</option>
                                  <option value="dark">Negro / Carbón (Dark)</option>
                                  <option value="outline-light">Borde Blanco (Outline Light)</option>
                                  <option value="outline-dark">Borde Oscuro (Outline Dark)</option>
                                </select>
                              </div>

                              {/* Disposición individual de títulos */}
                              <div className="col-12 col-md-6">
                                <label className="form-label small fw-bold text-muted mb-1">
                                  <i className="bi bi-layout-text-window-reverse me-1 text-primary"></i> Ubicación de Títulos en este Banner
                                </label>
                                <select
                                  className="form-select form-select-sm fw-semibold rounded-3"
                                  value={promo.cardStyle || 'inherit'}
                                  onChange={(e) => handlePromoBannerChange(idx, 'cardStyle', e.target.value)}
                                >
                                  <option value="inherit">Heredar de la sección ({(config.promoBannersSettings?.cardStyle || 'overlay') === 'below' ? 'Debajo de la foto' : 'Superpuesto'})</option>
                                  <option value="overlay">Superpuesto sobre la imagen</option>
                                  <option value="below">Debajo de la imagen (Estilo Ficha)</option>
                                </select>
                              </div>

                              {/* Color de Título y Subtítulo de este Banner */}
                              <div className="col-12 col-md-6">
                                <label className="form-label small fw-bold text-muted mb-1">Color de Fuente - Título</label>
                                <div className="d-flex align-items-center gap-2">
                                  <input
                                    type="color"
                                    className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                                    style={{ width: '38px', height: '30px' }}
                                    value={promo.titleColor || ((promo.cardStyle || config.promoBannersSettings?.cardStyle) === 'below' ? '#1e293b' : '#ffffff')}
                                    onChange={(e) => handlePromoBannerChange(idx, 'titleColor', e.target.value)}
                                  />
                                  <input
                                    type="text"
                                    className="form-control form-control-sm font-monospace"
                                    style={{ maxWidth: '100px' }}
                                    value={promo.titleColor || ''}
                                    onChange={(e) => handlePromoBannerChange(idx, 'titleColor', e.target.value)}
                                    placeholder="Auto"
                                  />
                                  {promo.titleColor && (
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                      style={{ width: '26px', height: '26px', padding: 0 }}
                                      title="Restablecer color por defecto"
                                      onClick={() => handlePromoBannerChange(idx, 'titleColor', '')}
                                    >
                                      <i className="bi bi-x" style={{ fontSize: '0.85rem' }}></i>
                                    </button>
                                  )}
                                </div>
                              </div>

                              <div className="col-12 col-md-6">
                                <label className="form-label small fw-bold text-muted mb-1">Color de Fuente - Subtítulo</label>
                                <div className="d-flex align-items-center gap-2">
                                  <input
                                    type="color"
                                    className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                                    style={{ width: '38px', height: '30px' }}
                                    value={promo.subtitleColor || ((promo.cardStyle || config.promoBannersSettings?.cardStyle) === 'below' ? '#64748b' : '#f1f5f9')}
                                    onChange={(e) => handlePromoBannerChange(idx, 'subtitleColor', e.target.value)}
                                  />
                                  <input
                                    type="text"
                                    className="form-control form-control-sm font-monospace"
                                    style={{ maxWidth: '100px' }}
                                    value={promo.subtitleColor || ''}
                                    onChange={(e) => handlePromoBannerChange(idx, 'subtitleColor', e.target.value)}
                                    placeholder="Auto"
                                  />
                                  {promo.subtitleColor && (
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                      style={{ width: '26px', height: '26px', padding: 0 }}
                                      title="Restablecer color por defecto"
                                      onClick={() => handlePromoBannerChange(idx, 'subtitleColor', '')}
                                    >
                                      <i className="bi bi-x" style={{ fontSize: '0.85rem' }}></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* PESTAÑA 4: NOVEDADES & OFERTAS (/novedades) */}
      {activeTab === 'novedades' && (
        <div className="bg-white p-4 rounded-4 border shadow-sm">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div>
              <h5 className="fw-bold text-dark mb-1">Publicaciones de Novedades y Ofertas de Temporada</h5>
              <p className="text-muted small mb-0">Gestioná los lanzamientos y flyers que se publican en la sección <code>/novedades</code>.</p>
            </div>
            <button type="button" className="btn btn-outline-primary btn-sm rounded-pill fw-bold" onClick={handleAddNovedad}>
              <i className="bi bi-plus-lg me-1"></i> Nueva Publicación
            </button>
          </div>

          <div className="row g-4">
            {(config.novedadesPosts || []).map((post, idx) => (
              <div key={post.id || idx} className="col-12">
                <div className="p-4 rounded-4 border bg-light">
                  <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
                    <div className="d-flex align-items-center gap-2">
                      <span className="badge bg-primary text-white font-monospace">Novedad #{idx + 1}</span>
                      <span className={`badge bg-${post.badgeColor || 'warning'} text-dark fw-bold`}>{post.badge || 'PROMO'}</span>
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm rounded-pill"
                      onClick={() => handleDeleteNovedad(idx)}
                      disabled={(config.novedadesPosts || []).length <= 1}
                    >
                      <i className="bi bi-trash"></i> Eliminar
                    </button>
                  </div>

                  <div className="row g-3">
                    {/* Imagen de la novedad */}
                    <div className="col-lg-3 col-md-4 col-12">
                      <label className="form-label small fw-bold text-muted">Flyer / Imagen</label>
                      <div className="ratio ratio-1x1 rounded-3 overflow-hidden border mb-2 bg-light shadow-xs">
                        <CardPreviewImage
                          url={post.image}
                          alt={post.title}
                        />
                      </div>
                      <label className="btn btn-outline-primary btn-sm w-100 rounded-pill fw-semibold" style={{ cursor: 'pointer' }}>
                        <i className="bi bi-upload me-1"></i> Subir Imagen
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={(e) => handleUploadImage(e, (url) => handleNovedadChange(idx, 'image', url), 'novedades')}
                        />
                      </label>
                      {post.image && (
                        <button
                          type="button"
                          className="btn btn-link btn-sm text-danger text-decoration-none w-100 mt-1.5 p-0 d-flex align-items-center justify-content-center gap-1"
                          style={{ fontSize: '0.76rem' }}
                          onClick={() => handleNovedadChange(idx, 'image', '')}
                        >
                          <i className="bi bi-trash3"></i>
                          <span>Quitar imagen</span>
                        </button>
                      )}
                    </div>

                    {/* Campos de la novedad */}
                    <div className="col-lg-9 col-md-8 col-12">
                      <div className="row g-2">
                        <div className="col-md-7">
                          <label className="form-label small fw-bold text-muted">Título de la Novedad</label>
                          <input
                            type="text"
                            className="form-control form-control-sm fw-bold"
                            value={post.title || ''}
                            onChange={(e) => handleNovedadChange(idx, 'title', e.target.value)}
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label small fw-bold text-muted">Texto del Badge</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={post.badge || ''}
                            onChange={(e) => handleNovedadChange(idx, 'badge', e.target.value)}
                            placeholder="Ej. LANZAMIENTO"
                          />
                        </div>
                        <div className="col-md-2">
                          <label className="form-label small fw-bold text-muted">Color Badge</label>
                          <select
                            className="form-select form-select-sm"
                            value={post.badgeColor || 'warning'}
                            onChange={(e) => handleNovedadChange(idx, 'badgeColor', e.target.value)}
                          >
                            <option value="warning">Amarillo (Warning)</option>
                            <option value="danger">Rojo (Danger)</option>
                            <option value="success">Verde (Success)</option>
                            <option value="primary">Azul (Primary)</option>
                            <option value="info">Celeste (Info)</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label small fw-bold text-muted">Fecha / Vigencia</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={post.date || ''}
                            onChange={(e) => handleNovedadChange(idx, 'date', e.target.value)}
                            placeholder="Ej. Temporada Actual"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label small fw-bold text-muted">Rubro Asociado</label>
                          <select
                            className="form-select form-select-sm"
                            value={post.rubroTarget || ''}
                            onChange={(e) => handleNovedadChange(idx, 'rubroTarget', e.target.value)}
                          >
                            <option value="">-- Sin Rubro Específico --</option>
                            {rubros.map(r => (
                              <option key={r.c_rubro || r.id} value={r.d_rubro || r.nombre}>
                                {r.d_rubro || r.nombre}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12">
                          <label className="form-label small fw-bold text-muted">Descripción Detallada</label>
                          <textarea
                            className="form-control form-control-sm"
                            rows="2"
                            value={post.description || ''}
                            onChange={(e) => handleNovedadChange(idx, 'description', e.target.value)}
                          ></textarea>
                        </div>
                        
                        {/* 3 Bullets / Puntos Clave */}
                        <div className="col-12">
                          <label className="form-label small fw-bold text-muted mb-1">Puntos Clave / Beneficios Rápidos (3 items)</label>
                          <div className="row g-2">
                            {[0, 1, 2].map((bIdx) => (
                              <div key={bIdx} className="col-md-4">
                                <div className="input-group input-group-sm">
                                  <span className="input-group-text bg-white"><i className="bi bi-check2-circle text-success"></i></span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Punto destacado #${bIdx + 1}`}
                                    value={(post.bulletPoints && post.bulletPoints[bIdx]) || ''}
                                    onChange={(e) => handleNovedadBulletChange(idx, bIdx, e.target.value)}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="col-12">
                          <label className="form-label small fw-bold text-muted">Mensaje Predeterminado de WhatsApp al Consultar</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={post.whatsappMessage || ''}
                            onChange={(e) => handleNovedadChange(idx, 'whatsappMessage', e.target.value)}
                            placeholder="¡Hola! Me comunico para consultar por..."
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

            {/* PESTAÑA: BANNERS SECUNDARIOS (ENVÍOS & SERVICIOS) */}
      {activeTab === 'secondaryBanner' && (
        <div className="bg-white p-4 rounded-4 border shadow-sm">
          <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-4 pb-3 border-bottom gap-2">
            <div>
              <div className="d-flex align-items-center gap-2 mb-1">
                <span className="badge bg-primary-subtle text-primary fw-bold text-uppercase px-3 py-1 rounded-pill">
                  Banners Intermedios
                </span>
                <span className="badge bg-light text-muted border font-monospace">Portada Web</span>
              </div>
              <h5 className="fw-bold text-dark mb-1">
                <i className="bi bi-truck text-primary me-2"></i>
                Banners Secundarios (Envíos, Logística & Servicios)
              </h5>
              <p className="text-muted small mb-0">
                Sección de banners fotográficos ubicada más abajo en la portada. Ideal para destacar envíos a todo el país, fotos de camiones, servicios o llamados a la acción con textos y botones alineados a gusto.
              </p>
            </div>
          </div>

          <UnifiedBannersAdminSection
            banners={config.secondaryBanners || DEFAULT_SECONDARY_BANNERS}
            carouselSettings={config.secondaryCarouselSettings || {
              sizePreset: 'standard',
              widthMode: 'container',
              fitMode: 'cover',
              borderRadius: '16px'
            }}
            onBannersChange={(newBanners) => {
              setConfig(prev => ({
                ...prev,
                secondaryBanners: newBanners
              }));
            }}
            onCarouselSettingsChange={(field, value) => {
              setConfig(prev => ({
                ...prev,
                secondaryCarouselSettings: {
                  ...(prev.secondaryCarouselSettings || DEFAULT_LANDING_CONFIG.secondaryCarouselSettings),
                  [field]: value
                }
              }));
            }}
            companyId={selectedCompanyId}
            showLivePreview={true}
            title="Dimensiones y Medidas del Banner Secundario"
            subtitle="Personalizá formato, bordes y proporción para este banner fotográfico intermedio de la portada."
          />
        </div>
      )}

      {/* PESTAÑA 5: SOBRE NOSOTROS (/empresa) */}
      {activeTab === 'about' && (
        <div className="bg-white p-4 rounded-4 border shadow-sm">
          <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-4 pb-3 border-bottom gap-2">
            <div>
              <div className="d-flex align-items-center gap-2 mb-1">
                <span className="badge bg-primary-subtle text-primary fw-bold text-uppercase px-3 py-1 rounded-pill">
                  Institucional
                </span>
                <span className="badge bg-light text-muted border font-monospace">Portada e Historia</span>
              </div>
              <h5 className="fw-bold text-dark mb-1">Contenido Institucional de la Empresa (Inicio y /empresa)</h5>
              <p className="text-muted small mb-0">Configurá la historia, fotos, estadísticas y el bloque institucional de presentación de la portada.</p>
            </div>
            <div className="form-check form-switch d-flex align-items-center gap-2 bg-light px-3 py-2 rounded-pill border mb-0">
              <input
                className="form-check-input ms-0 cursor-pointer"
                type="checkbox"
                role="switch"
                id="aboutEnabled"
                checked={config.aboutSection?.enabled !== false}
                onChange={(e) => setConfig({
                  ...config,
                  aboutSection: { ...(config.aboutSection || {}), enabled: e.target.checked }
                })}
              />
              <label className="form-check-label fw-bold small text-dark cursor-pointer mb-0" htmlFor="aboutEnabled">
                {config.aboutSection?.enabled !== false ? 'Sección Habilitada' : 'Sección Oculta'}
              </label>
            </div>
          </div>

          {/* 1. SECCIÓN TEASER EN LA PORTADA (HOME) */}
          <div className="p-3 p-md-4 bg-light rounded-4 border mb-4 shadow-xs">
            <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-3 pb-2 border-bottom gap-2">
              <div>
                <h6 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                  <i className="bi bi-house-door text-primary"></i>
                  <span>1. Bloque de Empresa en la Portada (Inicio)</span>
                </h6>
                <small className="text-muted">Personalizá cómo se ve la presentación institucional en el Home.</small>
              </div>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div className="d-flex align-items-center gap-2">
                  <label className="small text-muted mb-0 fw-semibold">Fondo:</label>
                  <input
                    type="color"
                    className="form-control form-control-color border rounded-3 p-1 cursor-pointer"
                    style={{ width: '38px', height: '32px' }}
                    value={config.aboutSection?.backgroundColor || '#ffffff'}
                    onChange={(e) => setConfig({
                      ...config,
                      aboutSection: { ...(config.aboutSection || {}), backgroundColor: e.target.value }
                    })}
                    title="Color de fondo del bloque en el Home"
                  />
                </div>
                <div className="d-flex align-items-center gap-2">
                  <label className="small text-muted mb-0 fw-semibold">Fuente:</label>
                  <select
                    className="form-select form-select-sm fw-semibold"
                    style={{ maxWidth: '140px' }}
                    value={config.aboutSection?.fontFamily || 'inherit'}
                    onChange={(e) => setConfig({
                      ...config,
                      aboutSection: { ...(config.aboutSection || {}), fontFamily: e.target.value }
                    })}
                  >
                    <option value="inherit">Heredar</option>
                    {AVAILABLE_FONTS.map(f => (
                      <option key={f.id} value={f.id}>{f.id}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label small fw-bold text-dark mb-1">Etiqueta Superior (Badge)</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.aboutSection?.badgeText ?? 'Fábrica Directa'}
                  onChange={(e) => setConfig({
                    ...config,
                    aboutSection: { ...(config.aboutSection || {}), badgeText: e.target.value }
                  })}
                  placeholder="Ej. Fábrica Directa o Nuestra Trayectoria"
                />
              </div>

              <div className="col-md-8">
                <label className="form-label small fw-bold text-dark mb-1">Título Principal en Portada</label>
                <input
                  type="text"
                  className="form-control form-control-sm fw-bold"
                  value={config.aboutSection?.homeTitle || config.aboutSection?.title || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    aboutSection: { 
                      ...(config.aboutSection || {}), 
                      homeTitle: e.target.value,
                      title: config.aboutSection?.title || e.target.value
                    }
                  })}
                  placeholder="Ej. Más de 30 años liderando en cartón, envases y embalajes"
                />
              </div>

              <div className="col-12">
                <label className="form-label small fw-bold text-dark mb-1">Descripción / Párrafo de Presentación en Portada</label>
                <textarea
                  className="form-control form-control-sm"
                  rows="3"
                  value={config.aboutSection?.paragraph1 || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    aboutSection: { ...(config.aboutSection || {}), paragraph1: e.target.value }
                  })}
                  placeholder="Somos una empresa argentina dedicada a la fabricación..."
                ></textarea>
              </div>

              {/* Botones de Acción */}
              <div className="col-md-3">
                <label className="form-label small fw-bold text-muted mb-1">Texto Botón 1</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.aboutSection?.button1Text ?? 'Conocer Nuestra Empresa'}
                  onChange={(e) => setConfig({
                    ...config,
                    aboutSection: { ...(config.aboutSection || {}), button1Text: e.target.value }
                  })}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label small fw-bold text-muted mb-1">Enlace Botón 1</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.aboutSection?.button1Link ?? '/empresa'}
                  onChange={(e) => setConfig({
                    ...config,
                    aboutSection: { ...(config.aboutSection || {}), button1Link: e.target.value }
                  })}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label small fw-bold text-muted mb-1">Texto Botón 2</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.aboutSection?.button2Text ?? 'Solicitar Asesoramiento'}
                  onChange={(e) => setConfig({
                    ...config,
                    aboutSection: { ...(config.aboutSection || {}), button2Text: e.target.value }
                  })}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label small fw-bold text-muted mb-1">Enlace Botón 2</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.aboutSection?.button2Link ?? '/contacto'}
                  onChange={(e) => setConfig({
                    ...config,
                    aboutSection: { ...(config.aboutSection || {}), button2Link: e.target.value }
                  })}
                />
              </div>

              {/* Tarjeta Flotante sobre la Foto */}
              <div className="col-12 border-top pt-3 mt-2">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="small fw-bold text-dark">Tarjeta Flotante de Confianza (sobre la foto en el Home):</span>
                  <div className="form-check form-switch mb-0">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id="floatingBadgeSwitch"
                      checked={config.aboutSection?.floatingBadgeShow !== false}
                      onChange={(e) => setConfig({
                        ...config,
                        aboutSection: { ...(config.aboutSection || {}), floatingBadgeShow: e.target.checked }
                      })}
                    />
                    <label className="form-check-label small fw-semibold text-muted cursor-pointer" htmlFor="floatingBadgeSwitch">
                      {config.aboutSection?.floatingBadgeShow !== false ? 'Visible' : 'Oculta'}
                    </label>
                  </div>
                </div>
                {config.aboutSection?.floatingBadgeShow !== false && (
                  <div className="row g-2">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Título flotante (ej. Calidad & Stock Permanente)"
                        value={config.aboutSection?.floatingBadgeTitle ?? 'Calidad & Stock Permanente'}
                        onChange={(e) => setConfig({
                          ...config,
                          aboutSection: { ...(config.aboutSection || {}), floatingBadgeTitle: e.target.value }
                        })}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Subtítulo flotante (ej. Despachos rápidos a toda la Argentina)"
                        value={config.aboutSection?.floatingBadgeSubtitle ?? 'Despachos rápidos a toda la Argentina'}
                        onChange={(e) => setConfig({
                          ...config,
                          aboutSection: { ...(config.aboutSection || {}), floatingBadgeSubtitle: e.target.value }
                        })}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* 2. IMAGEN INSTITUCIONAL */}
          <div className="row g-4 mb-4">
            <div className="col-lg-5 col-12">
              <div className="p-3 bg-light rounded-4 border h-100">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <label className="form-label small fw-bold text-dark mb-0">
                    <i className="bi bi-image me-1 text-primary"></i> Foto Institucional / Planta
                  </label>
                  <div className="form-check form-switch mb-0" title="Activar degradé/sombra sobre la foto">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id="aboutPhotoGradientSwitch"
                      checked={config.aboutSection?.showGradient === true}
                      onChange={(e) => setConfig({
                        ...config,
                        aboutSection: { ...(config.aboutSection || {}), showGradient: e.target.checked }
                      })}
                    />
                    <label className="form-check-label small fw-semibold text-muted cursor-pointer" htmlFor="aboutPhotoGradientSwitch">
                      {config.aboutSection?.showGradient ? 'Degradé' : 'Nítida'}
                    </label>
                  </div>
                </div>

                <div className="ratio ratio-16x9 rounded-3 overflow-hidden border mb-2 bg-light shadow-xs position-relative">
                  <CardPreviewImage
                    url={config.aboutSection?.image}
                    alt="Empresa"
                  />
                </div>

                <div className="input-group input-group-sm">
                  <input
                    type="text"
                    className="form-control font-monospace"
                    value={config.aboutSection?.image || ''}
                    onChange={(e) => setConfig({
                      ...config,
                      aboutSection: { ...(config.aboutSection || {}), image: e.target.value }
                    })}
                    placeholder="/media/..."
                  />
                  <label className="btn btn-primary d-inline-flex align-items-center gap-1 cursor-pointer mb-0">
                    <i className="bi bi-upload"></i> Subir Foto
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={(e) => handleUploadImage(e, (url) => setConfig({
                        ...config,
                        aboutSection: { ...(config.aboutSection || {}), image: url }
                      }), 'about')}
                    />
                  </label>
                </div>
                {config.aboutSection?.image && (
                  <button
                    type="button"
                    className="btn btn-link btn-sm text-danger text-decoration-none p-0 mt-1.5 d-inline-flex align-items-center gap-1"
                    style={{ fontSize: '0.75rem' }}
                    onClick={() => setConfig({
                      ...config,
                      aboutSection: { ...(config.aboutSection || {}), image: '' }
                    })}
                  >
                    <i className="bi bi-trash3"></i>
                    <span>Quitar imagen</span>
                  </button>
                )}
              </div>
            </div>

            {/* 3. CAMPOS ADICIONALES PARA LA PÁGINA COMPLETA /empresa */}
            <div className="col-lg-7 col-12">
              <div className="p-3 bg-light rounded-4 border h-100">
                <h6 className="fw-bold text-dark mb-2 d-flex align-items-center gap-2">
                  <i className="bi bi-building text-primary"></i>
                  <span>2. Información Adicional para Página /empresa</span>
                </h6>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">Título de la Página /empresa</label>
                    <input
                      type="text"
                      className="form-control form-control-sm fw-bold"
                      value={config.aboutSection?.title || ''}
                      onChange={(e) => setConfig({
                        ...config,
                        aboutSection: { ...(config.aboutSection || {}), title: e.target.value }
                      })}
                      placeholder="Ej. Sobre Nuestra Empresa"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">Eslogan / Bajada</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={config.aboutSection?.tagline || ''}
                      onChange={(e) => setConfig({
                        ...config,
                        aboutSection: { ...(config.aboutSection || {}), tagline: e.target.value }
                      })}
                      placeholder="Ej. Más de 30 años de experiencia e innovación"
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-bold text-muted mb-1">Párrafo 2 (Alcance y Propuesta de Valor)</label>
                    <textarea
                      className="form-control form-control-sm"
                      rows="3"
                      value={config.aboutSection?.paragraph2 || ''}
                      onChange={(e) => setConfig({
                        ...config,
                        aboutSection: { ...(config.aboutSection || {}), paragraph2: e.target.value }
                      })}
                      placeholder="Brindamos atención personalizada tanto a comercios..."
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 3. Métricas y Estadísticas Modulares */}
          <div className="p-3 p-md-4 bg-light rounded-4 border">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                <div>
                  <h6 className="fw-bold text-dark mb-0">
                    Métricas Destacadas e Indicadores de Confianza
                    <span className="badge bg-primary-subtle text-primary border ms-2 font-monospace">
                      {(config.aboutSection?.stats || []).length} Indicadores
                    </span>
                  </h6>
                  <p className="text-muted small mb-0" style={{ fontSize: '0.8rem' }}>
                    Podés agregar, quitar, ordenar o editar las cifras y etiquetas destacadas de la empresa.
                  </p>
                </div>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm rounded-pill fw-semibold px-3 py-2 d-flex align-items-center gap-2 shadow-xs"
                  onClick={handleAddStat}
                >
                  <i className="bi bi-plus-circle me-1"></i> Agregar Métrica
                </button>
              </div>

              {(!config.aboutSection?.stats || config.aboutSection.stats.length === 0) ? (
                <div className="text-center p-4 bg-light border border-dashed rounded-3 text-muted small">
                  <i className="bi bi-bar-chart fs-3 d-block mb-1 text-secondary"></i>
                  No hay métricas configuradas actualmente. Hacé clic en <strong>Agregar Métrica</strong> para sumar indicadores clave.
                </div>
              ) : (
                <div className="row g-3">
                  {(config.aboutSection?.stats || []).map((stat, sIdx, arr) => (
                    <div key={sIdx} className="col-12 col-sm-6 col-lg-4 col-xl-3">
                      <div className="p-3 bg-light rounded-3 border h-100 position-relative shadow-xs d-flex flex-column justify-content-between">
                        <div>
                          <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom">
                            <span className="badge bg-white text-dark border small fw-bold font-monospace">
                              #{sIdx + 1} Indicador
                            </span>
                            <div className="d-flex align-items-center gap-1">
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                style={{ width: '24px', height: '24px', padding: 0 }}
                                onClick={() => handleMoveStat(sIdx, -1)}
                                disabled={sIdx === 0}
                                title="Mover a la izquierda"
                              >
                                <i className="bi bi-chevron-left" style={{ fontSize: '0.75rem' }}></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                style={{ width: '24px', height: '24px', padding: 0 }}
                                onClick={() => handleMoveStat(sIdx, 1)}
                                disabled={sIdx === arr.length - 1}
                                title="Mover a la derecha"
                              >
                                <i className="bi bi-chevron-right" style={{ fontSize: '0.75rem' }}></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center ms-1"
                                style={{ width: '24px', height: '24px', padding: 0 }}
                                onClick={() => handleDeleteStat(sIdx)}
                                title="Eliminar Métrica"
                              >
                                <i className="bi bi-trash" style={{ fontSize: '0.75rem' }}></i>
                              </button>
                            </div>
                          </div>

                          <div className="mb-2">
                            <label className="form-label small fw-bold text-muted mb-1">Número / Cifra</label>
                            <input
                              type="text"
                              className="form-control form-control-sm fw-bold text-primary"
                              value={stat.number || ''}
                              onChange={(e) => handleStatChange(sIdx, 'number', e.target.value)}
                              placeholder="Ej. 30+, 1000+, 24h"
                            />
                          </div>

                          <div>
                            <label className="form-label small fw-bold text-muted mb-1">Etiqueta / Descripción</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={stat.label || ''}
                              onChange={(e) => handleStatChange(sIdx, 'label', e.target.value)}
                              placeholder="Ej. Años de Trayectoria"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
      )}

      {/* PESTAÑA 6: DÓNDE ESTAMOS & SEDES (/donde-estamos) */}
      {activeTab === 'location' && (
        <div className="bg-white p-4 rounded-4 border shadow-sm">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4 pb-3 border-bottom">
            <div>
              <div className="d-flex align-items-center gap-2 mb-1">
                <span className="badge bg-primary-subtle text-primary fw-bold font-monospace px-3 py-1 rounded-pill">
                  /donde-estamos
                </span>
                <span className="badge bg-light text-muted border font-monospace">
                  {(config.locationSection?.locations || []).length} Direcciones
                </span>
              </div>
              <h5 className="fw-bold text-dark mb-1">Gestión de Sedes, Sucursales y Fábricas</h5>
              <p className="text-muted small mb-0">Configurá las diferentes direcciones de la empresa (Fábrica, Showroom, Depósito, Sucursales, etc.) con sus horarios y accesos.</p>
            </div>
            <button
              type="button"
              className="btn btn-primary btn-sm rounded-pill fw-semibold px-3 py-2 d-flex align-items-center gap-2 shadow-xs"
              onClick={handleAddLocation}
            >
              <i className="bi bi-plus-circle me-1"></i> Agregar Dirección / Sede
            </button>
          </div>

          {/* Lista Modular de Sedes / Direcciones */}
          <div className="mb-4">
            {(!config.locationSection?.locations || config.locationSection.locations.length === 0) ? (
              <div className="text-center p-4 bg-light border border-dashed rounded-4 text-muted small">
                <i className="bi bi-geo-alt fs-3 d-block mb-2 text-secondary"></i>
                No hay direcciones o sedes configuradas. Hacé clic en <strong>Agregar Dirección / Sede</strong> para sumar puntos de atención o retiro.
              </div>
            ) : (
              <div className="d-flex flex-column gap-3">
                {(config.locationSection?.locations || []).map((loc, lIdx, arr) => (
                  <div key={loc.id || lIdx} className={`card border rounded-4 shadow-xs overflow-hidden transition-all ${loc.is_active !== false ? 'bg-white' : 'bg-light opacity-75'}`}>
                    {/* Header de la Tarjeta de Sede */}
                    <div className="card-header bg-light bg-opacity-75 py-2 px-3 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
                      <div className="d-flex align-items-center gap-2">
                        <span className="badge bg-primary text-white font-monospace fw-bold px-2 py-1 rounded-pill" style={{ fontSize: '0.75rem' }}>
                          Sede #{lIdx + 1}
                        </span>
                        <strong className="text-dark small">{loc.title || 'Sede sin título'}</strong>
                        {loc.badge && (
                          <span className="badge bg-white text-secondary border small">{loc.badge}</span>
                        )}
                      </div>

                      <div className="d-flex align-items-center gap-2">
                        <div className="form-check form-switch m-0 d-flex align-items-center gap-1">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            checked={loc.is_active !== false}
                            onChange={(e) => handleLocationItemChange(lIdx, 'is_active', e.target.checked)}
                            id={`loc-active-${lIdx}`}
                          />
                          <label className="form-check-label small fw-semibold text-muted" htmlFor={`loc-active-${lIdx}`}>
                            {loc.is_active !== false ? 'Visible' : 'Oculta'}
                          </label>
                        </div>

                        <div className="d-flex align-items-center gap-1 ms-2">
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: '26px', height: '26px', padding: 0 }}
                            onClick={() => handleMoveLocation(lIdx, -1)}
                            disabled={lIdx === 0}
                            title="Subir posición"
                          >
                            <i className="bi bi-chevron-up" style={{ fontSize: '0.75rem' }}></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: '26px', height: '26px', padding: 0 }}
                            onClick={() => handleMoveLocation(lIdx, 1)}
                            disabled={lIdx === arr.length - 1}
                            title="Bajar posición"
                          >
                            <i className="bi bi-chevron-down" style={{ fontSize: '0.75rem' }}></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center ms-1"
                            style={{ width: '26px', height: '26px', padding: 0 }}
                            onClick={() => handleDeleteLocation(lIdx)}
                            title="Eliminar Sede"
                          >
                            <i className="bi bi-trash" style={{ fontSize: '0.8rem' }}></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Formulario de la Sede */}
                    <div className="card-body p-4">
                      <div className="row g-3">
                        <div className="col-md-5">
                          <label className="form-label small fw-bold text-dark mb-1">Nombre / Título de la Sede</label>
                          <input
                            type="text"
                            className="form-control form-control-sm fw-semibold"
                            value={loc.title || ''}
                            onChange={(e) => handleLocationItemChange(lIdx, 'title', e.target.value)}
                            placeholder="Ej. Planta de Fabricación y Retiro / Showroom CABA / Depósito"
                          />
                        </div>

                        <div className="col-md-3">
                          <label className="form-label small fw-bold text-dark mb-1">Etiqueta / Tipo</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={loc.badge || ''}
                            onChange={(e) => handleLocationItemChange(lIdx, 'badge', e.target.value)}
                            placeholder="Ej. Casa Central & Fábrica, Showroom, Depósito"
                          />
                        </div>

                        <div className="col-md-4">
                          <label className="form-label small fw-bold text-dark mb-1">Horario de Atención / Retiros</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={loc.schedule || ''}
                            onChange={(e) => handleLocationItemChange(lIdx, 'schedule', e.target.value)}
                            placeholder="Ej. Lun a Vie de 08:00 a 18:00 hs"
                          />
                        </div>

                        <div className="col-md-8">
                          <label className="form-label small fw-bold text-dark mb-1">Dirección Completa</label>
                          <div className="input-group input-group-sm">
                            <span className="input-group-text bg-light text-muted">
                              <i className="bi bi-geo-alt"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={loc.address || ''}
                              onChange={(e) => handleLocationItemChange(lIdx, 'address', e.target.value)}
                              placeholder="Ej. Vicente Damonte 1237, Lanús Este, Buenos Aires"
                            />
                            {loc.address && (
                              <a
                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc.address)}`}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-secondary"
                                title="Abrir en Google Maps"
                              >
                                <i className="bi bi-box-arrow-up-right me-1"></i> Maps
                              </a>
                            )}
                          </div>
                        </div>

                        <div className="col-md-2">
                          <label className="form-label small fw-bold text-dark mb-1">Teléfono</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={loc.phone || ''}
                            onChange={(e) => handleLocationItemChange(lIdx, 'phone', e.target.value)}
                            placeholder="Ej. (011) 4247-6622"
                          />
                        </div>

                        <div className="col-md-2">
                          <label className="form-label small fw-bold text-dark mb-1">WhatsApp</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={loc.whatsapp || ''}
                            onChange={(e) => handleLocationItemChange(lIdx, 'whatsapp', e.target.value)}
                            placeholder="Ej. 5491142476622"
                          />
                        </div>

                        <div className="col-12">
                          <label className="form-label small fw-bold text-dark mb-1">Descripción / Servicios en esta sede</label>
                          <textarea
                            className="form-control form-control-sm"
                            rows="2"
                            value={loc.description || ''}
                            onChange={(e) => handleLocationItemChange(lIdx, 'description', e.target.value)}
                            placeholder="Detalle de actividades, atención a mayoristas, zona de carga, muestras disponibles, etc."
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Instrucciones de Transporte y Acceso */}
          <div className="border-top pt-4 mt-4">
            <h6 className="fw-bold text-dark mb-1">Instrucciones de Transporte y Acceso General</h6>
            <p className="text-muted small mb-3">Estas indicaciones se mostrarán en la parte inferior de la página de ubicación para guiar a los clientes.</p>

            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label small fw-bold text-muted">En Automóvil / Utilitario / Camión</label>
                <textarea
                  className="form-control form-control-sm"
                  rows="3"
                  value={config.locationSection?.carAccess || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    locationSection: { ...(config.locationSection || {}), carAccess: e.target.value }
                  })}
                  placeholder="Instrucciones de autopistas, avenidas principales y zonas de carga..."
                ></textarea>
              </div>
              <div className="col-md-4">
                <label className="form-label small fw-bold text-muted">En Tren / Ferrocarril</label>
                <textarea
                  className="form-control form-control-sm"
                  rows="3"
                  value={config.locationSection?.trainAccess || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    locationSection: { ...(config.locationSection || {}), trainAccess: e.target.value }
                  })}
                  placeholder="Líneas y estaciones de tren cercanas..."
                ></textarea>
              </div>
              <div className="col-md-4">
                <label className="form-label small fw-bold text-muted">En Colectivo / Líneas</label>
                <textarea
                  className="form-control form-control-sm"
                  rows="3"
                  value={config.locationSection?.busAccess || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    locationSection: { ...(config.locationSection || {}), busAccess: e.target.value }
                  })}
                  placeholder="Líneas de colectivo con parada directa..."
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PESTAÑA 7: CONTACTO & TOPBAR */}
      {activeTab === 'contact' && (
        <div className="bg-white p-4 rounded-4 border shadow-sm">
          {/* Barra Superior */}
          <div className="mb-5 pb-4 border-bottom">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div>
                <h5 className="fw-bold text-dark mb-1">Barra Superior de Anuncios (TopBar)</h5>
                <p className="text-muted small mb-0">Cinta superior que aparece sobre la barra de navegación en todas las páginas de la web.</p>
              </div>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="topBarEnabled"
                  checked={config.topBar?.enabled !== false}
                  onChange={(e) => setConfig({
                    ...config,
                    topBar: { ...(config.topBar || {}), enabled: e.target.checked }
                  })}
                />
                <label className="form-check-label fw-bold small" htmlFor="topBarEnabled">Habilitado</label>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-12">
                <label className="form-label small fw-bold text-muted">Texto del Anuncio Destacado</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.topBar?.announcementText || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    topBar: { ...(config.topBar || {}), announcementText: e.target.value }
                  })}
                  placeholder="Ej. 🚀 ¡Venta Mayorista y Minorista con Envíos a Todo el País!"
                />
              </div>
            </div>
          </div>

          {/* Datos Generales de Contacto */}
          <div>
            <h5 className="fw-bold text-dark mb-1">Información de Contacto y Atención Comercial</h5>
            <p className="text-muted small mb-4">Canales oficiales de atención para el formulario de contacto, WhatsApp y pie de página.</p>

            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label small fw-bold text-muted">Título del Bloque de Contacto</label>
                <input
                  type="text"
                  className="form-control form-control-sm fw-bold"
                  value={config.contactSection?.title || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    contactSection: { ...(config.contactSection || {}), title: e.target.value }
                  })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-bold text-muted">Subtítulo / Bajada</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.contactSection?.subtitle || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    contactSection: { ...(config.contactSection || {}), subtitle: e.target.value }
                  })}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small fw-bold text-muted">Teléfono Central</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.contactSection?.phone || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    contactSection: { ...(config.contactSection || {}), phone: e.target.value },
                    topBar: { ...(config.topBar || {}), phone: e.target.value }
                  })}
                  placeholder="(011) 4247-6622"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small fw-bold text-muted">WhatsApp Comercial (con código de país sin +)</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.contactSection?.whatsapp || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    contactSection: { ...(config.contactSection || {}), whatsapp: e.target.value },
                    topBar: { ...(config.topBar || {}), whatsapp: e.target.value }
                  })}
                  placeholder="5491142476622"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small fw-bold text-muted">Email Oficial de Ventas</label>
                <input
                  type="email"
                  className="form-control form-control-sm"
                  value={config.contactSection?.email || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    contactSection: { ...(config.contactSection || {}), email: e.target.value },
                    topBar: { ...(config.topBar || {}), email: e.target.value }
                  })}
                  placeholder="ventas@empresa.com.ar"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-bold text-muted">Dirección Física</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.contactSection?.address || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    contactSection: { ...(config.contactSection || {}), address: e.target.value }
                  })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-bold text-muted">Horarios de Atención</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.contactSection?.schedule || ''}
                  onChange={(e) => setConfig({
                    ...config,
                    contactSection: { ...(config.contactSection || {}), schedule: e.target.value }
                  })}
                  placeholder="Lunes a Viernes de 08:00 a 18:00 hs | Sábados de 08:00 a 13:00 hs"
                />
              </div>
            </div>
          </div>

          {/* BOTÓN FLOTANTE DE WHATSAPP EN TODA LA WEB */}
          <div className="pt-4 border-top">
            <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <div className="d-flex align-items-center gap-2">
                <div className="p-2 bg-success-subtle text-success rounded-3">
                  <i className="bi bi-whatsapp fs-5"></i>
                </div>
                <div>
                  <h5 className="fw-bold text-dark mb-0">Botón Flotante de WhatsApp (Web y Tienda)</h5>
                  <small className="text-muted">Ajustá la visibilidad, mensaje predeterminado y cartelito flotante para todas las páginas del sitio.</small>
                </div>
              </div>
              <div className="form-check form-switch fs-5 mb-0">
                <input
                  className="form-check-input cursor-pointer"
                  type="checkbox"
                  role="switch"
                  id="switchWhatsappFloating"
                  checked={config.whatsappFloating?.enabled !== false}
                  onChange={(e) => setConfig(prev => ({
                    ...prev,
                    whatsappFloating: {
                      ...(prev.whatsappFloating || DEFAULT_LANDING_CONFIG.whatsappFloating),
                      enabled: e.target.checked
                    }
                  }))}
                />
              </div>
            </div>

            <div className="row g-4 align-items-center">
              
              {/* Controles de Configuración */}
              <div className="col-12 col-lg-8">
                <div className="row g-3">
                  {/* Número de WhatsApp */}
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">
                      Número de WhatsApp Receptor (código de país sin +)
                    </label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text bg-light text-success fw-bold">
                        <i className="bi bi-whatsapp me-1"></i> +
                      </span>
                      <input
                        type="text"
                        className="form-control font-monospace fw-bold"
                        value={config.whatsappFloating?.phone || ''}
                        onChange={(e) => setConfig(prev => ({
                          ...prev,
                          whatsappFloating: {
                            ...(prev.whatsappFloating || DEFAULT_LANDING_CONFIG.whatsappFloating),
                            phone: e.target.value
                          }
                        }))}
                        placeholder="5491142476622"
                      />
                    </div>
                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                      Ej: 5491142476622 (Argentina: 54 + 9 + código de área + número).
                    </small>
                  </div>

                  {/* Texto de la Píldora / Cartelito Flotante */}
                  <div className="col-12 col-md-6">
                    <div className="d-flex align-items-center justify-content-between mb-1">
                      <label className="form-label small fw-bold text-muted mb-0">
                        Texto de la Píldora Emergente
                      </label>
                      <div className="form-check form-switch small mb-0">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          role="switch"
                          id="switchShowPill"
                          checked={config.whatsappFloating?.showPill !== false}
                          onChange={(e) => setConfig(prev => ({
                            ...prev,
                            whatsappFloating: {
                              ...(prev.whatsappFloating || DEFAULT_LANDING_CONFIG.whatsappFloating),
                              showPill: e.target.checked
                            }
                          }))}
                        />
                        <label className="form-check-label text-muted text-xs ms-1" htmlFor="switchShowPill">
                          Mostrar cartel
                        </label>
                      </div>
                    </div>
                    <input
                      type="text"
                      className="form-control form-control-sm fw-semibold"
                      value={config.whatsappFloating?.pillText || ''}
                      onChange={(e) => setConfig(prev => ({
                        ...prev,
                        whatsappFloating: {
                          ...(prev.whatsappFloating || DEFAULT_LANDING_CONFIG.whatsappFloating),
                          pillText: e.target.value
                        }
                      }))}
                      placeholder="¿Dudas? ¡Escribinos!"
                    />
                  </div>

                  {/* Mensaje Predeterminado al Abrir Chat */}
                  <div className="col-12">
                    <label className="form-label small fw-bold text-muted mb-1">
                      Mensaje Inicial Preconfigurado
                    </label>
                    <textarea
                      className="form-control form-control-sm"
                      rows="2"
                      value={config.whatsappFloating?.message || ''}
                      onChange={(e) => setConfig(prev => ({
                        ...prev,
                        whatsappFloating: {
                          ...(prev.whatsappFloating || DEFAULT_LANDING_CONFIG.whatsappFloating),
                          message: e.target.value
                        }
                      }))}
                      placeholder="¡Hola! Me comunico desde el sitio web de Hiperpel para hacer una consulta."
                    ></textarea>
                    <small className="text-muted" style={{ fontSize: '0.72rem' }}>
                      Este texto aparecerá precargado en el WhatsApp del cliente cuando haga clic en el botón flotante.
                    </small>
                  </div>
                </div>
              </div>

              {/* Mini Preview del Botón Flotante */}
              <div className="col-12 col-lg-4 text-center">
                <div className="p-3 bg-light rounded-4 border">
                  <span className="badge bg-white text-muted border rounded-pill px-3 py-1 text-xs mb-3">
                    Vista Previa del Botón
                  </span>
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    {config.whatsappFloating?.showPill !== false && config.whatsappFloating?.pillText && (
                      <div className="bg-white border rounded-pill shadow-xs px-3 py-2 d-flex align-items-center gap-2 small text-dark fw-bold animate-pulse">
                        <i className="bi bi-chat-dots-fill text-success"></i>
                        <span style={{ fontSize: '0.78rem' }}>{config.whatsappFloating?.pillText || '¿Dudas? ¡Escribinos!'}</span>
                      </div>
                    )}
                    <div 
                      className="rounded-circle d-flex align-items-center justify-content-center text-white shadow"
                      style={{
                        width: '46px',
                        height: '46px',
                        backgroundColor: '#25d366',
                        fontSize: '1.4rem'
                      }}
                    >
                      <i className="bi bi-whatsapp"></i>
                    </div>
                  </div>
                  <div className="text-muted mt-2 text-xs">
                    {config.whatsappFloating?.enabled !== false ? (
                      <span className="text-success fw-bold">✓ Activo en toda la web y tienda</span>
                    ) : (
                      <span className="text-danger fw-bold">✕ Desactivado</span>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* SECCIÓN 4: PIE DE PÁGINA (FOOTER) */}
          <div className="pt-4 border-top">
            <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <div className="d-flex align-items-center gap-2">
                <div className="p-2 bg-primary-subtle text-primary rounded-3">
                  <i className="bi bi-layout-text-window-reverse fs-5"></i>
                </div>
                <div>
                  <h5 className="fw-bold text-dark mb-0">Pie de Página (Footer) & Horarios</h5>
                  <small className="text-muted">Personalizá los horarios y el lema institucional visible en el pie de página de toda la web.</small>
                </div>
              </div>
            </div>

            <div className="row g-3">
              {/* Lema / Tagline del Footer */}
              <div className="col-12">
                <label className="form-label small fw-bold text-muted mb-1">
                  Lema / Descripción Institucional del Footer
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.tagline !== undefined ? config.tagline : (config.footer?.tagline || '')}
                  onChange={(e) => {
                    const val = e.target.value;
                    setConfig(prev => ({
                      ...prev,
                      tagline: val,
                      footer: { ...(prev.footer || {}), tagline: val }
                    }));
                  }}
                  placeholder="Fabricantes de productos de cartón, envases, embalajes..."
                />
                <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                  Texto descriptivo que se muestra debajo del logo en el pie de página.
                </small>
              </div>

              {/* Horarios Lunes a Viernes */}
              <div className="col-12 col-md-6">
                <label className="form-label small fw-bold text-muted mb-1">
                  Horarios Lunes a Viernes
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.contactSection?.scheduleMonFri || '08:00 a 18:00 hs'}
                  onChange={(e) => setConfig(prev => ({
                    ...prev,
                    contactSection: {
                      ...(prev.contactSection || DEFAULT_LANDING_CONFIG.contactSection),
                      scheduleMonFri: e.target.value
                    }
                  }))}
                  placeholder="08:00 a 18:00 hs"
                />
              </div>

              {/* Horarios Sábados */}
              <div className="col-12 col-md-6">
                <label className="form-label small fw-bold text-muted mb-1">
                  Horarios Sábados
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={config.contactSection?.scheduleSat || '08:00 a 13:00 hs'}
                  onChange={(e) => setConfig(prev => ({
                    ...prev,
                    contactSection: {
                      ...(prev.contactSection || DEFAULT_LANDING_CONFIG.contactSection),
                      scheduleSat: e.target.value
                    }
                  }))}
                  placeholder="08:00 a 13:00 hs"
                />
              </div>
            </div>

            {/* Identidad del Pie de Página (Logo y Textos del Footer) */}
            <div className="pt-4 mt-4 border-top">
              <div className="d-flex align-items-center gap-2 mb-3">
                <div className="p-2 bg-primary-subtle text-primary rounded-3">
                  <i className="bi bi-layout-text-window-reverse fs-5"></i>
                </div>
                <div>
                  <h6 className="fw-bold text-dark mb-0">Identidad de Marca en Pie de Página (Footer)</h6>
                  <small className="text-muted">Personalizá un logotipo exclusivo para el pie de página (por ejemplo, versión blanca o monocromática) y sus textos.</small>
                </div>
              </div>

              <div className="p-3 bg-light rounded-4 border mb-4">
                <div className="row g-3 align-items-center">
                  {/* Vista previa del Logo del Footer */}
                  <div className="col-12 col-md-3 text-center">
                    <label className="form-label fw-bold text-dark small mb-1 d-block">Logotipo en Footer</label>
                    <div 
                      className="p-3 bg-white rounded-3 border d-flex flex-column align-items-center justify-content-center mx-auto shadow-2xs"
                      style={{ minHeight: '95px', maxWidth: '220px' }}
                    >
                      <LogoPreviewImage url={config.footer?.logoUrl || config.logoUrl} alt={config.footer?.companyName || config.logoText} />
                    </div>
                    <div className="mt-1.5">
                      {config.footer?.logoUrl ? (
                        <div className="d-flex flex-column align-items-center gap-1">
                          <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill" style={{ fontSize: '0.68rem' }}>
                            <i className="bi bi-check2-circle me-1"></i> Logo específico activo
                          </span>
                          <button
                            type="button"
                            className="btn btn-link btn-sm text-danger text-decoration-none p-0"
                            style={{ fontSize: '0.75rem' }}
                            onClick={() => setConfig(prev => ({
                              ...prev,
                              footer: {
                                ...(prev.footer || {}),
                                logoUrl: ''
                              }
                            }))}
                          >
                            <i className="bi bi-arrow-counterclockwise me-1"></i> Usar logo principal
                          </button>
                        </div>
                      ) : (
                        <span className="badge bg-secondary-subtle text-secondary border border-secondary-subtle rounded-pill" style={{ fontSize: '0.68rem' }}>
                          <i className="bi bi-arrow-down-left me-1"></i> Hereda logo principal
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Carga y campos del Footer */}
                  <div className="col-12 col-md-9">
                    <div className="row g-3">
                      <div className="col-12 col-lg-7">
                        <label className="form-label fw-semibold small text-dark mb-1">
                          Subir Logo para el Footer (PNG, SVG, JPG, WEBP)
                        </label>
                        <div className="input-group">
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            accept="image/*"
                            onChange={(e) => handleUploadImage(e, (url) => {
                              setConfig(prev => ({
                                ...prev,
                                footer: {
                                  ...(prev.footer || {}),
                                  logoUrl: url
                                }
                              }));
                            }, 'logo')}
                            disabled={uploadingImage}
                          />
                          {uploadingImage && (
                            <span className="input-group-text bg-light">
                              <span className="spinner-border spinner-border-sm text-primary" role="status"></span>
                            </span>
                          )}
                        </div>
                        <div className="mt-1.5">
                          <input
                            type="text"
                            className="form-control form-control-sm font-monospace"
                            value={config.footer?.logoUrl || ''}
                            onChange={(e) => setConfig(prev => ({
                              ...prev,
                              footer: {
                                ...(prev.footer || {}),
                                logoUrl: e.target.value
                              }
                            }))}
                            placeholder="o pegá una URL directa (/images/logo-blanco.png o https://...)"
                            style={{ fontSize: '0.8rem' }}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-lg-5">
                        <label className="form-label fw-semibold small text-dark mb-1">
                          Nombre visible en Footer
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm fw-bold"
                          value={config.footer?.companyName || ''}
                          onChange={(e) => setConfig(prev => ({
                            ...prev,
                            footer: {
                              ...(prev.footer || {}),
                              companyName: e.target.value
                            }
                          }))}
                          placeholder={config.logoText || 'HIPERPEL S.A.'}
                        />
                        <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                          Si se deja vacío, toma el nombre oficial principal.
                        </small>
                      </div>

                      <div className="col-12">
                        <label className="form-label fw-semibold small text-dark mb-1">
                          Texto de Copyright / Derechos Reservados
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={config.footer?.copyrightText || ''}
                          onChange={(e) => setConfig(prev => ({
                            ...prev,
                            footer: {
                              ...(prev.footer || {}),
                              copyrightText: e.target.value
                            }
                          }))}
                          placeholder={`© ${new Date().getFullYear()} ${config.footer?.companyName || config.logoText || 'SISGECOM'} - Todos los derechos reservados.`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Redes Sociales Oficiales del Footer */}
            <div className="pt-4 mt-4 border-top">
              <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2 mb-3">
                <div className="d-flex align-items-center gap-2">
                  <div className="p-2 bg-danger-subtle text-danger rounded-3">
                    <i className="bi bi-share-fill fs-5"></i>
                  </div>
                  <div>
                    <h6 className="fw-bold text-dark mb-0">Redes Sociales Oficiales</h6>
                    <small className="text-muted">Activá, ocultá y configurá los enlaces de cada red social visible en el pie de página.</small>
                  </div>
                </div>

                <div className="form-check form-switch mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="showSocialsSwitch"
                    checked={config.footer?.showSocials !== false}
                    onChange={(e) => setConfig(prev => ({
                      ...prev,
                      footer: {
                        ...(prev.footer || {}),
                        showSocials: e.target.checked
                      }
                    }))}
                  />
                  <label className="form-check-label small fw-bold text-dark" htmlFor="showSocialsSwitch">
                    Mostrar Redes Sociales en Footer
                  </label>
                </div>
              </div>

              {config.footer?.showSocials !== false && (
                <div className="row g-3">
                  
                  {/* INSTAGRAM */}
                  <div className="col-12 col-md-6">
                    <div className="p-3 bg-light rounded-4 border">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <span className="btn btn-sm rounded-circle p-0 d-inline-flex align-items-center justify-content-center text-white shadow-xs" style={{ width: '28px', height: '28px', background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)', fontSize: '0.85rem' }}>
                            <i className="bi bi-instagram"></i>
                          </span>
                          <span className="small fw-bold text-dark">Instagram</span>
                        </div>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-instagram"
                            checked={Boolean(
                              typeof config.footer?.socialLinks?.instagram === 'object'
                                ? config.footer?.socialLinks?.instagram?.enabled !== false
                                : (config.footer?.socialLinks?.instagram || config.footer?.instagram)
                            )}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              const currentUrl = typeof config.footer?.socialLinks?.instagram === 'object'
                                ? (config.footer?.socialLinks?.instagram?.url || '')
                                : (config.footer?.socialLinks?.instagram || config.footer?.instagram || '');
                              setConfig(prev => ({
                                ...prev,
                                footer: {
                                  ...(prev.footer || {}),
                                  socialLinks: {
                                    ...(prev.footer?.socialLinks || {}),
                                    instagram: { enabled: checked, url: currentUrl }
                                  },
                                  instagram: checked ? currentUrl : ''
                                }
                              }));
                            }}
                          />
                          <label className="form-check-label text-2xs text-muted fw-semibold" htmlFor="switch-instagram">
                            {typeof config.footer?.socialLinks?.instagram === 'object' && config.footer?.socialLinks?.instagram?.enabled === false ? 'Oculto' : 'Visible'}
                          </label>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm rounded-3"
                        placeholder="https://instagram.com/tu_cuenta o @usuario"
                        value={
                          typeof config.footer?.socialLinks?.instagram === 'object'
                            ? (config.footer?.socialLinks?.instagram?.url || '')
                            : (config.footer?.socialLinks?.instagram || config.footer?.instagram || '')
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          setConfig(prev => {
                            const isEnabled = typeof prev.footer?.socialLinks?.instagram === 'object'
                              ? prev.footer?.socialLinks?.instagram?.enabled !== false
                              : true;
                            return {
                              ...prev,
                              footer: {
                                ...(prev.footer || {}),
                                socialLinks: {
                                  ...(prev.footer?.socialLinks || {}),
                                  instagram: { enabled: isEnabled, url: val }
                                },
                                instagram: val
                              }
                            };
                          });
                        }}
                      />
                    </div>
                  </div>

                  {/* FACEBOOK */}
                  <div className="col-12 col-md-6">
                    <div className="p-3 bg-light rounded-4 border">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <span className="btn btn-sm rounded-circle p-0 d-inline-flex align-items-center justify-content-center text-white shadow-xs" style={{ width: '28px', height: '28px', backgroundColor: '#1877f2', fontSize: '0.85rem' }}>
                            <i className="bi bi-facebook"></i>
                          </span>
                          <span className="small fw-bold text-dark">Facebook</span>
                        </div>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-facebook"
                            checked={Boolean(
                              typeof config.footer?.socialLinks?.facebook === 'object'
                                ? config.footer?.socialLinks?.facebook?.enabled !== false
                                : (config.footer?.socialLinks?.facebook || config.footer?.facebook)
                            )}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              const currentUrl = typeof config.footer?.socialLinks?.facebook === 'object'
                                ? (config.footer?.socialLinks?.facebook?.url || '')
                                : (config.footer?.socialLinks?.facebook || config.footer?.facebook || '');
                              setConfig(prev => ({
                                ...prev,
                                footer: {
                                  ...(prev.footer || {}),
                                  socialLinks: {
                                    ...(prev.footer?.socialLinks || {}),
                                    facebook: { enabled: checked, url: currentUrl }
                                  },
                                  facebook: checked ? currentUrl : ''
                                }
                              }));
                            }}
                          />
                          <label className="form-check-label text-2xs text-muted fw-semibold" htmlFor="switch-facebook">
                            {typeof config.footer?.socialLinks?.facebook === 'object' && config.footer?.socialLinks?.facebook?.enabled === false ? 'Oculto' : 'Visible'}
                          </label>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm rounded-3"
                        placeholder="https://facebook.com/tu_pagina"
                        value={
                          typeof config.footer?.socialLinks?.facebook === 'object'
                            ? (config.footer?.socialLinks?.facebook?.url || '')
                            : (config.footer?.socialLinks?.facebook || config.footer?.facebook || '')
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          setConfig(prev => {
                            const isEnabled = typeof prev.footer?.socialLinks?.facebook === 'object'
                              ? prev.footer?.socialLinks?.facebook?.enabled !== false
                              : true;
                            return {
                              ...prev,
                              footer: {
                                ...(prev.footer || {}),
                                socialLinks: {
                                  ...(prev.footer?.socialLinks || {}),
                                  facebook: { enabled: isEnabled, url: val }
                                },
                                facebook: val
                              }
                            };
                          });
                        }}
                      />
                    </div>
                  </div>

                  {/* X (TWITTER) */}
                  <div className="col-12 col-md-6">
                    <div className="p-3 bg-light rounded-4 border">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <span className="btn btn-sm rounded-circle p-0 d-inline-flex align-items-center justify-content-center text-white shadow-xs" style={{ width: '28px', height: '28px', backgroundColor: '#000000', fontSize: '0.8rem' }}>
                            <i className="bi bi-twitter-x"></i>
                          </span>
                          <span className="small fw-bold text-dark">X (Twitter)</span>
                        </div>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-x"
                            checked={Boolean(
                              typeof config.footer?.socialLinks?.x === 'object'
                                ? config.footer?.socialLinks?.x?.enabled !== false
                                : (config.footer?.socialLinks?.x || config.footer?.x || config.footer?.twitter)
                            )}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              const currentUrl = typeof config.footer?.socialLinks?.x === 'object'
                                ? (config.footer?.socialLinks?.x?.url || '')
                                : (config.footer?.socialLinks?.x || config.footer?.x || config.footer?.twitter || '');
                              setConfig(prev => ({
                                ...prev,
                                footer: {
                                  ...(prev.footer || {}),
                                  socialLinks: {
                                    ...(prev.footer?.socialLinks || {}),
                                    x: { enabled: checked, url: currentUrl }
                                  },
                                  x: checked ? currentUrl : ''
                                }
                              }));
                            }}
                          />
                          <label className="form-check-label text-2xs text-muted fw-semibold" htmlFor="switch-x">
                            {typeof config.footer?.socialLinks?.x === 'object' && config.footer?.socialLinks?.x?.enabled === false ? 'Oculto' : 'Visible'}
                          </label>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm rounded-3"
                        placeholder="https://x.com/tu_cuenta o @usuario"
                        value={
                          typeof config.footer?.socialLinks?.x === 'object'
                            ? (config.footer?.socialLinks?.x?.url || '')
                            : (config.footer?.socialLinks?.x || config.footer?.x || config.footer?.twitter || '')
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          setConfig(prev => {
                            const isEnabled = typeof prev.footer?.socialLinks?.x === 'object'
                              ? prev.footer?.socialLinks?.x?.enabled !== false
                              : true;
                            return {
                              ...prev,
                              footer: {
                                ...(prev.footer || {}),
                                socialLinks: {
                                  ...(prev.footer?.socialLinks || {}),
                                  x: { enabled: isEnabled, url: val }
                                },
                                x: val
                              }
                            };
                          });
                        }}
                      />
                    </div>
                  </div>

                  {/* LINKEDIN */}
                  <div className="col-12 col-md-6">
                    <div className="p-3 bg-light rounded-4 border">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <span className="btn btn-sm rounded-circle p-0 d-inline-flex align-items-center justify-content-center text-white shadow-xs" style={{ width: '28px', height: '28px', backgroundColor: '#0a66c2', fontSize: '0.85rem' }}>
                            <i className="bi bi-linkedin"></i>
                          </span>
                          <span className="small fw-bold text-dark">LinkedIn</span>
                        </div>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-linkedin"
                            checked={Boolean(
                              typeof config.footer?.socialLinks?.linkedin === 'object'
                                ? config.footer?.socialLinks?.linkedin?.enabled !== false
                                : (config.footer?.socialLinks?.linkedin || config.footer?.linkedin)
                            )}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              const currentUrl = typeof config.footer?.socialLinks?.linkedin === 'object'
                                ? (config.footer?.socialLinks?.linkedin?.url || '')
                                : (config.footer?.socialLinks?.linkedin || config.footer?.linkedin || '');
                              setConfig(prev => ({
                                ...prev,
                                footer: {
                                  ...(prev.footer || {}),
                                  socialLinks: {
                                    ...(prev.footer?.socialLinks || {}),
                                    linkedin: { enabled: checked, url: currentUrl }
                                  },
                                  linkedin: checked ? currentUrl : ''
                                }
                              }));
                            }}
                          />
                          <label className="form-check-label text-2xs text-muted fw-semibold" htmlFor="switch-linkedin">
                            {typeof config.footer?.socialLinks?.linkedin === 'object' && config.footer?.socialLinks?.linkedin?.enabled === false ? 'Oculto' : 'Visible'}
                          </label>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm rounded-3"
                        placeholder="https://linkedin.com/company/tu_empresa"
                        value={
                          typeof config.footer?.socialLinks?.linkedin === 'object'
                            ? (config.footer?.socialLinks?.linkedin?.url || '')
                            : (config.footer?.socialLinks?.linkedin || config.footer?.linkedin || '')
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          setConfig(prev => {
                            const isEnabled = typeof prev.footer?.socialLinks?.linkedin === 'object'
                              ? prev.footer?.socialLinks?.linkedin?.enabled !== false
                              : true;
                            return {
                              ...prev,
                              footer: {
                                ...(prev.footer || {}),
                                socialLinks: {
                                  ...(prev.footer?.socialLinks || {}),
                                  linkedin: { enabled: isEnabled, url: val }
                                },
                                linkedin: val
                              }
                            };
                          });
                        }}
                      />
                    </div>
                  </div>

                  {/* TIKTOK */}
                  <div className="col-12 col-md-6">
                    <div className="p-3 bg-light rounded-4 border">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <span className="btn btn-sm rounded-circle p-0 d-inline-flex align-items-center justify-content-center text-white shadow-xs" style={{ width: '28px', height: '28px', backgroundColor: '#000000', fontSize: '0.85rem' }}>
                            <i className="bi bi-tiktok"></i>
                          </span>
                          <span className="small fw-bold text-dark">TikTok</span>
                        </div>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-tiktok"
                            checked={Boolean(
                              typeof config.footer?.socialLinks?.tiktok === 'object'
                                ? config.footer?.socialLinks?.tiktok?.enabled !== false
                                : (config.footer?.socialLinks?.tiktok || config.footer?.tiktok)
                            )}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              const currentUrl = typeof config.footer?.socialLinks?.tiktok === 'object'
                                ? (config.footer?.socialLinks?.tiktok?.url || '')
                                : (config.footer?.socialLinks?.tiktok || config.footer?.tiktok || '');
                              setConfig(prev => ({
                                ...prev,
                                footer: {
                                  ...(prev.footer || {}),
                                  socialLinks: {
                                    ...(prev.footer?.socialLinks || {}),
                                    tiktok: { enabled: checked, url: currentUrl }
                                  },
                                  tiktok: checked ? currentUrl : ''
                                }
                              }));
                            }}
                          />
                          <label className="form-check-label text-2xs text-muted fw-semibold" htmlFor="switch-tiktok">
                            {typeof config.footer?.socialLinks?.tiktok === 'object' && config.footer?.socialLinks?.tiktok?.enabled === false ? 'Oculto' : 'Visible'}
                          </label>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm rounded-3"
                        placeholder="https://tiktok.com/@tu_cuenta o @usuario"
                        value={
                          typeof config.footer?.socialLinks?.tiktok === 'object'
                            ? (config.footer?.socialLinks?.tiktok?.url || '')
                            : (config.footer?.socialLinks?.tiktok || config.footer?.tiktok || '')
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          setConfig(prev => {
                            const isEnabled = typeof prev.footer?.socialLinks?.tiktok === 'object'
                              ? prev.footer?.socialLinks?.tiktok?.enabled !== false
                              : true;
                            return {
                              ...prev,
                              footer: {
                                ...(prev.footer || {}),
                                socialLinks: {
                                  ...(prev.footer?.socialLinks || {}),
                                  tiktok: { enabled: isEnabled, url: val }
                                },
                                tiktok: val
                              }
                            };
                          });
                        }}
                      />
                    </div>
                  </div>

                </div>
              )}
            </div>
          </div>

        </div>
      )}

      {/* PESTAÑA 8: DESCARGAS (/descargas) */}
      {activeTab === 'downloads' && (
        <div className="space-y-4">
          
          {/* Tarjeta de Configuración General de Descargas */}
          <div className="card border-0 shadow-sm rounded-4 p-4 mb-4 bg-white">
            
            {/* Cabecera de la Sección */}
            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 pb-3 border-bottom mb-4">
              <div>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span className="badge bg-primary-subtle text-primary fw-bold px-3 py-1 rounded-pill">
                    Módulo de Recursos
                  </span>
                  <span className="badge bg-light text-dark border">Ruta: /descargas</span>
                </div>
                <h5 className="fw-black text-dark mb-1">
                  <i className="bi bi-cloud-arrow-down-fill text-primary me-2"></i>
                  Configuración del Módulo de Descargas
                </h5>
                <p className="text-muted small mb-0">
                  Gestioná los textos de portada, la visibilidad del menú en la cabecera y los permisos de acceso a los archivos.
                </p>
              </div>

              <div>
                <a
                  href="/descargas"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-primary btn-sm rounded-pill px-3 py-2 fw-bold d-inline-flex align-items-center shadow-2xs"
                >
                  <i className="bi bi-box-arrow-up-right me-2 text-primary"></i>
                  <span>Ver Página /descargas</span>
                </a>
              </div>
            </div>

            {/* Fila 1: Títulos de la Página */}
            <div className="row g-3 mb-4">
              <div className="col-md-5">
                <label className="form-label small fw-bold text-secondary mb-1">
                  Título Principal de la Sección
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm fw-semibold rounded-3"
                  value={config.downloadsSection?.title || ''}
                  onChange={(e) => handleDownloadSectionChange('title', e.target.value)}
                  placeholder="Centro de Descargas y Recursos"
                />
              </div>

              <div className="col-md-7">
                <label className="form-label small fw-bold text-secondary mb-1">
                  Subtítulo / Bajada Descriptiva
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm rounded-3"
                  value={config.downloadsSection?.subtitle || ''}
                  onChange={(e) => handleDownloadSectionChange('subtitle', e.target.value)}
                  placeholder="Descargá nuestras listas de precios actualizadas, catálogos en PDF, planos y material comercial."
                />
              </div>
            </div>

            {/* Fila 2: Opciones de Menú y Política de Acceso */}
            <div className="row g-4">
              
              {/* Columna Izquierda: Opciones de Menú y Activación */}
              <div className="col-lg-6">
                <div className="border rounded-4 p-3 bg-light bg-opacity-50 h-100">
                  <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
                    <i className="bi bi-toggles text-primary fs-5 me-2"></i>
                    <span>Opciones de Navegación y Menú</span>
                  </h6>

                  <div className="d-flex flex-column gap-3">
                    {/* Switch 1: Habilitar Módulo */}
                    <div className="d-flex align-items-center justify-content-between p-3 bg-white rounded-3 border shadow-2xs">
                      <div className="pe-3">
                        <div className="fw-bold text-dark small">Habilitar Módulo de Descargas</div>
                        <div className="text-muted text-xs mt-1">Activa la página pública y las descargas en el sitio.</div>
                      </div>
                      <div className="form-check form-switch mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="downloadsEnabledSwitch"
                          checked={config.downloadsSection?.enabled ?? true}
                          onChange={(e) => handleDownloadSectionChange('enabled', e.target.checked)}
                          style={{ cursor: 'pointer', transform: 'scale(1.15)' }}
                        />
                      </div>
                    </div>

                    {/* Switch 2: Mostrar en Barra Superior */}
                    <div className="d-flex align-items-center justify-content-between p-3 bg-white rounded-3 border shadow-2xs">
                      <div className="pe-3">
                        <div className="fw-bold text-dark small">Mostrar enlace en el Menú Superior</div>
                        <div className="text-muted text-xs mt-1">Muestra el botón "DESCARGAS" en la barra de navegación.</div>
                      </div>
                      <div className="form-check form-switch mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="downloadsShowInNavbarSwitch"
                          checked={config.downloadsSection?.showInNavbar ?? true}
                          onChange={(e) => handleDownloadSectionChange('showInNavbar', e.target.checked)}
                          style={{ cursor: 'pointer', transform: 'scale(1.15)' }}
                        />
                      </div>
                    </div>

                    {/* Switch 3: Mostrar en Menú a Visitantes Anónimos */}
                    <div className="d-flex align-items-center justify-content-between p-3 bg-white rounded-3 border shadow-2xs">
                      <div className="pe-3">
                        <div className="fw-bold text-dark small">Mostrar Menú al Público en General</div>
                        <div className="text-muted text-xs mt-1">
                          {config.downloadsSection?.showInNavbarForGuests !== false
                            ? 'Visible en el menú para todos los visitantes (anónimos y logueados).'
                            : 'Oculto para anónimos: solo aparece cuando el cliente inicia sesión.'}
                        </div>
                      </div>
                      <div className="form-check form-switch mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="downloadsShowGuestsSwitch"
                          checked={config.downloadsSection?.showInNavbarForGuests ?? true}
                          onChange={(e) => handleDownloadSectionChange('showInNavbarForGuests', e.target.checked)}
                          style={{ cursor: 'pointer', transform: 'scale(1.15)' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Columna Derecha: Política de Acceso al Contenido */}
              <div className="col-lg-6">
                <div className="border rounded-4 p-3 bg-light bg-opacity-50 h-100 d-flex flex-column justify-content-between">
                  <div>
                    <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
                      <i className="bi bi-shield-lock-fill text-primary fs-5 me-2"></i>
                      <span>Acceso y Descarga de Archivos</span>
                    </h6>

                    <div className="d-flex flex-column gap-3">
                      {/* Opción 1: Público General */}
                      <div
                        className={`p-3 rounded-3 border bg-white transition-all cursor-pointer ${
                          (config.downloadsSection?.visibility || 'public') === 'public'
                            ? 'border-primary border-2 bg-primary bg-opacity-10 shadow-sm'
                            : 'opacity-75'
                        }`}
                        onClick={() => handleDownloadSectionChange('visibility', 'public')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="d-flex align-items-start gap-3">
                          <input
                            className="form-check-input mt-1 flex-shrink-0"
                            type="radio"
                            name="downloadsVisibilityRadio"
                            id="visPublic"
                            value="public"
                            checked={(config.downloadsSection?.visibility || 'public') === 'public'}
                            onChange={() => handleDownloadSectionChange('visibility', 'public')}
                            style={{ cursor: 'pointer' }}
                          />
                          <div className="flex-grow-1">
                            <label className="form-check-label fw-bold text-dark small d-flex align-items-center cursor-pointer mb-1" htmlFor="visPublic">
                              <i className="bi bi-globe text-primary me-2 fs-6"></i>
                              <span>Descarga Libre para Todo Público</span>
                            </label>
                            <span className="text-muted text-xs d-block">
                              Cualquier visitante puede ver los archivos y descargarlos sin necesidad de estar registrado.
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Opción 2: Solo Logueados */}
                      <div
                        className={`p-3 rounded-3 border bg-white transition-all cursor-pointer ${
                          config.downloadsSection?.visibility === 'authenticated'
                            ? 'border-primary border-2 bg-primary bg-opacity-10 shadow-sm'
                            : 'opacity-75'
                        }`}
                        onClick={() => handleDownloadSectionChange('visibility', 'authenticated')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="d-flex align-items-start gap-3">
                          <input
                            className="form-check-input mt-1 flex-shrink-0"
                            type="radio"
                            name="downloadsVisibilityRadio"
                            id="visAuth"
                            value="authenticated"
                            checked={config.downloadsSection?.visibility === 'authenticated'}
                            onChange={() => handleDownloadSectionChange('visibility', 'authenticated')}
                            style={{ cursor: 'pointer' }}
                          />
                          <div className="flex-grow-1">
                            <label className="form-check-label fw-bold text-dark small d-flex align-items-center cursor-pointer mb-1" htmlFor="visAuth">
                              <i className="bi bi-lock-fill text-warning me-2 fs-6"></i>
                              <span>Exclusivo para Usuarios Logueados</span>
                            </label>
                            <span className="text-muted text-xs d-block">
                              Si un visitante no tiene sesión activa, verá un aviso invitándolo a ingresar o registrarse.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="p-3 mt-3 rounded-3 bg-primary-subtle text-primary border border-primary-subtle d-flex align-items-center">
                    <i className="bi bi-lightbulb-fill me-2 fs-6 flex-shrink-0"></i>
                    <span className="text-xs">
                      Podés combinar: ocultar el menú a visitantes anónimos y exigir inicio de sesión para descargar listas de precios.
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* Gestión de Archivos y Recursos para Descargar */}
          <div className="card border-0 shadow-sm rounded-4 p-4 bg-white">
            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 pb-3 border-bottom mb-4">
              <div>
                <h5 className="fw-bold text-dark mb-1">
                  <i className="bi bi-folder2-open text-primary me-2"></i>
                  Archivos y Listas de Precios Disponibles
                </h5>
                <p className="text-muted small mb-0">
                  Agregá, ordená o subí nuevos archivos en PDF, Excel, Word, imágenes o comprimidos ZIP/RAR.
                </p>
              </div>

              <button
                type="button"
                className="btn btn-outline-primary btn-sm fw-bold rounded-pill px-3 py-2 d-inline-flex align-items-center shadow-xs"
                onClick={handleAddDownloadItem}
              >
                <i className="bi bi-plus-circle-fill me-2 fs-6"></i>
                <span>Agregar Nuevo Archivo</span>
              </button>
            </div>

            {/* Lista de Items */}
            <div className="space-y-4">
              {(!config.downloadsSection?.items || config.downloadsSection.items.length === 0) ? (
                <div className="text-center py-5 bg-light rounded-4 border border-dashed">
                  <i className="bi bi-file-earmark-arrow-down text-muted fs-1 d-block mb-2"></i>
                  <h6 className="fw-bold text-dark">No hay archivos en la sección de descargas</h6>
                  <p className="text-muted small mb-3">Comenzá agregando listas de precios o catálogos en formato PDF o Excel.</p>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm rounded-pill fw-bold px-4 py-2 d-inline-flex align-items-center"
                    onClick={handleAddDownloadItem}
                  >
                    <i className="bi bi-plus-lg me-2"></i>
                    <span>Agregar Primer Archivo</span>
                  </button>
                </div>
              ) : (
                config.downloadsSection.items.map((item, index) => (
                  <div
                    key={item.id || index}
                    className="card border rounded-4 shadow-2xs overflow-hidden mb-3 transition-all"
                    style={{ borderColor: item.is_active !== false ? '#e2e8f0' : '#f1f5f9', opacity: item.is_active !== false ? 1 : 0.75 }}
                  >
                    {/* Header del Item */}
                    <div className="card-header bg-light bg-opacity-50 border-bottom py-2 px-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        <span className="badge bg-secondary-subtle text-secondary fw-bold rounded-pill px-3 py-1">
                          #{index + 1}
                        </span>
                        <span className="badge bg-primary-subtle text-primary fw-bold text-uppercase px-3 py-1 rounded-pill">
                          {item.fileFormat || 'PDF'}
                        </span>
                        <span className="badge bg-light text-dark border fw-medium px-3 py-1 rounded-pill">
                          {item.category || 'General'}
                        </span>
                        <span className="fw-bold text-dark small text-truncate" style={{ maxWidth: '300px' }}>
                          {item.title || 'Archivo sin título'}
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={`downActive_${index}`}
                            checked={item.is_active !== false}
                            onChange={(e) => handleDownloadItemChange(index, 'is_active', e.target.checked)}
                          />
                          <label className="form-check-label small fw-bold text-muted ms-1" htmlFor={`downActive_${index}`}>
                            {item.is_active !== false ? 'Activo' : 'Oculto'}
                          </label>
                        </div>

                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm rounded-pill px-3 py-1"
                          onClick={() => handleDeleteDownloadItem(index)}
                          title="Eliminar este archivo"
                        >
                          <i className="bi bi-trash-fill"></i>
                        </button>
                      </div>
                    </div>

                    {/* Cuerpo del Item */}
                    <div className="card-body p-3 p-md-4">
                      <div className="row g-3">
                        {/* Columna Izquierda: Textos y Categoría */}
                        <div className="col-lg-7">
                          <div className="row g-3">
                            <div className="col-md-8">
                              <label className="form-label small fw-bold text-muted">Título del Documento / Lista</label>
                              <input
                                type="text"
                                className="form-control form-control-sm fw-bold"
                                value={item.title || ''}
                                onChange={(e) => handleDownloadItemChange(index, 'title', e.target.value)}
                                placeholder="Ej: Lista de Precios Mayorista - Vigente"
                              />
                            </div>

                            <div className="col-md-4">
                              <label className="form-label small fw-bold text-muted">Categoría / Grupo</label>
                              <input
                                type="text"
                                list="downloadsCategoriesList"
                                className="form-control form-control-sm"
                                value={item.category || ''}
                                onChange={(e) => handleDownloadItemChange(index, 'category', e.target.value)}
                                placeholder="Listas de Precios"
                              />
                            </div>

                            <div className="col-12">
                              <label className="form-label small fw-bold text-muted">Descripción Breve / Contenido</label>
                              <textarea
                                className="form-control form-control-sm"
                                rows="2"
                                value={item.description || ''}
                                onChange={(e) => handleDownloadItemChange(index, 'description', e.target.value)}
                                placeholder="Descripción del contenido, condiciones de compra, escalas o destinatarios..."
                              ></textarea>
                            </div>

                            <div className="col-md-6">
                              <div className="form-check form-switch pt-1">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id={`downAuthReq_${index}`}
                                  checked={Boolean(item.requiresAuth)}
                                  onChange={(e) => handleDownloadItemChange(index, 'requiresAuth', e.target.checked)}
                                />
                                <label className="form-check-label small fw-bold text-dark ms-1 d-inline-flex align-items-center" htmlFor={`downAuthReq_${index}`}>
                                  <i className="bi bi-shield-lock-fill text-warning me-2"></i>
                                  <span>Requiere Login para Descargar</span>
                                </label>
                              </div>
                              <span className="text-muted text-xs d-block ps-4">
                                Si está activado, solicita inicio de sesión para descargar este archivo en específico.
                              </span>
                            </div>

                            <div className="col-md-6">
                              <label className="form-label small fw-bold text-muted">Orden de Aparición</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={item.order ?? (index + 1)}
                                onChange={(e) => handleDownloadItemChange(index, 'order', Number(e.target.value))}
                                min="1"
                              />
                            </div>

                            <div className="col-12">
                              <label className="form-label small fw-bold text-muted mb-1">
                                Restringir a Lista de Precios Específica (Opcional)
                              </label>
                              <select
                                className="form-select form-select-sm"
                                value={item.targetPriceList || ''}
                                onChange={(e) => handleDownloadItemChange(index, 'targetPriceList', e.target.value ? Number(e.target.value) : '')}
                              >
                                <option value="">Disponible para todos (Público / Sin restricción de lista)</option>
                                {priceLists.map((pl) => (
                                  <option key={pl.n_lista} value={pl.n_lista}>
                                    Exclusivo para clientes con Lista {pl.n_lista} {pl.d_obser ? `- ${pl.d_obser}` : ''}
                                  </option>
                                ))}
                              </select>
                              <span className="text-muted text-2xs d-block mt-1">
                                Si seleccionás una lista, solo los clientes de la tienda que tengan esa lista asignada podrán ver y descargar este documento.
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Columna Derecha: Subida de Archivo y Metadatos */}
                        <div className="col-lg-5">
                          <div className="p-3 bg-light rounded-3 border h-100 d-flex flex-column justify-content-between">
                            <div>
                              <label className="form-label small fw-bold text-dark d-flex align-items-center justify-content-between mb-2">
                                <span><i className="bi bi-file-earmark-arrow-up text-primary me-2"></i> Archivo Adjunto</span>
                                {item.fileUrl && (
                                  <a
                                    href={item.fileUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="badge bg-success-subtle text-success text-decoration-none px-3 py-1 d-inline-flex align-items-center"
                                    title="Probar descarga del archivo"
                                  >
                                    <i className="bi bi-box-arrow-down me-2"></i>
                                    <span>Probar Descarga</span>
                                  </a>
                                )}
                              </label>

                              {/* Botón de Subida */}
                              <div className="d-flex align-items-center gap-2 mb-3">
                                <label className="btn btn-outline-primary btn-sm rounded-pill fw-bold px-3 py-2 d-inline-flex align-items-center cursor-pointer mb-0 shadow-2xs">
                                  <i className="bi bi-cloud-arrow-up-fill me-2 fs-6"></i>
                                  <span>Subir Archivo</span>
                                  <input
                                    type="file"
                                    className="d-none"
                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.zip,.rar,.png,.jpg,.jpeg,.webp,.svg"
                                    onChange={(e) => handleUploadDownloadFile(e, index)}
                                    disabled={uploadingImage}
                                  />
                                </label>

                                {item.fileUrl ? (
                                  <span className="text-muted small text-truncate" style={{ maxWidth: '180px' }} title={item.fileUrl}>
                                    {item.fileUrl.split('/').pop()}
                                  </span>
                                ) : (
                                  <span className="text-muted small fst-italic">Sin archivo adjunto</span>
                                )}
                              </div>

                              {/* Ruta Manual / URL Directa */}
                              <div className="mb-2">
                                <label className="form-label text-xs fw-bold text-muted mb-1">Ruta o Enlace Directo</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm font-monospace text-xs"
                                  value={item.fileUrl || ''}
                                  onChange={(e) => handleDownloadItemChange(index, 'fileUrl', e.target.value)}
                                  placeholder="/downloads/lista-de-precios.pdf o https://..."
                                />
                              </div>
                            </div>

                            {/* Metadatos: Formato, Peso y Fecha */}
                            <div className="row g-2 pt-2 border-top">
                              <div className="col-4">
                                <label className="form-label text-xs fw-bold text-muted mb-0">Formato</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm text-uppercase fw-bold text-xs"
                                  value={item.fileFormat || 'PDF'}
                                  onChange={(e) => handleDownloadItemChange(index, 'fileFormat', e.target.value.toUpperCase())}
                                  placeholder="PDF / XLSX"
                                />
                              </div>
                              <div className="col-4">
                                <label className="form-label text-xs fw-bold text-muted mb-0">Tamaño</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm text-xs"
                                  value={item.fileSize || ''}
                                  onChange={(e) => handleDownloadItemChange(index, 'fileSize', e.target.value)}
                                  placeholder="1.2 MB"
                                />
                              </div>
                              <div className="col-4">
                                <label className="form-label text-xs fw-bold text-muted mb-0">Vigencia</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm text-xs"
                                  value={item.updatedAt || ''}
                                  onChange={(e) => handleDownloadItemChange(index, 'updatedAt', e.target.value)}
                                  placeholder="Marzo 2026"
                                />
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Datalist con sugerencias de Categorías */}
          <datalist id="downloadsCategoriesList">
            <option value="Listas de Precios" />
            <option value="Catálogos PDF" />
            <option value="Planos y Fichas Técnicas" />
            <option value="Flyers y Promos" />
            <option value="Imágenes en Alta" />
            <option value="Documentación Comercial" />
            <option value="Normas y Certificaciones" />
          </datalist>

        </div>
      )}

      {/* PESTAÑA 11: PREGUNTAS FRECUENTES (/preguntas-frecuentes) */}
      {activeTab === 'faq' && (
        <FaqAdminPanel
          config={config}
          setConfig={setConfig}
          onToggleHomeSection={handleToggleHomeSection}
          isHomeSectionEnabled={currentHomeSections.find(s => s.id === 'faq')?.enabled}
          onToggleNavbarItem={handleToggleNavbarItem}
          isNavbarItemEnabled={currentNavbarItems.find(i => i.id === 'faq')?.enabled}
        />
      )}

      {/* PESTAÑA 12: COLORES, FONDOS Y ESTILOS */}
      {activeTab === 'theme' && (
        <div className="row g-4">
          <div className="col-12 col-xl-7">
            {/* SECCIÓN DE TIPOGRAFÍA PRINCIPAL */}
            <div className="card border-0 shadow-sm rounded-4 mb-4 bg-white">
              <div className="card-header bg-white py-3 px-4 border-0 d-flex align-items-center justify-content-between">
                <div>
                  <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                    <i className="bi bi-fonts text-primary"></i>
                    <span>Tipografía Principal de la Tienda y Portada</span>
                  </h5>
                  <small className="text-muted">Elegí la familia tipográfica base que vestirá todos los textos, títulos y botones.</small>
                </div>
                <span className="badge bg-primary text-white font-monospace px-3 py-2 rounded-pill">
                  {config.fontFamily || config.colors?.fontFamily || 'Inter'}
                </span>
              </div>
              <div className="card-body p-4 pt-0">
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-dark mb-1">Fuente Tipográfica Web</label>
                    <select
                      className="form-select fw-bold rounded-3 shadow-2xs"
                      value={config.fontFamily || config.colors?.fontFamily || 'Inter'}
                      onChange={(e) => {
                        const font = e.target.value;
                        setConfig(prev => ({
                          ...prev,
                          fontFamily: font,
                          colors: { ...(prev.colors || {}), fontFamily: font }
                        }));
                      }}
                    >
                      {AVAILABLE_FONTS.map(f => (
                        <option key={f.id} value={f.id}>{f.name}</option>
                      ))}
                    </select>
                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.74rem' }}>
                      Cargada automáticamente desde Google Fonts en alta resolución.
                    </small>
                  </div>

                  {/* Previsualización en Tiempo Real */}
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-bold text-muted mb-1">Muestra en Vivo</label>
                    <div 
                      className="p-3 rounded-3 border bg-light shadow-2xs"
                      style={{ 
                        fontFamily: getFontFamilyCss(config.fontFamily || config.colors?.fontFamily || 'Inter') 
                      }}
                    >
                      <h6 className="fw-bold text-dark mb-1">Tipografía: {config.fontFamily || config.colors?.fontFamily || 'Inter'}</h6>
                      <p className="small text-secondary mb-1">
                        El veloz murciélago hindú comía feliz cardillo y kiwi. 1234567890
                      </p>
                      <span className="badge bg-primary text-white rounded-pill px-3 py-1 small">Muestra Botón</span>
                    </div>
                  </div>
                </div>

                {/* Ajustes Globales de Tamaños de Letra (Títulos, Subtítulos, Descripciones) */}
                <div className="row g-3 pt-3 mt-1 border-top">
                  <div className="col-12">
                    <h6 className="fw-bold text-dark mb-1 d-flex align-items-center gap-2">
                      <i className="bi bi-type text-primary"></i>
                      <span>Escala y Tamaños de Letra Predeterminados</span>
                    </h6>
                    <small className="text-muted">Definí el tamaño base con el que se mostrarán los títulos, subtítulos y descripciones en todo el sitio:</small>
                  </div>

                  <div className="col-12 col-md-4">
                    <label className="form-label small fw-bold text-dark mb-1">
                      <i className="bi bi-type-h1 me-1 text-primary"></i> Títulos de Secciones
                    </label>
                    <select
                      className="form-select form-select-sm fw-bold rounded-3"
                      value={config.titleFontSize || config.colors?.titleFontSize || 'medium'}
                      onChange={(e) => {
                        const val = e.target.value;
                        setConfig(prev => ({
                          ...prev,
                          titleFontSize: val,
                          colors: { ...(prev.colors || {}), titleFontSize: val }
                        }));
                      }}
                    >
                      <option value="small">Chico (1.35rem)</option>
                      <option value="medium">Mediano / Normal (1.75rem)</option>
                      <option value="large">Grande (2.25rem)</option>
                      <option value="xlarge">Extra Grande (2.85rem)</option>
                    </select>
                  </div>

                  <div className="col-12 col-md-4">
                    <label className="form-label small fw-bold text-dark mb-1">
                      <i className="bi bi-type-h2 me-1 text-primary"></i> Subtítulos y Bajadas
                    </label>
                    <select
                      className="form-select form-select-sm fw-bold rounded-3"
                      value={config.subtitleFontSize || config.colors?.subtitleFontSize || 'medium'}
                      onChange={(e) => {
                        const val = e.target.value;
                        setConfig(prev => ({
                          ...prev,
                          subtitleFontSize: val,
                          colors: { ...(prev.colors || {}), subtitleFontSize: val }
                        }));
                      }}
                    >
                      <option value="small">Chico (0.85rem)</option>
                      <option value="medium">Mediano / Normal (1rem)</option>
                      <option value="large">Grande (1.18rem)</option>
                    </select>
                  </div>

                  <div className="col-12 col-md-4">
                    <label className="form-label small fw-bold text-dark mb-1">
                      <i className="bi bi-text-paragraph me-1 text-primary"></i> Textos y Descripciones
                    </label>
                    <select
                      className="form-select form-select-sm fw-bold rounded-3"
                      value={config.descriptionFontSize || config.colors?.descriptionFontSize || 'medium'}
                      onChange={(e) => {
                        const val = e.target.value;
                        setConfig(prev => ({
                          ...prev,
                          descriptionFontSize: val,
                          colors: { ...(prev.colors || {}), descriptionFontSize: val }
                        }));
                      }}
                    >
                      <option value="small">Chico (0.82rem)</option>
                      <option value="medium">Mediano / Normal (0.92rem)</option>
                      <option value="large">Grande (1.05rem)</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Presets Rápidos */}
            <div className="card border-0 shadow-sm rounded-4 mb-4 bg-white">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
                  <div>
                    <h5 className="fw-bold text-dark mb-1">Paletas de Colores Sugeridas</h5>
                    <p className="text-muted small mb-0">Hacé clic en cualquiera para aplicar un esquema armónico integral en todo el sitio:</p>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary rounded-pill px-3"
                    onClick={() => handleApplyPreset(COLOR_PRESETS[0])}
                  >
                    <i className="bi bi-arrow-counterclockwise me-1"></i> Original
                  </button>
                </div>
                <div className="d-flex flex-wrap gap-2 pt-2">
                  {COLOR_PRESETS.map((preset, idx) => (
                    <button
                      key={idx}
                      type="button"
                      className="btn btn-outline-secondary rounded-pill px-3 py-2 d-flex align-items-center gap-2 text-start shadow-xs hover-shadow transition-all"
                      onClick={() => handleApplyPreset(preset)}
                    >
                      <div className="d-flex align-items-center gap-1">
                        <span className="rounded-circle d-inline-block border" style={{ width: '13px', height: '13px', backgroundColor: preset.primaryColor }} title="Primario"></span>
                        <span className="rounded-circle d-inline-block border" style={{ width: '13px', height: '13px', backgroundColor: preset.buttonColor }} title="Botón"></span>
                        <span className="rounded-circle d-inline-block border" style={{ width: '13px', height: '13px', backgroundColor: preset.pageBg }} title="Fondo"></span>
                        <span className="rounded-circle d-inline-block border" style={{ width: '13px', height: '13px', backgroundColor: preset.footerBg }} title="Footer"></span>
                      </div>
                      <span className="small fw-semibold">{preset.name}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* SECCIÓN 1: COLORES PRINCIPALES DE MARCA */}
            <div className="card border-0 shadow-sm rounded-4 bg-white mb-4">
              <div className="card-header bg-white py-3 px-4 border-0">
                <h5 className="fw-bold text-dark mb-0">1. Colores Principales de Marca e Identidad</h5>
                <small className="text-muted">Tonos principales para títulos, enlaces, acentos y textos generales.</small>
              </div>
              <div className="card-body p-4 pt-0">
                <div className="row g-3">
                  {/* Color Primario */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Color Primario (Títulos, Enlaces, Badges)
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.primaryColor || '#0d6efd'}
                        onChange={(e) => handleColorChange('primaryColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.primaryColor || '#0d6efd'}
                        onChange={(e) => handleColorChange('primaryColor', e.target.value)}
                        placeholder="#0d6efd"
                      />
                    </div>
                  </div>

                  {/* Color Secundario */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Color Secundario / Hover
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.secondaryColor || '#0a58ca'}
                        onChange={(e) => handleColorChange('secondaryColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.secondaryColor || '#0a58ca'}
                        onChange={(e) => handleColorChange('secondaryColor', e.target.value)}
                        placeholder="#0a58ca"
                      />
                    </div>
                  </div>

                  {/* Color de Acentos / Ofertas */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Color de Acentos & Ofertas (Badges promocionales)
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.accentColor || '#ff6b35'}
                        onChange={(e) => handleColorChange('accentColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.accentColor || '#ff6b35'}
                        onChange={(e) => handleColorChange('accentColor', e.target.value)}
                        placeholder="#ff6b35"
                      />
                    </div>
                  </div>

                  {/* Color de Textos Generales */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Color de Textos Principales
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.textColor || '#1e293b'}
                        onChange={(e) => handleColorChange('textColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.textColor || '#1e293b'}
                        onChange={(e) => handleColorChange('textColor', e.target.value)}
                        placeholder="#1e293b"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* SECCIÓN 2: FONDOS, TARJETAS Y BORDES */}
            <div className="card border-0 shadow-sm rounded-4 bg-white mb-4">
              <div className="card-header bg-white py-3 px-4 border-0">
                <h5 className="fw-bold text-dark mb-0">2. Fondos, Tarjetas y Bordes de la Web</h5>
                <small className="text-muted">Ajustá el fondo general de la página, tarjetas y bordes perimetrales.</small>
              </div>
              <div className="card-body p-4 pt-0">
                <div className="row g-3">
                  {/* Fondo General de la Página */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Fondo General de la Web (Páginas y Catálogo)
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.pageBg || '#f8fafc'}
                        onChange={(e) => handleColorChange('pageBg', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.pageBg || '#f8fafc'}
                        onChange={(e) => handleColorChange('pageBg', e.target.value)}
                        placeholder="#f8fafc"
                      />
                    </div>
                  </div>

                  {/* Fondo de Tarjetas */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Fondo de Tarjetas y Módulos
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.cardBg || '#ffffff'}
                        onChange={(e) => handleColorChange('cardBg', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.cardBg || '#ffffff'}
                        onChange={(e) => handleColorChange('cardBg', e.target.value)}
                        placeholder="#ffffff"
                      />
                    </div>
                  </div>

                  {/* Color de Bordes */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Color de Bordes y Divisores
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.borderColor || '#e2e8f0'}
                        onChange={(e) => handleColorChange('borderColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.borderColor || '#e2e8f0'}
                        onChange={(e) => handleColorChange('borderColor', e.target.value)}
                        placeholder="#e2e8f0"
                      />
                    </div>
                  </div>

                  {/* Curvatura de Bordes (Border Radius) */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Curvatura de Bordes (Bordes Redondeados)
                    </label>
                    <select
                      className="form-select"
                      value={config.colors?.borderRadius || '12px'}
                      onChange={(e) => handleColorChange('borderRadius', e.target.value)}
                    >
                      <option value="0px">Rectos (0px)</option>
                      <option value="6px">Suave (6px)</option>
                      <option value="10px">Medio (10px)</option>
                      <option value="12px">Estándar Moderno (12px)</option>
                      <option value="16px">Redondeado Elegante (16px)</option>
                      <option value="22px">Extra Redondeado (22px)</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* SECCIÓN 3: BOTONES Y LLAMADOS A LA ACCIÓN */}
            <div className="card border-0 shadow-sm rounded-4 bg-white mb-4">
              <div className="card-header bg-white py-3 px-4 border-0">
                <h5 className="fw-bold text-dark mb-0">3. Botones y Llamados a la Acción</h5>
                <small className="text-muted">Definí el estilo de los botones primarios y secundarios de toda la web.</small>
              </div>
              <div className="card-body p-4 pt-0">
                <div className="row g-3">
                  {/* Fondo Botón Primario */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Fondo Botón Primario (Comprar / CTA)
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.buttonColor || '#ffc107'}
                        onChange={(e) => handleColorChange('buttonColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.buttonColor || '#ffc107'}
                        onChange={(e) => handleColorChange('buttonColor', e.target.value)}
                        placeholder="#ffc107"
                      />
                    </div>
                  </div>

                  {/* Texto Botón Primario */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Texto Botón Primario
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.buttonPrimaryText || '#111827'}
                        onChange={(e) => handleColorChange('buttonPrimaryText', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.buttonPrimaryText || '#111827'}
                        onChange={(e) => handleColorChange('buttonPrimaryText', e.target.value)}
                        placeholder="#111827"
                      />
                    </div>
                  </div>

                  {/* Fondo Botón Secundario */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Fondo Botón Secundario
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.buttonSecondaryBg || '#f8fafc'}
                        onChange={(e) => handleColorChange('buttonSecondaryBg', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.buttonSecondaryBg || '#f8fafc'}
                        onChange={(e) => handleColorChange('buttonSecondaryBg', e.target.value)}
                        placeholder="#f8fafc"
                      />
                    </div>
                  </div>

                  {/* Texto Botón Secundario */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Texto Botón Secundario
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.buttonSecondaryText || '#1e293b'}
                        onChange={(e) => handleColorChange('buttonSecondaryText', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.buttonSecondaryText || '#1e293b'}
                        onChange={(e) => handleColorChange('buttonSecondaryText', e.target.value)}
                        placeholder="#1e293b"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* SECCIÓN 4: CABECERA (HEADER Y TOPBAR) */}
            <div className="card border-0 shadow-sm rounded-4 bg-white mb-4">
              <div className="card-header bg-white py-3 px-4 border-0">
                <h5 className="fw-bold text-dark mb-0">4. Cabecera (Header y Barra Superior)</h5>
                <small className="text-muted">Ajustá la barra de avisos superior y el menú de navegación principal.</small>
              </div>
              <div className="card-body p-4 pt-0">
                <div className="row g-3">
                  {/* TopBar Fondo */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Fondo Barra Superior (TopBar)
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.topBarBg || '#0f172a'}
                        onChange={(e) => handleColorChange('topBarBg', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.topBarBg || '#0f172a'}
                        onChange={(e) => handleColorChange('topBarBg', e.target.value)}
                        placeholder="#0f172a"
                      />
                    </div>
                  </div>

                  {/* TopBar Texto */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Texto Barra Superior (TopBar)
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.topBarText || '#ffffff'}
                        onChange={(e) => handleColorChange('topBarText', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.topBarText || '#ffffff'}
                        onChange={(e) => handleColorChange('topBarText', e.target.value)}
                        placeholder="#ffffff"
                      />
                    </div>
                  </div>

                  {/* Navbar Fondo */}
                  <div className="col-12 col-md-4">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Fondo del Menú (Navbar)
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.navbarBg || '#ffffff'}
                        onChange={(e) => handleColorChange('navbarBg', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.navbarBg || '#ffffff'}
                        onChange={(e) => handleColorChange('navbarBg', e.target.value)}
                        placeholder="#ffffff"
                      />
                    </div>
                  </div>

                  {/* Navbar Texto de Enlaces */}
                  <div className="col-12 col-md-4">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Texto de Enlaces del Menú
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.headerText || '#1e293b'}
                        onChange={(e) => handleColorChange('headerText', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.headerText || '#1e293b'}
                        onChange={(e) => handleColorChange('headerText', e.target.value)}
                        placeholder="#1e293b"
                      />
                    </div>
                  </div>

                  {/* Borde inferior del Navbar */}
                  <div className="col-12 col-md-4">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Borde Inferior del Menú
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.headerBorder || '#e2e8f0'}
                        onChange={(e) => handleColorChange('headerBorder', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.headerBorder || '#e2e8f0'}
                        onChange={(e) => handleColorChange('headerBorder', e.target.value)}
                        placeholder="#e2e8f0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* SECCIÓN 5: PIE DE PÁGINA (FOOTER) */}
            <div className="card border-0 shadow-sm rounded-4 bg-white mb-4">
              <div className="card-header bg-white py-3 px-4 border-0">
                <h5 className="fw-bold text-dark mb-0">5. Pie de Página (Footer)</h5>
                <small className="text-muted">Colores para el fondo, títulos, textos y bordes del pie de página.</small>
              </div>
              <div className="card-body p-4 pt-0">
                <div className="row g-3">
                  {/* Fondo Footer */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Fondo del Pie de Página
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.footerBg || '#1e293b'}
                        onChange={(e) => handleColorChange('footerBg', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.footerBg || '#1e293b'}
                        onChange={(e) => handleColorChange('footerBg', e.target.value)}
                        placeholder="#1e293b"
                      />
                    </div>
                  </div>

                  {/* Títulos Footer */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Color de Títulos del Footer
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.footerTitleColor || '#ffffff'}
                        onChange={(e) => handleColorChange('footerTitleColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.footerTitleColor || '#ffffff'}
                        onChange={(e) => handleColorChange('footerTitleColor', e.target.value)}
                        placeholder="#ffffff"
                      />
                    </div>
                  </div>

                  {/* Textos y Links Footer */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Color de Textos y Enlaces del Footer
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.footerTextColor || '#94a3b8'}
                        onChange={(e) => handleColorChange('footerTextColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.footerTextColor || '#94a3b8'}
                        onChange={(e) => handleColorChange('footerTextColor', e.target.value)}
                        placeholder="#94a3b8"
                      />
                    </div>
                  </div>

                  {/* Borde Superior Footer */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small text-dark mb-1">
                      Borde Superior del Footer
                    </label>
                    <div className="input-group">
                      <input
                        type="color"
                        className="form-control form-control-color border-0 p-1 rounded-start-3 cursor-pointer"
                        value={config.colors?.footerBorderColor || '#334155'}
                        onChange={(e) => handleColorChange('footerBorderColor', e.target.value)}
                        style={{ width: '48px', height: '38px' }}
                      />
                      <input
                        type="text"
                        className="form-control font-monospace"
                        value={config.colors?.footerBorderColor || '#334155'}
                        onChange={(e) => handleColorChange('footerBorderColor', e.target.value)}
                        placeholder="#334155"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* VISTA PREVIA INTERACTIVA EN TIEMPO REAL */}
          <div className="col-12 col-xl-5">
            <div className="card border-0 shadow-sm rounded-4 bg-white sticky-top" style={{ top: '90px', zIndex: 10 }}>
              <div className="card-header bg-white py-3 px-4 border-0 d-flex align-items-center justify-content-between">
                <div>
                  <h5 className="fw-bold text-dark mb-0">
                    <i className="bi bi-eye-fill text-primary me-2"></i>
                    Vista Previa en Vivo
                  </h5>
                  <small className="text-muted">Así se verá tu sitio web con los estilos aplicados:</small>
                </div>
                <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill px-3 py-1 small">
                  ● En Vivo
                </span>
              </div>
              <div className="card-body p-4 bg-light rounded-bottom-4">
                
                {/* MOCKUP COMPLETO DE LA WEB */}
                <div 
                  className="rounded-4 border shadow-sm overflow-hidden"
                  style={{
                    backgroundColor: config.colors?.pageBg || '#f8fafc',
                    borderColor: config.colors?.borderColor || '#e2e8f0',
                    color: config.colors?.textColor || '#1e293b'
                  }}
                >
                  {/* 1. Mini TopBar */}
                  <div
                    className="px-3 py-2 d-flex align-items-center justify-content-between text-xs"
                    style={{
                      backgroundColor: config.colors?.topBarBg || '#0f172a',
                      color: config.colors?.topBarText || '#ffffff',
                      fontSize: '0.68rem'
                    }}
                  >
                    <span>🚀 ¡Envíos a Todo el País!</span>
                    <span>(011) 4247-6622</span>
                  </div>

                  {/* 2. Mini Navbar */}
                  <div
                    className="px-3 py-2 d-flex align-items-center justify-content-between border-bottom"
                    style={{
                      backgroundColor: config.colors?.navbarBg || '#ffffff',
                      color: config.colors?.headerText || '#1e293b',
                      borderColor: config.colors?.headerBorder || '#e2e8f0'
                    }}
                  >
                    <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                      <span className="badge rounded-circle p-1 d-flex align-items-center justify-content-center" style={{ backgroundColor: config.colors?.primaryColor || '#0d6efd', color: '#ffffff', width: '22px', height: '22px' }}>
                        <i className="bi bi-building" style={{ fontSize: '0.7rem' }}></i>
                      </span>
                      <span className="fw-bold" style={{ fontSize: '0.8rem', color: config.colors?.primaryColor || '#0d6efd' }}>
                        {config.logoText || 'HIPERPEL'}
                      </span>
                    </div>

                    <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px', fontSize: '0.68rem' }}>
                      <span className="px-2 py-1 rounded-pill fw-bold" style={{ backgroundColor: `${config.colors?.primaryColor || '#0d6efd'}18`, color: config.colors?.primaryColor || '#0d6efd' }}>
                        Inicio
                      </span>
                      <span className="px-2 py-1" style={{ color: config.colors?.headerText || '#1e293b' }}>
                        Tienda
                      </span>
                      <span className="px-2 py-1" style={{ color: config.colors?.headerText || '#1e293b' }}>
                        Novedades
                      </span>
                      <span className="px-2 py-1" style={{ color: config.colors?.headerText || '#1e293b' }}>
                        Empresa
                      </span>
                    </div>
                  </div>

                  {/* 3. Mini Body Content & Tarjetas */}
                  <div className="p-3">
                    
                    {/* Mini Hero Banner */}
                    <div 
                      className="p-3 mb-3 text-white d-flex flex-column justify-content-center shadow-xs"
                      style={{
                        background: `linear-gradient(135deg, ${config.colors?.primaryColor || '#0d6efd'} 0%, ${config.colors?.secondaryColor || '#0a58ca'} 100%)`,
                        borderRadius: config.colors?.borderRadius || '12px'
                      }}
                    >
                      <span className="badge rounded-pill align-self-start mb-1 text-xs" style={{ backgroundColor: config.colors?.accentColor || '#ff6b35', fontSize: '0.62rem' }}>
                        FABRICANTES DIRECTOS
                      </span>
                      <div className="fw-bold text-xs" style={{ fontSize: '0.85rem' }}>Soluciones Integrales en Embalajes</div>
                      <p className="mb-0 opacity-85" style={{ fontSize: '0.65rem' }}>Venta mayorista y minorista con precios de fábrica.</p>
                    </div>

                    {/* Mini Grid de Tarjetas */}
                    <div className="row g-2.5">
                      {/* Tarjeta 1 */}
                      <div className="col-6">
                        <div
                          className="p-3 shadow-xs border h-100 d-flex flex-column justify-content-between"
                          style={{
                            backgroundColor: config.colors?.cardBg || '#ffffff',
                            borderColor: config.colors?.borderColor || '#e2e8f0',
                            borderRadius: config.colors?.borderRadius || '12px'
                          }}
                        >
                          <div>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="badge px-2 py-1" style={{ backgroundColor: config.colors?.accentColor || '#ff6b35', color: '#fff', fontSize: '0.58rem' }}>
                                PROMO
                              </span>
                              <span className="text-muted" style={{ fontSize: '0.58rem' }}>ART-1049</span>
                            </div>
                            <div className="text-center py-2">
                              <i className="bi bi-box-seam text-secondary opacity-50 fs-4"></i>
                            </div>
                            <div className="fw-bold text-truncate" style={{ fontSize: '0.74rem', color: config.colors?.textColor || '#1e293b' }}>
                              Bolsa Kraft 20x30
                            </div>
                            <div className="fw-extrabold mt-1 mb-2" style={{ color: config.colors?.primaryColor || '#0d6efd', fontSize: '0.82rem' }}>
                              $ 6.450,00
                            </div>
                          </div>
                          <div className="pt-1">
                            <button
                              className="btn btn-sm w-100 rounded-pill fw-bold shadow-xs"
                              style={{
                                backgroundColor: config.colors?.buttonColor || '#ffc107',
                                color: config.colors?.buttonPrimaryText || '#111827',
                                border: 'none',
                                fontSize: '0.68rem',
                                padding: '6px 10px'
                              }}
                            >
                              <i className="bi bi-cart-plus me-1"></i> Comprar
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Tarjeta 2 */}
                      <div className="col-6">
                        <div
                          className="p-3 shadow-xs border h-100 d-flex flex-column justify-content-between"
                          style={{
                            backgroundColor: config.colors?.cardBg || '#ffffff',
                            borderColor: config.colors?.borderColor || '#e2e8f0',
                            borderRadius: config.colors?.borderRadius || '12px'
                          }}
                        >
                          <div>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="badge px-2 py-1" style={{ backgroundColor: config.colors?.primaryColor || '#0d6efd', color: '#fff', fontSize: '0.58rem' }}>
                                NOVEDAD
                              </span>
                              <span className="text-muted" style={{ fontSize: '0.58rem' }}>ART-2014</span>
                            </div>
                            <div className="text-center py-2">
                              <i className="bi bi-archive text-secondary opacity-50 fs-4"></i>
                            </div>
                            <div className="fw-bold text-truncate" style={{ fontSize: '0.74rem', color: config.colors?.textColor || '#1e293b' }}>
                              Caja Pizza Corrugado
                            </div>
                            <div className="fw-extrabold mt-1 mb-2" style={{ color: config.colors?.primaryColor || '#0d6efd', fontSize: '0.82rem' }}>
                              $ 12.800,00
                            </div>
                          </div>
                          <div className="pt-1">
                            <button
                              className="btn btn-sm w-100 rounded-pill fw-bold shadow-xs border"
                              style={{
                                backgroundColor: config.colors?.buttonSecondaryBg || '#f8fafc',
                                color: config.colors?.buttonSecondaryText || '#1e293b',
                                borderColor: config.colors?.borderColor || '#e2e8f0',
                                fontSize: '0.68rem',
                                padding: '6px 10px'
                              }}
                            >
                              <i className="bi bi-eye me-1"></i> Ver Detalle
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 4. Mini Footer */}
                  <div
                    className="p-3 border-top"
                    style={{
                      backgroundColor: config.colors?.footerBg || '#1e293b',
                      borderColor: config.colors?.footerBorderColor || '#334155',
                      color: config.colors?.footerTextColor || '#94a3b8',
                      fontSize: '0.68rem'
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="fw-bold" style={{ color: config.colors?.footerTitleColor || '#ffffff', fontSize: '0.75rem' }}>
                        HIPERPEL S.A.
                      </span>
                      <span style={{ color: config.colors?.footerTextColor || '#94a3b8' }}>
                        ventas@hiperpel.com.ar
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center opacity-75" style={{ fontSize: '0.6rem' }}>
                      <span>© 2026 Todos los derechos reservados.</span>
                      <span>Plataforma SIGECOM</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Botón flotante permanente para Guardar Cambios */}
      <div
        className="position-fixed d-flex align-items-center gap-2"
        style={{
          bottom: '28px',
          right: '32px',
          zIndex: 1060
        }}
      >
        <button
          type="button"
          className="btn btn-primary btn-lg rounded-pill px-4 py-3 shadow-lg d-flex align-items-center gap-2 fw-bold text-white border-2 border-white"
          onClick={handleSave}
          disabled={saving || uploadingImage}
          style={{
            boxShadow: '0 8px 25px rgba(13, 110, 253, 0.45)',
            transition: 'all 0.2s ease-in-out',
            fontSize: '1.05rem',
            cursor: saving || uploadingImage ? 'not-allowed' : 'pointer'
          }}
          onMouseEnter={(e) => {
            if (!saving && !uploadingImage) {
              e.currentTarget.style.transform = 'translateY(-2px) scale(1.03)';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0px) scale(1)';
          }}
          title="Guardar todos los cambios realizados en la configuración web"
        >
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span>Guardando Cambios...</span>
            </>
          ) : (
            <>
              <i className="bi bi-cloud-check-fill fs-5"></i>
              <span>Guardar Cambios</span>
            </>
          )}
        </button>
      </div>

      {/* Modal de Detalle de Producto Preview */}
      {previewProduct && (
        <EcommerceProductDetail
          show={Boolean(previewProduct)}
          onHide={() => setPreviewProduct(null)}
          product={previewProduct}
          canSeePrice={true}
          price={Number(previewProduct?.i_preant || previewProduct?.i_conta || previewProduct?.i_lista || 0)}
          regularPrice={Number(previewProduct?.i_conta || previewProduct?.i_lista || 0)}
          onAddToCart={() => {
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'info',
              title: 'Modo Administrador: Vista previa de detalle de producto',
              showConfirmButton: false,
              timer: 2000
            });
          }}
        />
      )}

    </div>
  );
};

export default LandingAdminSettings;
